/**
 * Copyright (c) 2016 SendBird DBA (Smile Family, Inc.)
 * SendBird JavaScript SDK v3.0.85
 */
!function (e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? exports.SendBird = n() : e.SendBird = n();
}("undefined" != typeof self ? self : this, function () {
  function e() {
    this.oldIE = !0, this.boundary = "--------FormData" + Math.random(), this._fields = [];
  }

  function n(e) {
    var n = this,
        t = [];
    n.onChangeHandler = function (e, n, t) {}, Object.defineProperty(n, "push", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: function value(e) {
        var r = JSON.parse(JSON.stringify(t));
        return t.push(e), v(r, t) || n.onChangeHandler(t, r, {
          added: e
        }), t;
      }
    }), Object.defineProperty(n, "pop", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: function value() {
        var e = JSON.parse(JSON.stringify(t)),
            r = t.pop();
        return v(e, t) || n.onChangeHandler(t, e, {
          removed: r
        }), r;
      }
    }), Object.defineProperty(n, "shift", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: function value() {
        var e = JSON.parse(JSON.stringify(t)),
            r = t.shift();
        return v(e, t) || n.onChangeHandler(t, e, {
          removed: r
        }), r;
      }
    }), Object.defineProperty(n, "splice", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: function value(e, r) {
        var i = JSON.parse(JSON.stringify(t)),
            a = t.splice(e, r);
        return v(i, t) || n.onChangeHandler(t, i, {
          removed: a
        }), a;
      }
    }), Object.defineProperty(n, "length", {
      configurable: !1,
      enumerable: !1,
      get: function get() {
        return t.length;
      }
    }), Object.defineProperty(n, "items", {
      configurable: !1,
      enumerable: !1,
      get: function get() {
        return t;
      }
    }), Object.defineProperty(n, "update", {
      configurable: !1,
      enumerable: !1,
      value: function value(e, r) {
        var i = JSON.parse(JSON.stringify(t));
        return t[e] = r, v(i, t) || n.onChangeHandler(t, i, {
          updated: r
        }), t;
      }
    }), Object.defineProperty(n, "searchIndexByKeyValue", {
      configurable: !1,
      enumerable: !1,
      value: function value(e, n) {
        for (var r = -1, i = t.length, a = 0; a < i; a++) {
          var s = t[a];

          if (s.hasOwnProperty(e) && s[e] === n) {
            r = a;
            break;
          }
        }

        return r;
      }
    });

    var r = function r(e, n, t) {
      if (!(n >= t)) {
        for (var i = e[t].seq, a = n, s = n; s <= t; s++) {
          if (e[s].seq <= i) {
            var o = e[a];
            e[a] = e[s], e[s] = o, a++;
          }
        }

        r(e, n, a - 2), r(e, a, t);
      }
    };

    Object.defineProperty(n, "insert", {
      configurable: !1,
      enumerable: !1,
      value: function value(e, i) {
        var a = JSON.parse(JSON.stringify(t));
        return t.splice(e, 0, i), r(t, 0, t.length - 1), v(a, t) || n.onChangeHandler(t, a, {
          added: i
        }), t;
      }
    }), Object.getOwnPropertyNames(Array.prototype).forEach(function (e) {
      e in n || Object.defineProperty(n, e, {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Array.prototype[e]
      });
    }), e instanceof Array && e.length > 0 && n.push.apply(n, e);
  }

  var t,
      r = !1,
      i = "wss://ws.sendbird.com",
      a = "https://api.sendbird.com",
      s = 1e3,
      o = 9e3;

  try {
    t = window.console || {
      log: function log() {}
    };
  } catch (e) {
    t = {
      log: function log() {}
    };
  }

  var l = "undefined";

  try {
    l = navigator.userAgent.replace(/,/g, ".");
  } catch (e) {
    l = "undefined";
  }

  var u,
      c = "JS," + l + ",3.0.85,",
      d = function () {
    try {
      if (document && 9 === document.documentMode) return !0;
    } catch (e) {
      return !1;
    }

    return !1;
  }(),
      h = function () {
    try {
      if (document && document.documentMode <= 8) return !0;
    } catch (e) {
      return !1;
    }

    return !1;
  }();

  if (d || h) "function" != typeof String.prototype.trim && (String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, "");
  }), "function" != typeof Array.prototype.forEach && (Array.prototype.forEach = function (e) {
    for (var n = 0; n < this.length; n++) {
      e.apply(this, [this[n], n, this]);
    }
  }), e.prototype.append = function (e, n) {
    this._fields.push([e, n]);
  }, e.prototype.toString = function () {
    var e = this.boundary,
        n = "";
    return this._fields.forEach(function (t) {
      if (n += "--" + e + "\r\n", t[1].name) {
        var r = t[1];
        n += 'Content-Disposition: form-data; name="' + t[0] + '"; filename="' + r.name + '"\r\n', n += "Content-Transfer-Encoding: base64\r\n", n += "Content-Type: " + r.type + "\r\n\r\n", n += r.base64 + "\r\n";
      } else n += 'Content-Disposition: form-data; name="' + t[0] + '";\r\n\r\n', n += t[1] + "\r\n";
    }), n += "--" + e + "--";
  }, u = e;else if ("undefined" == typeof window && "undefined" == typeof FormData) try {
    u = null;
  } catch (e) {}

  var p = function p(e, n, t) {
    if (t && "function" == typeof t) if (e) {
      var r = null,
          i = null;

      try {
        i = JSON.parse(e.response);
        var a = i ? i.message : "Request failed.",
            s = i ? i.code : 800220;
        r = new g(a, s);
      } catch (n) {
        r = e instanceof g ? e : new g("Request failed.", 800220);
      }

      t(n, r);
    } else t(n, null);
  },
      f = function f(e) {
    for (var n in e) {
      if (e.hasOwnProperty(n)) return !1;
    }

    return Array.isArray(e) ? JSON.stringify(e) === JSON.stringify([]) : JSON.stringify(e) === JSON.stringify({});
  },
      _ = function _(e) {
    try {
      if ("number" == typeof e) return !0;

      if ("string" == typeof e) {
        return /^\d+$/.test(e);
      }
    } catch (e) {
      return r && t.error(e), !1;
    }
  },
      I = function () {
    var e = function e() {};

    return function (n, t) {
      e.prototype = new n(), t.prototype = new e(), t["super"] = n.prototype, t.prototype.constructor = t;
    };
  }(),
      g = function g(e, n) {
    return this.name = "SendBirdException", this.code = n || 0, this.message = e, this;
  };

  I(Error, g);

  var m = {
    MessageTypeFilter: {
      ALL: 0,
      USER: 1,
      FILE: 2,
      ADMIN: 3
    }
  },
      E = function E(e) {
    return Object.keys(e).forEach(function (n) {
      null !== e[n] && "undefined" != typeof e[n] && "object" == typeof e[n] && (e[n] = E(e[n]));
    }), Object.freeze(e);
  },
      A = function A(e) {
    return JSON.parse(JSON.stringify(e));
  },
      y = function y(e, n, t) {
    try {
      "number" == typeof n && n >= 0 && ("all" === e.myCountPreference || "unread_message_count_only" === e.myCountPreference ? e.isSuper ? e.unreadMessageCount = n >= 1 ? 1 : 0 : e.unreadMessageCount = n : e.unreadMessageCount = 0), "number" == typeof t && t >= 0 && ("all" === e.myCountPreference || "unread_mention_count_only" === e.myCountPreference ? e.unreadMentionCount = t : e.unreadMentionCount = 0);
    } catch (e) {}
  },
      v = function v(e, n) {
    var i = !1;

    try {
      var a = !0;

      if (e && "object" == typeof e && n && "object" == typeof n) {
        var s = Object.keys(e),
            o = Object.keys(n);

        if (s.indexOf("reqId") > -1 && s.indexOf("messageId") > -1 && o.indexOf("reqId") > -1 && o.indexOf("messageId") > -1) {
          var l = s.reqId;
          s.splice(s.indexOf("reqId"), 1);
          var u = s.messageId;
          s.splice(s.indexOf("messageId"), 1);
          var c = o.reqId;
          o.splice(o.indexOf("reqId"), 1);
          var d = o.messageId;
          o.splice(o.indexOf("messageId"), 1), a = 0 !== u && 0 !== d && u === d || (0 === u || 0 === d) && 0 !== l && 0 !== c && l === c;
        }

        if (s.length === o.length) {
          i = s.map(function (t) {
            return v(e[t], n[t]);
          }).filter(function (e) {
            return !e;
          }).length <= 0;
        } else i = !1;
      } else "number" == typeof e && "number" == typeof n && (isNaN(e) && (e = 0), isNaN(n) && (n = 0)), i = e instanceof Date ? e.getTime() === n.getTime() : e === n || "function" == typeof e && "function" == typeof n;

      return i && a;
    } catch (e) {
      return r && t.log("isEqual() Exception: ", e), !1;
    }
  };

  n.EventType = {
    ADDED: "added",
    REMOVED: "removed",
    UPDATED: "updated"
  };

  var N = function N() {
    var e = function e() {
      var e = function e() {
        try {
          navigator.onLine && (Ie.getInstance().reconnecting || Ie.getInstance().connecting || !se.getInstance().sessionKey || Ie.getInstance().getConnectionState() === Ie.getInstance().ConnectionState.OPEN || Ie.getInstance().reconnect());
        } catch (e) {
          r && t.log("There is no window.addEventListener.ononline or navigator.onLine");
        }
      },
          n = function n() {
        try {
          navigator.onLine || Ie.getInstance().reconnecting || Ie.getInstance().connecting || !se.getInstance().sessionKey || (ie && ie.stop(), Ie.getInstance().reconnect());
        } catch (e) {
          r && t.log("There is no window.addEventListener.ononline or navigator.onLine");
        }
      };

      this.start = function () {
        try {
          window && window.addEventListener && "ononline" in window && "onoffline" in window && navigator && "boolean" == typeof navigator.onLine && (window.addEventListener("online", e), window.addEventListener("offline", n));
        } catch (e) {
          r && t.log("There is no window.addEventListener.ononline or navigator.onLine");
        }
      }, this.stop = function () {
        try {
          window.removeEventListener("online", e, !1), window.removeEventListener("offline", n, !1);
        } catch (e) {
          r && t.log("There is no window.addEventListener.ononline or navigator.onLine");
        }
      };
    },
        d = new e(),
        N = function N() {};

    N.INVALID_INITIALIZATION = 800100, N.CONNECTION_REQUIRED = 800101, N.CONNECTION_CANCELED = 800102, N.INVALID_PARAMETER = 800110, N.NETWORK_ERROR = 800120, N.NETWORK_ROUTING_ERROR = 800121, N.MALFORMED_DATA = 800130, N.MALFORMED_ERROR_DATA = 800140, N.WRONG_CHANNEL_TYPE = 800150, N.MARK_AS_READ_RATE_LIMIT_EXCEEDED = 800160, N.QUERY_IN_PROGRESS = 800170, N.ACK_TIMEOUT = 800180, N.LOGIN_TIMEOUT = 800190, N.WEBSOCKET_CONNECTION_CLOSED = 800200, N.WEBSOCKET_CONNECTION_FAILED = 800210, N.REQUEST_FAILED = 800220, N.FILE_UPLOAD_CANCEL_FAILED = 800230, N.REQUEST_CANCELED = 800240;

    var C = function C() {
      var e = function () {
        return "undefined" != typeof process && "[object process]" === Object.prototype.toString.call(process);
      }(),
          n = null;

      try {
        e ? n = require("xhr2") : "undefined" != typeof XMLHttpRequest ? n = XMLHttpRequest : (r && t.log("There is not XHR."), n = null);
      } catch (e) {
        r && t.log("There is not XHR. - ", e);
      }

      if (n) {
        try {
          n.prototype.setRequestEvent = function (e, i) {
            var a = this;
            e && "function" == typeof e && (a.upload.onprogress = function (n) {
              i && "function" == typeof i && i(n), n.lengthComputable && n.loaded >= n.total && e();
            }), a.onreadystatechange = function () {
              if (a && a.readyState === n.DONE) {
                var i = a.status,
                    s = null;

                if (i >= 200 && i < 400) {
                  var o = !0;

                  try {
                    s = JSON.parse(a.responseText);
                  } catch (e) {
                    o = !1, s = null;
                  }

                  o ? p(null, s, a.callback) : p(new g("Request failed.", N.REQUEST_FAILED), null, a.callback), e && "function" == typeof e && e(), a = null;
                } else {
                  var l = {
                    status: i,
                    statusText: a.statusText,
                    response: a.responseText
                  };
                  r && t.log(l), a && a.isAbort ? a.onabort() : (p(l, null, a.callback), a = null);
                }
              }
            }, a.onabort = function () {
              a && (p(new g("Request has been canceled.", N.REQUEST_CANCELED), null, a.callback), e && "function" == typeof e && e(), a = null);
            }, a.onerror = function () {
              a && (p(new g("There was a network error.", N.NETWORK_ERROR), null, a.callback), e && "function" == typeof e && e(), a = null);
            }, a.ontimeout = function () {
              a && (p(new g("Request is timeout.", N.REQUEST_FAILED), null, a.callback), e && "function" == typeof e && e(), a = null);
            };
          };
        } catch (e) {
          r && t.log("setting request event is failed. - ", e);
        }

        try {
          n.prototype.setDefaultHeader = function (e) {
            var n = this;
            n.setRequestHeader("SendBird", c + T), e && n.setRequestHeader("Session-Key", e);
          };
        } catch (e) {
          r && t.log("setting default header is failed. - ", e);
        }

        try {
          n.prototype.createWithEncodedGetParams = function () {
            try {
              var e = this,
                  n = "";

              for (var i in e.data) {
                if (e.data.hasOwnProperty(i)) {
                  var a = e.data[i];

                  if (void 0 !== a && null !== a) {
                    var s = "";
                    s = "object" == typeof a ? Array.isArray(a) ? a.map(function (e) {
                      return encodeURIComponent(e);
                    }).join(",") : encodeURIComponent(JSON.stringify(a)) : encodeURIComponent(a), n += i + "=" + s + "&";
                  }
                }
              }

              n && (e.url = e.url + "?" + n.substring(0, n.length - 1));
            } catch (e) {
              r && t.log("createWithEncodedGetParams is failed. - ", e);
            }
          }, n.prototype.sendRequest = function (e) {
            var n = this;

            switch (e) {
              case "GET":
                n.send();
                break;

              default:
                "undefined" != typeof FormData && FormData && n.data instanceof FormData || void 0 !== u && u && n.data instanceof u ? n.data.oldIE ? (n.setRequestHeader("Content-Type", "multipart/form-data; boundary=" + n.data.boundary), n.send(n.data.toString())) : n.send(n.data) : (n.setRequestHeader("Content-Type", "application/json; charset=utf-8"), n.send(JSON.stringify(n.data)));
            }
          };
        } catch (e) {
          r && t.log("sending a request is failed. - ", e);
        }
      }

      var i = function i(e, t, r, _i) {
        var a = new n();
        return a.url = t, a.data = r, a.callback = _i, "GET" !== e && "DELETE" !== e || a.createWithEncodedGetParams(), a.open(e, a.url, !0), a;
      },
          a = function a(e) {
        p(new g("Request failed. There is not XMLHttpRequest.", N.REQUEST_FAILED), null, e);
      };

      this.get = function (e, t, r) {
        n || a(r);
        var s = i("GET", e, t, r);
        s.setRequestEvent(), s.setDefaultHeader(se.getInstance().sessionKey), s.sendRequest("GET");
      }, this.post = function (e, t, r) {
        n || a(r);
        var s = i("POST", e, t, r);
        s.setRequestEvent(), s.setDefaultHeader(se.getInstance().sessionKey), s.sendRequest("POST");
      }, this.put = function (e, t, r) {
        n || a(r);
        var s = i("PUT", e, t, r);
        s.setRequestEvent(), s.setDefaultHeader(se.getInstance().sessionKey), s.sendRequest("PUT");
      }, this["delete"] = function (e, t, r) {
        n || a(r);
        var s = i("DELETE", e, t, r);
        s.setRequestEvent(), s.setDefaultHeader(se.getInstance().sessionKey), s.sendRequest("DELETE");
      }, this.upload = function (e, t, r, s, o) {
        n || a(o);
        var l = i("POST", e, null, o);
        Ie.getInstance()._fileUploadRequest[r] = l;

        var c = function c() {
          Ie.getInstance()._fileUploadRequest[r] && delete Ie.getInstance()._fileUploadRequest[r];
        },
            d = function d(e) {
          s && "function" == typeof s && s(e, r);
        };

        l.setRequestEvent(c, d);
        var h = u ? new u() : new FormData(),
            p = t.file,
            f = t.fileType;
        f && "undefined" != typeof Blob && (p instanceof Blob || "string" == typeof p || Array.isArray(p) || p.hasOwnProperty("isRNFetchBlobPolyfill")) ? h.append("file", new Blob([p], {
          type: f
        }), p.name) : h.append("file", p, p.name), t.channelUrl && "string" == typeof t.channelUrl && h.append("channel_url", t.channelUrl);
        var _ = t.thumbnailSizes;
        if (_) for (var I in _) {
          var g = parseInt(I) + 1;
          h.append("thumbnail" + g, _[I].maxWidth + "," + _[I].maxHeight);
        }
        l.data = h, l.setDefaultHeader(se.getInstance().sessionKey), l.sendRequest("POST");
      };
    },
        R = new C(),
        S = !1,
        U = function U(e, n, t) {
      t && "function" == typeof t && (void 0 === n && (n = null), void 0 === e && (e = null), S ? t(n, e) : t(e, n));
    },
        T = "",
        P = 0,
        O = 0,
        L = function L(e) {
      this.isOpenChannel = function () {
        return this.channelType === F.CHANNEL_TYPE_OPEN;
      }, this.isGroupChannel = function () {
        return this.channelType === F.CHANNEL_TYPE_GROUP;
      }, this.isUserMessage = function () {
        return this.messageType === L.MESSAGE_TYPE_USER;
      }, this.isAdminMessage = function () {
        return this.messageType === L.MESSAGE_TYPE_ADMIN;
      }, this.isFileMessage = function () {
        return this.messageType === L.MESSAGE_TYPE_FILE;
      }, this._update = function (e) {
        this.messageId = e.hasOwnProperty("msg_id") ? parseInt(e.msg_id) : 0, this.channelUrl = e.hasOwnProperty("channel_url") ? String(e.channel_url) : "", this.data = e.hasOwnProperty("data") ? String(e.data) : "", this.customType = e.hasOwnProperty("custom_type") ? String(e.custom_type) : "", this.createdAt = e.hasOwnProperty("ts") ? parseInt(e.ts) : 0, this.updatedAt = e.hasOwnProperty("updated_at") ? parseInt(e.updated_at) : 0, this.channelType = e.hasOwnProperty("channel_type") ? String(e.channel_type) : F.CHANNEL_TYPE_GROUP, this.metaArray = e.hasOwnProperty("metaarray") ? e.metaarray : {}, this.mentionType = e.hasOwnProperty("mention_type") ? e.mention_type : de.MentionType.USERS;
        var n = this;

        if (n.mentionedUsers = [], e.hasOwnProperty("mentioned_users")) {
          e.mentioned_users.forEach(function (e) {
            var t = new q(e);
            n.mentionedUsers.push(t);
          });
        }
      }, this.isIdentical = function (e) {
        var n = !1;

        try {
          return n = !("object" != typeof e || !e.hasOwnProperty("messageId")) && (this.messageType !== L.MESSAGE_TYPE_ADMIN ? !!e.hasOwnProperty("reqId") && (0 !== this.messageId && 0 !== e.messageId && this.messageId === e.messageId || (0 === this.messageId || 0 === e.messageId) && 0 !== this.reqId && 0 !== e.reqId && this.reqId === e.reqId) : 0 !== this.messageId && 0 !== e.messageId && this.messageId === e.messageId);
        } catch (e) {
          return r && t.log("isIdentical Exception: ", e), n;
        }
      }, this.isEqual = function (e) {
        return v(this, e);
      }, this.serialize = function () {
        var e = JSON.parse(JSON.stringify(this));
        return e.hasOwnProperty("_sender") && (e.sender = e._sender, delete e._sender), E(e);
      }, this.getMetaArrayByKeys = function (e) {
        var n = {};
        if (Array.isArray(e)) for (var t in e) {
          var r = e[t];
          "string" == typeof r && this.metaArray.hasOwnProperty(r) && (n[r] = this.metaArray[r]);
        }
        return n;
      }, this.messageType = L.MESSAGE_TYPE_BASE, e && this._update(e);
    };

    L.build = function (e, n) {
      if (!e) return null;
      var t, r, i, a, s, o, l, u, c, d, h;

      switch (e.type) {
        case "MESG":
          return t = new q(e.user), r = parseInt(e.message_id), i = String(e.message), a = String(e.data), s = parseInt(e.created_at), o = parseInt(e.updated_at), l = e.hasOwnProperty("custom_type") ? String(e.custom_type) : "", u = e.hasOwnProperty("translations") ? e.translations : {}, c = e.hasOwnProperty("metaarray") ? e.metaarray : {}, d = e.hasOwnProperty("mention_type") ? e.mention_type : de.MentionType.USERS, h = e.mentioned_users, new b(b.build("", r, t, n, i, a, l, u, s, o, c, d, h));

        case "FILE":
          t = new q(e.user), r = parseInt(e.message_id), i = String(e.message), s = parseInt(e.created_at), o = parseInt(e.updated_at), l = e.hasOwnProperty("custom_type") ? String(e.custom_type) : "", c = e.hasOwnProperty("metaarray") ? e.metaarray : {}, d = e.hasOwnProperty("mention_type") ? e.mention_type : de.MentionType.USERS, h = e.mentioned_users;

          var p = e.file,
              f = String(p.url),
              _ = String(p.name),
              I = String(p.type),
              g = parseInt(p.size) || 0;

          a = String(p.data);
          var m = e.hasOwnProperty("thumbnails") ? e.thumbnails : [],
              E = !!e.hasOwnProperty("require_auth") && e.require_auth;
          return new w(w.build("", r, t, n, f, _, I, g, a, l, s, m, E, o, c, d, h));

        case "BRDM":
        case "ADMM":
          return r = parseInt(e.message_id), i = String(e.message), a = String(e.data), s = parseInt(e.created_at), o = parseInt(e.updated_at), l = e.hasOwnProperty("custom_type") ? String(e.custom_type) : "", u = e.hasOwnProperty("translations") ? e.translations : {}, c = e.hasOwnProperty("metaarray") ? e.metaarray : {}, d = e.hasOwnProperty("mention_type") ? e.mention_type : de.MentionType.USERS, h = e.mentioned_users, new M(M.build(r, n, i, a, l, u, s, o, c, d, h));
      }

      return null;
    }, L.MESSAGE_TYPE_BASE = "base", L.MESSAGE_TYPE_ADMIN = "admin", L.MESSAGE_TYPE_USER = "user", L.MESSAGE_TYPE_FILE = "file";

    var M = function M(e) {
      this.messageType = L.MESSAGE_TYPE_ADMIN, e && (this._update(e), this.message = String(e.message), this.translations = e.hasOwnProperty("translations") ? e.translations : {});
    };

    I(L, M), M.build = function (e, n, t, r, i, a, s, o, l, u, c) {
      var d = {
        msg_id: e,
        channel_url: n.url,
        channel_type: n.channelType === F.CHANNEL_TYPE_OPEN ? F.CHANNEL_TYPE_OPEN : F.CHANNEL_TYPE_GROUP,
        ts: s,
        updated_at: o,
        message: t,
        data: r
      };
      return i && (d.custom_type = i), a && (d.translations = a), l && (d.metaarray = l), u && (d.mention_type = u), d.mentioned_users = [], c && (d.mentioned_users = c), d;
    }, M.buildFromSerializedData = function (e) {
      var n = A(e),
          t = [];
      return n.mentionedUsers.forEach(function (e) {
        t.push(q.build(e.userId, e.nickname, e.profileUrl, e.connectionStatus, e.lastSeenAt, e.metaData, e.isActive, e.friendDiscoveryKey, e.friendName));
      }), new M(M.build(n.messageId, {
        url: n.channelUrl,
        channelType: n.channelType
      }, n.message, n.data, n.customType, n.translations, n.createdAt, n.updatedAt, n.metaArray, n.mentionType, t));
    };

    var D = function D(e) {
      this.scheduledId = 0, this.scheduledDateTimeString = "", this.scheduledTimezone = "", this.status = D.Status.SCHEDULED, this.createdAt = 0, this.updatedAt = 0, this.channelUrl = "", this._channelType = "", this._messageType = L.MESSAGE_TYPE_BASE, this._sender = null, h ? this.sender = this._sender : Object.defineProperty(this, "sender", {
        get: function get() {
          if (Ie.getInstance().Options.useMemberAsMessageSender && this.isGroupChannel()) {
            var e = V.cachedChannels[this.channelUrl];

            if (e) {
              var n = e.memberMap[this._sender.userId];
              n && (this._sender.nickname !== n.nickname && (this._sender.nickname = n.nickname), this._sender.profileUrl !== n.profileUrl && (this._sender.profileUrl = n.profileUrl), this._sender.metaData !== n.metaData && (this._sender.metaData = n.metaData));
            }
          }

          return this._sender;
        },
        set: function set(e) {
          this._sender = e;
        }
      }), this.message = "", this.customType = "", this.data = "", this.metaArray = {}, this.mentionType = de.MentionType.USERS, this.mentionedUsers = [], this.pushNotificationDeliveryOption = de.PushNotificationDeliveryOption.DEFAULT, this.translationTargetLanguages = [], this.errorMessage = "", this.errorCode = 0;
      var n = this;
      this.isOpenChannel = function () {
        return this._channelType === F.CHANNEL_TYPE_OPEN;
      }, this.isGroupChannel = function () {
        return this._channelType === F.CHANNEL_TYPE_GROUP;
      }, this._update = function (e) {
        if (this.scheduledId = e.hasOwnProperty("scheduled_id") ? parseInt(e.scheduled_id) : 0, this.scheduledDateTimeString = e.hasOwnProperty("scheduled_dt") ? String(e.scheduled_dt) : "", this.scheduledTimezone = e.hasOwnProperty("scheduled_timezone") ? String(e.scheduled_timezone) : "", this.status = e.hasOwnProperty("status") ? String(e.status) : "", this.createdAt = e.hasOwnProperty("created_at") ? parseInt(e.created_at) : 0, this.updatedAt = e.hasOwnProperty("updated_at") ? parseInt(e.updated_at) : 0, this.channelUrl = e.hasOwnProperty("channel_url") ? String(e.channel_url) : "", this._channelType = e.hasOwnProperty("channel_type") ? String(e.channel_type) : "", this._messageType = e.hasOwnProperty("type") ? String(e.type) : "", this._sender = e.hasOwnProperty("user") ? new q(e.user) : "", this.message = e.hasOwnProperty("message") ? String(e.message) : "", this.customType = e.hasOwnProperty("custom_type") ? String(e.custom_type) : "", this.data = e.hasOwnProperty("data") ? String(e.data) : "", this.metaArray = e.hasOwnProperty("metaarray") ? e.metaarray : {}, this.mentionType = e.hasOwnProperty("mention_type") ? e.mention_type : de.MentionType.USERS, this.mentionedUsers = [], e.hasOwnProperty("mentioned_users")) {
          e.mentioned_users.forEach(function (e) {
            var t = new q(e);
            n.mentionedUsers.push(t);
          });
        }

        this.pushNotificationDeliveryOption = e.hasOwnProperty("push_option") ? e.push_option : de.PushNotificationDeliveryOption.DEFAULT, this.translationTargetLanguages = e.hasOwnProperty("translation_target_langs") ? e.translation_target_langs : [], this.status === D.Status.FAILED && (e.hasOwnProperty("error") && e.error.hasOwnProperty("message") && (this.errorMessage = String(e.error.message)), e.hasOwnProperty("error") && e.error.hasOwnProperty("code") && (this.errorCode = parseInt(e.error.code)));
      }, e && this._update(e);
    };

    D.Status = {
      SCHEDULED: "scheduled",
      SENT: "sent",
      CANCELED: "canceled",
      FAILED: "failed"
    };

    var b = function b(e) {
      this.messageType = L.MESSAGE_TYPE_USER, e && (this._update(e), this.message = String(e.message), this._sender = new q(e.user), h ? this.sender = this._sender : Object.defineProperty(this, "sender", {
        get: function get() {
          if (Ie.getInstance().Options.useMemberAsMessageSender && this.isGroupChannel()) {
            var e = V.cachedChannels[this.channelUrl];

            if (e) {
              var n = e.memberMap[this._sender.userId];
              n && (this._sender.nickname !== n.nickname && (this._sender.nickname = n.nickname), this._sender.profileUrl !== n.profileUrl && (this._sender.profileUrl = n.profileUrl), this._sender.metaData !== n.metaData && (this._sender.metaData = n.metaData));
            }
          }

          return this._sender;
        },
        set: function set(e) {
          this._sender = e;
        }
      }), this.reqId = e.hasOwnProperty("req_id") ? String(e.req_id) : "", this.translations = e.hasOwnProperty("translations") ? e.translations : {});
    };

    I(L, b), b.build = function (e, n, t, r, i, a, s, o, l, u, c, d, h, p) {
      var f = {};
      f.req_id = e, f.msg_id = n, f.channel_url = r.url, f.channel_type = r.channelType === F.CHANNEL_TYPE_OPEN ? F.CHANNEL_TYPE_OPEN : F.CHANNEL_TYPE_GROUP, f.ts = l, f.updated_at = u, f.message = i, a && (f.data = a), s && (f.custom_type = s), o && (f.translations = o);
      var _ = {
        user_id: "",
        nickname: "",
        profile_url: "",
        metadata: {}
      };

      if (t) {
        _.user_id = t.userId, _.nickname = t.nickname, _.profile_url = t.profileUrl;

        try {
          _.metadata = "string" == typeof t.metaData ? JSON.parse(t.metaData) : t.metaData;
        } catch (e) {
          _.metadata = {};
        }
      }

      return f.user = _, c && (f.metaarray = c), f.mention_type = de.MentionType.USERS, d && (f.mention_type = d), f.mentioned_users = [], h && (f.mentioned_users = h), p && (f.mentioned_user_ids = p), f;
    }, b.buildFromSerializedData = function (e) {
      var n = A(e),
          t = [];
      return n.mentionedUsers.forEach(function (e) {
        t.push(q.build(e.userId, e.nickname, e.profileUrl, e.connectionStatus, e.lastSeenAt, e.metaData, e.isActive, e.friendDiscoveryKey, e.friendName));
      }), new b(b.build(n.reqId, n.messageId, n.sender, {
        url: n.channelUrl,
        channelType: n.channelType
      }, n.message, n.data, n.customType, n.translations, n.createdAt, n.updatedAt, n.metaArray, n.mentionType, t));
    };

    var H = function H(e, i) {
      var a = 0,
          s = e,
          o = i,
          l = new n([]);

      l.onChangeHandler = function (e, i, a) {
        if (r && t.log("fileMessageQueue.onChangeHandler: ", e, i, a), a.hasOwnProperty(n.EventType.ADDED)) {
          var s = a[n.EventType.ADDED];

          if (s.state = H.StateType.UPLOADING, s.error) {
            var o = c.searchIndexByKeyValue("reqId", s.reqId);
            o > -1 && (s.state = H.StateType.SENT, c.update(o, s)), u(s.reqId);
          } else I(s, function (e) {
            s.state = H.StateType.UPLOADED;
            var n = c.searchIndexByKeyValue("reqId", s.reqId);
            n > -1 && (s.fileInfo = e, c.update(n, s)), u(s.reqId);
          });
        } else a.hasOwnProperty(n.EventType.UPDATED) || c.length > 0 && l.length < 6 && h();
      };

      var u = function u(e) {
        var n = l.searchIndexByKeyValue("reqId", e);
        n > -1 && l.splice(n, 1);
      },
          c = new n([]);

      c.onChangeHandler = function (e, i, a) {
        r && t.log("fileMessageQueue.onChangeHandler: ", e, i, a), a.hasOwnProperty(n.EventType.ADDED) ? l.length < 6 && h() : c.length > 0 && p();
      };

      var d = function d() {
        var e = null,
            n = c.items.filter(function (e) {
          return e.state === H.StateType.PENDING;
        });
        return n.length > 0 && (e = n[0]), e;
      },
          h = function h() {
        var e = d();
        e && l.push(e);
      },
          p = function p() {
        var e = c.items[0];
        e.state === H.StateType.UPLOADED ? f() : e.state === H.StateType.SENT && _();
      },
          f = function f() {
        var e = c.items[0];

        if (e && e.state === H.StateType.UPLOADED) {
          for (e.state = H.StateType.SENDING, a = 0 === a ? new Date().getTime() - 200 : a; new Date().getTime() - a < 200;) {
            ;
          }

          a = new Date().getTime(), m(e, function (n, t) {
            e.state = H.StateType.SENT, e.error = t || null, e.res = n || null;
            var r = c.searchIndexByKeyValue("reqId", e.reqId);
            r > -1 && c.update(r, e);
          });
        }
      },
          _ = function _() {
        var e = c.items[0];

        if (e && e.state === H.StateType.SENT) {
          e.state = H.StateType.DONE;
          var n = Ie.getInstance(),
              t = e.res,
              r = e.error;

          if (t && !r) {
            var i = n.currentUser;
            i && t._sender && i.userId === t._sender.userId && (i.nickname !== t._sender.nickname && (i.nickname = t._sender.nickname), i.profileUrl !== t._sender.profileUrl && (i.profileUrl = t._sender.profileUrl)), o || V.getChannel(s, function (r, i) {
              if (S) {
                var a = r;
                r = i, i = a;
              }

              if (i) return U(t, i, e.fileInfo.callback), void c.shift();
              r.lastMessage = t;

              for (var s in n.channelHandlers) {
                n.channelHandlers[s].onChannelChanged(r);
              }
            });
          }

          U(t, r, e.fileInfo.callback), c.shift();
        }
      },
          I = function I(e, n) {
        var t = e.fileInfo,
            r = e.preMessageObj;
        "string" != typeof t.file && t.file ? se.getInstance().uploadFile(t.file, t.type, t.thumbnailSizes, s, function (r, i) {
          if (i) return e.state = H.StateType.SENT, e.error = i, e.res = null, void n(t);
          var a = "object" == typeof r ? r : JSON.parse(r);
          t.file = a.url, t.thumbnailSizes = a.hasOwnProperty("thumbnails") ? a.thumbnails : [], t.requireAuth = !!a.hasOwnProperty("require_auth") && a.require_auth, n(t);
        }, t.progressHandler, r ? r.reqId : null) : (t.thumbnailSizes = [], t.requireAuth = !1, n(t));
      },
          m = function m(e, n) {
        if (null !== e) {
          var t = e.fileInfo,
              r = e.reqId,
              i = Ie.getInstance();
          if (i.getConnectionState() !== i.ConnectionState.OPEN && i.currentUser && !i.connecting) se.getInstance().sendFileMessageAPI(s, o, t.file, t.name, t.size, t.type, t.data, t.customType, t.customType, t.requireAuth, t.metaArray, t.mentionType, t.mentionedUserIds, t.pushNotificationDeliveryOption, function (e, t) {
            var r = t ? null : new w(e);
            n(r, t);
          });else {
            var a = x.bFile(r, s, t.file, t.name, t.type, t.size, t.data, t.customType, t.thumbnailSizes, t.requireAuth, t.metaArray, t.mentionType, t.mentionedUserIds, t.pushNotificationDeliveryOption);
            i.sendCommand(a, function (e, t) {
              var r = t ? null : new w(e.getJsonElement());
              n(r, t);
            });
          }
        }
      };

      this.addTask = function (e) {
        c.push(e);
      }, this.runCallbackByReqId = function (e, n, t) {
        var r = c.searchIndexByKeyValue("reqId", e);

        if (r > -1) {
          var i = c.items[r];
          return i.res = n, i.error = t, c.update(r, i), !0;
        }

        return !1;
      }, this.cancelUploadItemByReqId = function (e) {
        u(e);
        var n = c.searchIndexByKeyValue("reqId", e);

        if (n > -1) {
          var t = c.items[n];
          !t || t.state !== H.StateType.UPLOADING && t.state !== H.StateType.PENDING || (t.state = H.StateType.SENT, t.res = null, t.error = new g("Uploading has been completed or canceled.", N.FILE_UPLOAD_CANCEL_FAILED), c.update(n, t));
        }
      };
    };

    H.StateType = {
      PENDING: "pending",
      UPLOADING: "uploading",
      UPLOADED: "uploaded",
      SENDING: "sending",
      SENT: "sent",
      DONE: "done"
    };

    var w = function w(e) {
      if (this.messageType = L.MESSAGE_TYPE_FILE, e && (this._update(e), this._sender = new q(e.user), h ? this.sender = this._sender : Object.defineProperty(this, "sender", {
        get: function get() {
          if (Ie.getInstance().Options.useMemberAsMessageSender && this.isGroupChannel()) {
            var e = V.cachedChannels[this.channelUrl];

            if (e) {
              var n = e.memberMap[this._sender.userId];
              n && (this._sender.nickname !== n.nickname && (this._sender.nickname = n.nickname), this._sender.profileUrl !== n.profileUrl && (this._sender.profileUrl = n.profileUrl), this._sender.metaData !== n.metaData && (this._sender.metaData = n.metaData));
            }
          }

          return this._sender;
        },
        set: function set(e) {
          this._sender = e;
        }
      }), this.requireAuth = !!e.hasOwnProperty("require_auth") && e.require_auth, this.url = this.requireAuth ? String(e.url).split("?auth=")[0] + "?auth=" + se.getInstance().ekey : String(e.url).split("?auth=")[0], this.name = e.hasOwnProperty("name") ? e.name : "File", this.size = parseInt(e.size) || 0, this.type = String(e.type), this.data = e.hasOwnProperty("custom") ? String(e.custom) : "", this.reqId = e.hasOwnProperty("req_id") ? String(e.req_id) : "", this.thumbnails = e.hasOwnProperty("thumbnails") ? e.thumbnails : [], this.requireAuth)) for (var n in this.thumbnails) {
        this.thumbnails[n].url = String(this.thumbnails[n].url).split("?auth=")[0] + "?auth=" + se.getInstance().ekey;
      }
    };

    I(L, w), w.build = function (e, n, t, r, i, a, s, o, l, u, c, d, h, p, f, _, I, g) {
      var m = {};
      m.req_id = e, m.msg_id = n, m.channel_url = r.url, m.channel_type = r.channelType === F.CHANNEL_TYPE_OPEN ? F.CHANNEL_TYPE_OPEN : F.CHANNEL_TYPE_GROUP, m.ts = c, m.updated_at = p, m.url = i, m.name = a, m.type = s, m.size = o, m.custom = l;
      var E = {
        user_id: "",
        nickname: "",
        profile_url: "",
        metadata: {}
      };

      if (t) {
        E.user_id = t.userId, E.nickname = t.nickname, E.profile_url = t.profileUrl;

        try {
          E.metadata = JSON.parse(t.metaData);
        } catch (e) {
          E.metadata = {};
        }
      }

      return m.user = E, u && (m.custom_type = u), h && (m.require_auth = h), d && (m.thumbnails = d), f && (m.metaarray = f), _ && (m.mention_type = _), m.mentioned_users = [], I && (m.mentioned_users = I), g && (m.mentioned_user_ids = g), m;
    }, w.buildFromSerializedData = function (e) {
      var n = A(e),
          t = [];
      return n.mentionedUsers.forEach(function (e) {
        t.push(q.build(e.userId, e.nickname, e.profileUrl, e.connectionStatus, e.lastSeenAt, e.metaData, e.isActive, e.friendDiscoveryKey, e.friendName));
      }), new w(w.build(n.reqId, n.messageId, n.sender, {
        url: n.channelUrl,
        channelType: n.channelType
      }, n.url, n.name, n.type, n.size, n.data, n.customType, n.createdAt, n.thumbnails, n.requireAuth, n.updatedAt, n.metaArray, n.mentionType, t));
    };

    var F = function F(e) {
      this._update = function (e) {
        this.url = e.hasOwnProperty("channel_url") ? String(e.channel_url) : "", this.name = e.hasOwnProperty("name") ? String(e.name) : "", this.coverUrl = e.hasOwnProperty("cover_url") ? String(e.cover_url) : "", this.createdAt = e.hasOwnProperty("created_at") ? 1e3 * e.created_at : 0, this.data = e.hasOwnProperty("data") ? String(e.data) : "", this.customType = e.hasOwnProperty("custom_type") ? e.custom_type : "", this.isFrozen = !!e.hasOwnProperty("freeze") && e.freeze, this.isEphemeral = !!e.hasOwnProperty("is_ephemeral") && e.is_ephemeral;
      }, this.serialize = function () {
        var e = JSON.parse(JSON.stringify(this));

        if (e.hasOwnProperty("lastMessage") && null !== e.lastMessage && "undefined" != typeof e.lastMessage && "object" == typeof e.lastMessage) {
          var n = e.lastMessage;
          n.hasOwnProperty("_sender") && (n.sender = n._sender, delete n._sender, e.lastMessage = n);
        }

        return E(e);
      }, this.isGroupChannel = function () {
        return this.channelType === F.CHANNEL_TYPE_GROUP;
      }, this.isOpenChannel = function () {
        return this.channelType === F.CHANNEL_TYPE_OPEN;
      }, this.getMessageChangeLogsByToken = function (e, n, t) {
        var r = this;
        "function" == typeof n && (t = n, n = !1), "function" == typeof e && (t = e, n = !1, e = null), se.getInstance().getMessageChangeLogsByToken(r.isOpenChannel(), r.url, e, n, function (e, n) {
          if (n) return void U(null, n, t);
          var i = e.updated.map(function (e) {
            return L.build(e, r);
          }),
              a = e.deleted.map(function (e) {
            return e.message_id;
          }),
              s = e.has_more,
              o = e.next;
          U({
            updatedMessages: i,
            deletedMessageIds: a,
            hasMore: s,
            token: o
          }, null, t);
        });
      }, this.getMyMutedInfo = function (e) {
        var n = this;
        se.getInstance().getMyMutedInfo(n.isGroupChannel(), n.url, Ie.getInstance().currentUser.userId, function (n, t) {
          if (t) return void U(null, t, e);
          var r = {
            isMuted: n.is_muted,
            startAt: n.start_at,
            endAt: n.end_at,
            remainingDuration: n.remaining_duration,
            description: n.description
          };
          U(r, null, e);
        });
      }, this.createOperatorListQuery = function () {
        return new z(this);
      }, this.createPreviousMessageListQuery = function () {
        return new $(this);
      }, this.createMessageListQuery = function () {
        return new X(this);
      };

      var n = function n(e, _n, t, r, i, a, s, o, l, u, c) {
        if (s === m.MessageTypeFilter.ADMIN ? s = "ADMM" : s === m.MessageTypeFilter.USER ? s = "MESG" : s === m.MessageTypeFilter.FILE ? s = "FILE" : s === m.MessageTypeFilter.ALL && (s = ""), !(_(_n) && "boolean" == typeof t && _(r) && _(i) && "boolean" == typeof a && "string" == typeof s && "string" == typeof o && Array.isArray(l) && "boolean" == typeof u)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), c);

        for (var d = 0; d < l.length; d++) {
          if ("string" != typeof l[d]) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), c);
        }

        se.getInstance().messageList(e.isOpenChannel(), e.url, _n, r, i, t, a, s, o, l, u, function (n, t) {
          if (t) return void U(null, t, c);
          var r = n.messages,
              i = [];

          for (var a in r) {
            var s = L.build(r[a], e);
            s && i.push(s);
          }

          U(i, null, c);
        });
      },
          t = function t(e, n, _t, r, i, a, s, o, l, u, c) {
        if (s === m.MessageTypeFilter.ADMIN ? s = "ADMM" : s === m.MessageTypeFilter.USER ? s = "MESG" : s === m.MessageTypeFilter.FILE ? s = "FILE" : s === m.MessageTypeFilter.ALL && (s = ""), !(_(n) && "boolean" == typeof _t && _(r) && _(i) && "boolean" == typeof a && "string" == typeof s && "string" == typeof o && Array.isArray(l) && "boolean" == typeof u)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), c);

        for (var d = 0; d < l.length; d++) {
          if ("string" != typeof l[d]) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), c);
        }

        se.getInstance().messageListByID(e.isOpenChannel(), e.url, n, r, i, _t, a, s, o, l, u, function (n, t) {
          if (t) return void U(null, t, c);
          var r = n.messages,
              i = [];

          for (var a in r) {
            var s = L.build(r[a], e);
            s && i.push(s);
          }

          U(i, null, c);
        });
      };

      this.getNextMessagesByTimestamp = function (e, t, r, i, a, s, o, l, u) {
        return "function" != typeof l || u || (u = l, l = !1), "function" != typeof o || u || (u = o, l = !1, o = []), n(this, e, t, 0, r, i, a, s, o, l, u);
      }, this.getPreviousMessagesByTimestamp = function (e, t, r, i, a, s, o, l, u) {
        return "function" != typeof l || u || (u = l, l = !1), "function" != typeof o || u || (u = o, l = !1, o = []), n(this, e, t, r, 0, i, a, s, o, l, u);
      }, this.getPreviousAndNextMessagesByTimestamp = function (e, t, r, i, a, s, o, l, u) {
        return "function" != typeof l || u || (u = l, l = !1), "function" != typeof o || u || (u = o, l = !1, o = []), n(this, e, !0, t, r, i, a, s, o, l, u);
      }, this.getNextMessagesByID = function (e, n, r, i, a, s, o, l, u) {
        return "function" != typeof l || u || (u = l, l = !1), "function" != typeof o || u || (u = o, l = !1, o = []), t(this, e, n, 0, r, i, a, s, o, l, u);
      }, this.getPreviousMessagesByID = function (e, n, r, i, a, s, o, l, u) {
        return "function" != typeof l || u || (u = l, l = !1), "function" != typeof o || u || (u = o, l = !1, o = []), t(this, e, n, r, 0, i, a, s, o, l, u);
      }, this.getPreviousAndNextMessagesByID = function (e, n, r, i, a, s, o, l, u) {
        return "function" != typeof l || u || (u = l, l = !1), "function" != typeof o || u || (u = o, l = !1, o = []), t(this, e, !0, n, r, i, a, s, o, l, u);
      }, this._getParamFromSendFileMessage = function (e) {
        var n = {
          file: null,
          name: null,
          type: null,
          size: null,
          data: "",
          customType: "",
          thumbnailSizes: [],
          metaArray: {},
          mentionType: de.MentionType.USERS,
          mentionedUserIds: [],
          pushNotificationDeliveryOption: pe.PushNotificationDeliveryOption.DEFAULT,
          progressHandler: null,
          callback: null
        };

        if ("function" == typeof e.slice(-1)[0] && (n.callback = e.pop()), "function" == typeof e.slice(-1)[0] && (n.progressHandler = e.pop()), e[0] instanceof pe) {
          if (n.file = e[0].file ? e[0].file : e[0].fileUrl, n.name = e[0].fileName, n.type = e[0].mimeType, n.size = e[0].fileSize, n.data = e[0].data, n.customType = e[0].customType, n.thumbnailSizes = e[0].thumbnailSizes, Array.isArray(e[0].metaArrayKeys)) for (var t in e[0].metaArrayKeys) {
            var r = e[0].metaArrayKeys[t];
            "string" == typeof r && (n.metaArray[r] = []);
          }
          n.mentionType = e[0]._mentionType, n.mentionedUserIds = e[0]._mentionedIds, n.pushNotificationDeliveryOption = e[0].pushNotificationDeliveryOption ? e[0].pushNotificationDeliveryOption : pe.PushNotificationDeliveryOption.DEFAULT;
        } else switch (e.length) {
          case 1:
            n.file = e[0];
            break;

          case 2:
            n.file = e[0], n.data = e[1];
            break;

          case 3:
            n.file = e[0], n.data = e[1], n.customType = e[2];
            break;

          case 4:
            n.file = e[0], n.data = e[1], n.customType = e[2], n.thumbnailSizes = e[3];
            break;

          case 5:
            n.file = e[0], n.name = e[1], n.type = e[2], n.size = e[3], n.data = e[4];
            break;

          case 6:
            n.file = e[0], n.name = e[1], n.type = e[2], n.size = e[3], n.data = e[4], n.customType = e[5];
            break;

          case 7:
            n.file = e[0], n.name = e[1], n.type = e[2], n.size = e[3], n.data = e[4], n.customType = e[5], n.thumbnailSizes = e[6];
        }

        return (Array.isArray(n.file) || "string" == typeof n.file && 0 === n.file.length || "undefined" == typeof n.file || "string" != typeof n.file && "object" != typeof n.file || n.file && "object" == typeof n.file && 0 === Object.keys(n.file).length) && (n.file = null), "string" != typeof n.file && null !== n.file && (null !== n.name && "undefined" != typeof n.name && n.name || (n.name = n.file.name), null !== n.type && "undefined" != typeof n.type && n.type || (n.type = n.file.type), null !== n.size && "undefined" != typeof n.size || (n.size = n.file.size)), null !== n.name && "undefined" != typeof n.name || (n.name = ""), null !== n.type && "undefined" != typeof n.type || (n.type = ""), null !== n.size && "undefined" != typeof n.size || (n.size = 0), null !== n.thumbnailSizes && "undefined" != typeof n.thumbnailSizes || (n.thumbnailSizes = []), n;
      }, this._createTempFileMessage = function (e) {
        try {
          var n = this,
              t = x.generateRequestId(),
              r = new Date().getTime(),
              i = w.build(t, 0, Ie.getInstance().currentUser, n, "string" == typeof e.file ? e.file : "", e.name, e.type, e.size, e.data, e.customType, r, null, !1, null, e.metaArray, e.mentionType, null, e.mentionedUserIds);
          return new w(i);
        } catch (e) {
          return null;
        }
      }, this.sendFileMessage = function () {
        var e = this,
            n = null,
            t = e._getParamFromSendFileMessage(Array.prototype.slice.call(arguments)),
            r = null;

        (null === t.file || "undefined" == typeof t.file || null !== t.name && "undefined" != typeof t.name && "string" != typeof t.name || null !== t.type && "undefined" != typeof t.type && "string" != typeof t.type || null !== t.size && "undefined" != typeof t.size && (!_(t.size) || parseInt(t.size) < 0) || null !== t.data && "undefined" != typeof t.data && "string" != typeof t.data || null !== t.customType && "undefined" != typeof t.customType && "string" != typeof t.customType || !Array.isArray(t.thumbnailSizes) || [pe.PushNotificationDeliveryOption.DEFAULT, pe.PushNotificationDeliveryOption.SUPPRESS].indexOf(t.pushNotificationDeliveryOption) < 0) && (r = new g("Invalid parameter.", N.INVALID_PARAMETER)), Ie.getInstance() && Ie.getInstance().currentUser || (r = new g("Connection should be made first.", N.CONNECTION_REQUIRED));
        var i = null;
        return r ? i = x.generateRequestId() : (n = e._createTempFileMessage(t), i = n.reqId), Ie.getInstance()._createFileQueue(e.url, e.isOpenChannel()).addTask({
          reqId: i,
          fileInfo: t,
          preMessageObj: n,
          state: H.StateType.PENDING,
          error: r,
          res: null
        }), n;
      }, this.sendFileMessages = function (e, n) {
        var t = this,
            r = function r(e, n) {},
            i = function i(e, n) {},
            a = function a(e) {};

        if ("object" == typeof n && ("function" == typeof n.progress && (r = n.progress), "function" == typeof n.sent && (i = n.sent), "function" == typeof n.complete && (a = n.complete)), !Array.isArray(e) || 0 === e.length || e.length > 20) return a(new g("Invalid parameter.", N.INVALID_PARAMETER)), null;
        var s = e.length,
            o = [];
        return e.forEach(function (e, n) {
          var l = i;
          n === s - 1 && (l = function l(e, n) {
            i(e, n), a(null);
          }), o.push(t.sendFileMessage(e, r, l));
        }), o;
      }, this.cancelUploadingFileMessage = function (e, n) {
        var t = this;
        if (!_(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);

        Ie.getInstance()._getFileQueue(t.url).cancelUploadItemByReqId(e);

        var r = Ie.getInstance()._fileUploadRequest[e];

        return r ? (r.upload.onabort = function () {
          U(!0, null, n);
        }, r.isAbort = !0, r.abort(), !0) : (U(!1, new g("Uploading has been completed or canceled.", N.FILE_UPLOAD_CANCEL_FAILED), n), !1);
      }, this.sendUserMessage = function (e, n, t, r, i) {
        var a = this,
            s = [],
            o = de.MentionType.USERS,
            l = [],
            u = he.PushNotificationDeliveryOption.DEFAULT;

        if ("function" == typeof n && (i = n, n = "", t = "", r = [], e instanceof he)) {
          var c = e;
          e = c.message, n = c.data, t = c.customType, r = c.translationTargetLanguages, s = c.metaArrayKeys, o = c._mentionType, l = c._mentionedIds, u = c.pushNotificationDeliveryOption ? c.pushNotificationDeliveryOption : he.PushNotificationDeliveryOption.DEFAULT;
        }

        "function" == typeof t && (i = t, t = "", r = []), "function" == typeof r && (i = r, r = []), r || (r = []), "string" == typeof r && (r = [r]), null === n && (n = ""), null === t && (t = "");
        var d = !0;

        for (var h in s) {
          var p = s[h];
          if (!(d = d && "string" == typeof p && "" !== p)) break;
        }

        if ("string" != typeof e || "string" != typeof n || "string" != typeof t || null !== s && s !== undefined && (!Array.isArray(s) || !d) || !Array.isArray(r) || [he.PushNotificationDeliveryOption.DEFAULT, he.PushNotificationDeliveryOption.SUPPRESS].indexOf(u) < 0) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), i);
        var f = null;
        if (!Ie.getInstance() || !Ie.getInstance().currentUser) return i && U(null, new g("Connection should be made first.", N.CONNECTION_REQUIRED), i), f;
        var _ = {};

        for (var h in s) {
          var p = s[h];
          "string" == typeof p && (_[p] = []);
        }

        var I = x.bMessage(this.url, e, n, t, _, o, l, r, u),
            m = b.build(I.requestId, 0, Ie.getInstance().currentUser, this, e, n, t, r, new Date().getTime(), null, _, o, null, l);
        return f = new b(m), Ie.getInstance().sendCommand(I, function (e, n) {
          if (n) return void U(null, new g(n.message, n.code), i);
          var t = new b(e.getJsonElement()),
              r = Ie.getInstance().currentUser;
          r && t._sender && r.userId === t._sender.userId && (r.nickname !== t._sender.nickname && (r.nickname = t._sender.nickname), r.profileUrl !== t._sender.profileUrl && (r.profileUrl = t._sender.profileUrl), v(r.metaData, t._sender.metaData) || (r.metaData = t._sender.metaData)), a.isGroupChannel() && V.getChannel(a.url, function (e, n) {
            if (S) {
              var r = e;
              e = n, n = r;
            }

            if (n) return void U(null, n, i);
            e.lastMessage = t;

            for (var a in Ie.getInstance().channelHandlers) {
              Ie.getInstance().channelHandlers[a].onChannelChanged(e);
            }
          }), U(t, null, i);
        }), f;
      }, this.updateUserMessage = function (e, n, t, r, i) {
        var a = Array.prototype.slice.call(arguments);
        "function" == typeof a.slice(-1)[0] && (i = a.pop());
        var s = null,
            o = null;

        switch (a.length) {
          case 2:
            if (a[1] instanceof he) n = a[1].message, t = a[1].data, r = a[1].customType, s = a[1]._mentionType, o = a[1]._mentionedIds;else {
              if ("string" != typeof a[1]) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), i);
              n = a[1];
            }
            break;

          case 3:
          case 4:
            break;

          default:
            return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), i);
        }

        if (!_(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), i);
        if ("string" != typeof n && null !== n && void 0 !== n || "string" != typeof t && null !== t && void 0 !== t || "string" != typeof r && null !== r && void 0 !== r || "string" != typeof s && null !== s && void 0 !== s || "string" == typeof s && [de.MentionType.CHANNEL, de.MentionType.USERS].indexOf(s) < 0 || !Array.isArray(o) && null !== o && void 0 !== o) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), i);
        var l = x.bUpdateUserMessage(this.url, e, n, t, r, s, o);
        Ie.getInstance().sendCommand(l, function (e, n) {
          if (n) return void U(null, new g(n.message, n.code), i);
          var t = new b(e.getJsonElement());
          U(t, null, i);
        });
      }, this.updateFileMessage = function (e, n, t, r) {
        var i = Array.prototype.slice.call(arguments);
        "function" == typeof i.slice(-1)[0] && (r = i.pop());
        var a = null,
            s = null;

        switch (i.length) {
          case 2:
            if (i[1] instanceof pe) n = i[1].data, t = i[1].customType, a = i[1]._mentionType, s = i[1]._mentionedIds;else {
              if ("string" != typeof i[1]) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
              n = i[1];
            }
            break;

          case 3:
            break;

          default:
            return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
        }

        if (!_(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
        if ("string" != typeof n && null !== n && void 0 !== n || "string" != typeof t && null !== t && void 0 !== t || "string" != typeof a && null !== a && void 0 !== a || "string" == typeof a && [de.MentionType.CHANNEL, de.MentionType.USERS].indexOf(a) < 0 || !Array.isArray(s) && null !== s && void 0 !== s) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
        var o = x.bUpdateFileMessage(this.url, e, n, t, a, s);
        Ie.getInstance().sendCommand(o, function (e, n) {
          if (n) return void U(null, new g(n.message, n.code), r);
          var t = new w(e.getJsonElement());
          U(t, null, r);
        });
      }, this.createMetaCounters = function (e, n) {
        if (null === e || "object" != typeof e || Array.isArray(e) || f(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);

        for (var t in e) {
          if ("number" != typeof e[t]) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        }

        se.getInstance().createMetaCounters(this.isOpenChannel(), this.url, e, function (e, t) {
          if (t) return void U(null, t, n);
          U(e, null, n);
        });
      }, this.updateMetaCounters = function (e, n, t) {
        if ("function" != typeof n && void 0 !== t || (t = n, n = !1), null == e || "object" != typeof e || Array.isArray(e) || f(e) || "boolean" != typeof n) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
        se.getInstance().updateMetaCounters(this.isOpenChannel(), this.url, e, n, se.UPDATE_META_COUNTER_MODE_SET, function (e, n) {
          if (n) return void U(null, n, t);
          U(e, null, t);
        });
      }, this.increaseMetaCounters = function (e, n) {
        if (null == e || "object" != typeof e || Array.isArray(e) || f(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().updateMetaCounters(this.isOpenChannel(), this.url, e, !1, se.UPDATE_META_COUNTER_MODE_INC, function (e, t) {
          if (t) return void U(null, t, n);
          U(e, null, n);
        });
      }, this.decreaseMetaCounters = function (e, n) {
        if (null == e || "object" != typeof e || Array.isArray(e) || f(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().updateMetaCounters(this.isOpenChannel(), this.url, e, !1, se.UPDATE_META_COUNTER_MODE_DEC, function (e, t) {
          if (t) return void U(null, t, n);
          var r = e,
              i = {};

          for (var a in r) {
            var s = r[a];
            i[a] = s;
          }

          U(i, null, n);
        });
      }, this.getMetaCounters = function (e, n) {
        if (!Array.isArray(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().getMetaCounters(this.isOpenChannel(), this.url, e, function (e, t) {
          if (t) return void U(null, t, n);
          U(e, null, n);
        });
      }, this.getAllMetaCounters = function (e) {
        se.getInstance().getAllMetaCounters(this.isOpenChannel(), this.url, function (n, t) {
          if (t) return void U(null, t, e);
          U(n, null, e);
        });
      }, this.deleteMetaCounter = function (e, n) {
        if ("string" != typeof e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().deleteMetaCounter(this.isOpenChannel(), this.url, e, function (e, t) {
          if (t) return void U(null, t, n);
          U(e, null, n);
        });
      }, this.deleteAllMetaCounters = function (e) {
        se.getInstance().deleteAllMetaCounters(this.isOpenChannel(), this.url, function (n, t) {
          if (t) return void (e && U(null, t, e));
          U(n, null, e);
        });
      }, this.createMetaData = function (e, n) {
        if (null == e || "object" != typeof e || Array.isArray(e) || f(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().createMetaData(this.isOpenChannel(), this.url, e, function (e, t) {
          if (t) return void U(null, t, n);
          U(e, null, n);
        });
      }, this.updateMetaData = function (e, n, t) {
        if ("function" != typeof n && void 0 !== t || (t = n, n = !1), null == e || "object" != typeof e || Array.isArray(e) || f(e) || "boolean" != typeof n) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
        se.getInstance().updateMetaData(this.isOpenChannel(), this.url, e, n, function (e, n) {
          if (n) return void U(null, n, t);
          U(e, null, t);
        });
      }, this.getMetaData = function (e, n) {
        if (!Array.isArray(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().getMetaData(this.isOpenChannel(), this.url, e, function (e, t) {
          if (t) return void U(null, t, n);
          U(e, null, n);
        });
      }, this.getAllMetaData = function (e) {
        se.getInstance().getAllMetaData(this.isOpenChannel(), this.url, function (n, t) {
          if (t) return void U(null, t, e);
          U(n, null, e);
        });
      }, this.deleteMetaData = function (e, n) {
        if ("string" != typeof e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().deleteMetaData(this.isOpenChannel(), this.url, e, function (e, t) {
          if (t) return void U(null, t, n);
          U(e, null, n);
        });
      }, this.deleteAllMetaData = function (e) {
        se.getInstance().deleteAllMetaData(this.isOpenChannel(), this.url, function (n, t) {
          if (t) return void (e && U(null, t, e));
          U(n, null, e);
        });
      }, this.deleteMessage = function (e, n) {
        var t = Array.prototype.slice.call(arguments);
        if (2 !== t.length) return "function" == typeof t.slice(-1)[0] && (n = t.pop()), void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        var r = this;
        if ("object" != typeof e || f(e) || Array.isArray(e) || Object.keys(e).indexOf("messageId") < 0 || !e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().deleteMessage(r.isOpenChannel(), r.url, e.messageId, function (e, t) {
          if (t) return void U(null, t, n);
          U(null, null, n);
        });
      };

      var r = function r(e, n, t, _r) {
        var i = null;
        n.isUserMessage() ? i = x.bUpdateUserMessage(e, n.messageId, null, null, null, null, null, t) : n.isFileMessage() && (i = x.bUpdateFileMessage(e, n.messageId, null, null, null, null, t)), i ? Ie.getInstance().sendCommand(i, function (e, t) {
          if (t) return void U(null, t, _r);
          var i = null;
          n.isUserMessage() ? i = new b(e.getJsonElement()) : i.isFileMessage() ? i = new w(e.getJsonElement()) : i.isAdminMessage() && (i = new M(e.getJsonElement())), U(i, null, _r);
        }) : U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), _r);
      };

      this.createMessageMetaArrayKeys = function (e, n, t) {
        var i = e && (e.isUserMessage() || e.isFileMessage() || e.isAdminMessage()),
            a = !0;

        for (var s in n) {
          var o = n[s];
          if (!(a = a && "string" == typeof o && "" !== o)) break;
        }

        if (!(i && n && Array.isArray(n) && a)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
        var l = {};
        if (Array.isArray(n)) for (var s in n) {
          var o = n[s];
          l[o] = [];
        }
        r(this.url, e, {
          array: l,
          mode: "add",
          upsert: !0
        }, t);
      }, this.deleteMessageMetaArrayKeys = function (e, n, t) {
        var i = e && (e.isUserMessage() || e.isFileMessage() || e.isAdminMessage()),
            a = !0;

        for (var s in n) {
          var o = n[s];
          if (!(a = a && "string" == typeof o && "" !== o)) break;
        }

        if (!(i && n && Array.isArray(n) && a)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
        var l = {};
        if (Array.isArray(n)) for (var s in n) {
          var o = n[s];
          l[o] = [];
        }
        r(this.url, e, {
          array: l,
          mode: "remove",
          upsert: !0
        }, t);
      }, this.addMessageMetaArrayValues = function (e, n, t) {
        var i = e && (e.isUserMessage() || e.isFileMessage() || e.isAdminMessage()),
            a = n && "object" == typeof n;
        if (a) for (var s in n) {
          if ("string" != typeof s || "" === s || !Array.isArray(n[s])) {
            a = !1;
            break;
          }

          for (var o in n[s]) {
            if ("string" != typeof n[s][o] || "" === n[s][o]) {
              a = !1;
              break;
            }
          }

          if (!a) break;
        }
        if (!i || !a) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
        r(this.url, e, {
          array: n,
          mode: "add",
          upsert: !0
        }, t);
      }, this.removeMessageMetaArrayValues = function (e, n, t) {
        var i = e && (e.isUserMessage() || e.isFileMessage() || e.isAdminMessage()),
            a = n && "object" == typeof n;
        if (a) for (var s in n) {
          if (!("string" == typeof s && "" !== s && Array.isArray(n[s]) && n[s].length > 0)) {
            a = !1;
            break;
          }

          for (var o in n[s]) {
            if ("string" != typeof n[s][o] || "" === n[s][o]) {
              a = !1;
              break;
            }
          }

          if (!a) break;
        }
        if (!i || !a) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
        r(this.url, e, {
          array: n,
          mode: "remove",
          upsert: !0
        }, t);
      }, this.channelType = F.CHANNEL_TYPE_BASE, e && this._update(e);
    };

    F.CHANNEL_TYPE_OPEN = "open", F.CHANNEL_TYPE_GROUP = "group", F.CHANNEL_TYPE_BASE = "base";

    var k = function k(e) {
      this.parse = function (e) {
        if (e.hasOwnProperty("participant_count") && (this.participantCount = parseInt(e.participant_count)), e.hasOwnProperty("operators") && e.operators) {
          this.operators = [];

          for (var n in e.operators) {
            var t = new q(e.operators[n]);
            this.operators.push(t);
          }
        }
      }, this.refresh = function (e) {
        k.getChannelWithoutCache(this.url, function (n, t) {
          if (S) {
            var r = n;
            n = t, t = r;
          }

          if (t) return void U(null, t, e);
          U(n, null, e);
        });
      }, this.update = function (e) {
        this._update(e), this.parse(e);
      }, this["delete"] = function (e) {
        var n = this.url;
        se.getInstance().deleteOpenChannel(n, function (t, r) {
          if (r) return void U(null, r, e);
          delete k.cachedChannels[n], Ie.getInstance()._deleteFileQueue(n), U(t, null, e);
        });
      }, this.enter = function (e) {
        var n = this,
            t = x.bEnter(n.url);
        Ie.getInstance().sendCommand(t, function (t, r) {
          if (r) return void U(null, new g(r.message, r.code), e);
          k.enteredChannels[n.url] = n, U(null, null, e);
        });
      }, this.exit = function (e) {
        var n = this,
            t = x.bExit(n.url);
        Ie.getInstance().sendCommand(t, function (t, r) {
          if (r) return void U(null, new g(r.message, r.code), e);
          delete k.enteredChannels[n.url], Ie.getInstance()._deleteFileQueue(n.url), U(null, null, e);
        });
      }, this.createParticipantListQuery = function () {
        return new ee(ee.PARTICIPANT, this);
      }, this.createMutedUserListQuery = function () {
        return new ee(ee.MUTED_USER, this);
      }, this.createBannedUserListQuery = function () {
        return new ee(ee.BANNED_USER, this);
      }, this.updateChannel = function () {
        var e = Array.prototype.slice.call(arguments),
            n = null,
            t = null,
            r = null,
            i = null,
            a = null,
            s = null;

        switch ("function" == typeof e.slice(-1)[0] && (s = e.pop()), e.length) {
          case 3:
            n = e[0], t = e[1], r = e[2];
            break;

          case 4:
            n = e[0], t = e[1], r = e[2], i = e[3];
            break;

          case 5:
            n = e[0], t = e[1], r = e[2], i = e[3], a = e[4];
            break;

          default:
            return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), s);
        }

        this.updateChannelWithOperatorUserIds(n, t, r, i, a, s);
      }, this.updateChannelWithOperatorUserIds = function (e, n, t, r, i, a) {
        if ("function" == typeof i && (a = i, i = null), "string" != typeof e && null !== e && void 0 !== e || "string" != typeof n && f(n) && null !== n && void 0 !== n || "string" != typeof t && null !== t && void 0 !== t || "string" != typeof r && !Array.isArray(r) && null !== r && void 0 !== r || "string" != typeof i && null !== i && void 0 !== i) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), a);
        se.getInstance().updateOpenChannel(this.url, e, n, t, r, i, function (e, n) {
          if (n) return void U(null, n, a);
          var t = k.upsert(e);
          U(t, null, a);
        });
      }, this.banUser = function (e, n, t) {
        if ("function" == typeof n && (t = n, n = -1), !e || !e.hasOwnProperty("userId")) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
        this.banUserWithUserId(e.userId, n, t);
      }, this.banUserWithUserId = function (e, n, t) {
        var r = this;
        if ("function" == typeof n && (t = n, n = -1), !e || "number" != typeof n || parseInt(n) < 0 && -1 !== parseInt(n)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
        se.getInstance().banUser(r.url, e, null, n, !1, function (e, n) {
          if (n) return void U(null, n, t);
          U(null, null, t);
        });
      }, this.unbanUser = function (e, n) {
        if (!e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        this.unbanUserWithUserId(e.userId, n);
      }, this.unbanUserWithUserId = function (e, n) {
        if (!e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().unbanUser(this.url, e, !1, function (e, t) {
          if (t) return void U(null, t, n);
          U(null, null, n);
        });
      }, this.muteUser = function (e, n, t, r) {
        if ("function" == typeof n && (r = n, n = -1, t = ""), !e || !e.hasOwnProperty("userId") || "number" != typeof n || n < 0 && -1 !== n || "string" != typeof t) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
        this.muteUserWithUserId(e.userId, n, t, r);
      }, this.muteUserWithUserId = function (e, n, t, r) {
        if ("function" == typeof n && (r = n, n = -1, t = ""), !e || "number" != typeof n || n < 0 && -1 !== n || "string" != typeof t) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
        se.getInstance().muteUser(this.url, e, !1, n, t, function (e, n) {
          if (n) return void U(null, n, r);
          U(null, null, r);
        });
      }, this.unmuteUser = function (e, n) {
        if (!e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        this.unmuteUserWithUserId(e.userId, n);
      }, this.unmuteUserWithUserId = function (e, n) {
        if (!e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().unmuteUser(this.url, e, !1, function (e, t) {
          if (t) return void U(null, t, n);
          U(null, null, n);
        });
      }, this.isOperator = function (e) {
        return !!e && this.isOperatorWithUserId(e.userId);
      }, this.isOperatorWithUserId = function (e) {
        for (var n in this.operators) {
          if (this.operators[n].userId === e) return !0;
        }

        return !1;
      }, this.channelType = F.CHANNEL_TYPE_OPEN, this.participantCount = 0, this.operators = [], e && (this._update(e), this.parse(e));
    };

    I(F, k), k.enteredChannels = {}, k.clearEnteredChannels = function () {
      k.enteredChannels = {};
    }, k.createOpenChannelListQuery = function () {
      return new Z();
    }, k.buildFromSerializedData = function (e) {
      var n = A(e);
      return new k({
        channel_url: n.url,
        name: n.name,
        cover_url: n.coverUrl,
        data: n.data,
        custom_type: n.customType,
        created_at: n.createdAt / 1e3,
        freeze: n.isFrozen,
        is_ephemeral: n.isEphemeral,
        participant_count: n.participantCount,
        operators: n.operators.map(function (e) {
          return q.build(e.userId, e.nickname, e.profileUrl, e.connectionStatus, e.lastSeenAt, e.metaData, e.isActive, e.friendDiscoveryKey, e.friendName);
        })
      });
    }, k.createChannel = function () {
      var e, n, t, r, i, a;

      switch (arguments.length) {
        case 1:
          a = arguments[0];
          break;

        case 4:
          e = arguments[0], n = arguments[1], t = arguments[2], a = arguments[3];
          break;

        case 5:
          e = arguments[0], n = arguments[1], t = arguments[2], r = arguments[3], a = arguments[4];
          break;

        case 6:
          e = arguments[0], n = arguments[1], t = arguments[2], r = arguments[3], i = arguments[4], a = arguments[5];
      }

      k.createChannelWithOperatorUserIds(e, n, t, r, i, a);
    }, k.upsert = function (e) {
      var n = new k(e);
      return k.cachedChannels.hasOwnProperty(n.url) ? k.cachedChannels[n.url].update(e) : k.cachedChannels[n.url] = n, k.cachedChannels[n.url];
    }, k.createChannelWithOperatorUserIds = function (e, n, t, r, i, a) {
      if ("function" == typeof i && (a = i, i = ""), "string" != typeof e && null !== e && void 0 !== e || "string" != typeof n && f(n) && null !== n && void 0 !== n || "string" != typeof t && null !== t && void 0 !== t || "string" != typeof r && !Array.isArray(r) && null !== r && void 0 !== r || "string" != typeof i && null !== i && void 0 !== i) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), a);
      se.getInstance().createOpenChannel(e, n, t, r, i, function (e, n) {
        if (n) return void U(null, n, a);
        var t = k.upsert(e);
        U(t, null, a);
      });
    }, k.cachedChannels = {}, k.clearCache = function () {
      k.cachedChannels = {}, Ie.getInstance()._clearFileQueue();
    }, k.removeCachedChannel = function (e) {
      delete k.cachedChannels[e], Ie.getInstance()._deleteFileQueue(e);
    }, k.getChannel = function (e, n) {
      if (!e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
      k.cachedChannels.hasOwnProperty(e) ? U(k.cachedChannels[e], null, n) : k.getChannelWithoutCache(e, n);
    }, k.getChannelWithoutCache = function (e, n) {
      if (!e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
      se.getInstance().getOpenChannel(e, function (t, r) {
        if (r) return void U(null, r, n);
        k.upsert(t), U(k.cachedChannels[e], null, n);
      });
    };

    var G = function G() {
      this.channelCustomTypesFilter = [], this.superChannelFilter = V.superChannelFilter.ALL;
    },
        V = function V(e) {
      var n = {},
          r = 0,
          i = 0;
      this.parse = function (e) {
        var n = this;

        if (n.isAccessCodeRequired = !!e.is_access_code_required && e.is_access_code_required, n.isDistinct = !!e.is_distinct && e.is_distinct, n.isPushEnabled = !!e.is_push_enabled && e.is_push_enabled, n.isHidden = !!e.hasOwnProperty("is_hidden") && e.is_hidden, n.myCountPreference = e.hasOwnProperty("count_preference") ? e.count_preference : V.CountPreference.ALL, n.unreadMessageCount = 0, n.unreadMentionCount = 0, y(n, parseInt(e.unread_message_count), parseInt(e.unread_mention_count)), e.hasOwnProperty("read_receipt")) {
          n.cachedReadReceiptStatus = {};

          for (var t in e.read_receipt) {
            var r = e.read_receipt[t];
            n.updateReadReceipt(t, parseInt(r));
          }
        }

        if (e.hasOwnProperty("members")) {
          n.members = [], n.memberMap = {};
          e.members.forEach(function (e) {
            var t = new j(e);
            n.members.push(t), n.memberMap[t.userId] = t;
          });
        }

        e.hasOwnProperty("member_state") ? n.myMemberState = e.member_state : n.myMemberState = "none", e.hasOwnProperty("my_role") ? n.myRole = e.my_role || V.Role.NONE : n.myRole = V.Role.NONE, e.hasOwnProperty("is_muted") ? "string" == typeof e.is_muted ? n.myMutedState = e.is_muted : "boolean" == typeof e.is_muted && (n.myMutedState = e.is_muted ? "muted" : "unmuted") : n.myMutedState = "unmuted", e.hasOwnProperty("member_count") && (n.memberCount = parseInt(e.member_count)), e.hasOwnProperty("joined_member_count") && (n.joinedMemberCount = parseInt(e.joined_member_count)), e.hasOwnProperty("last_message") && "object" == typeof e.last_message && e.last_message ? e.last_message instanceof L ? n.lastMessage = e.last_message : n.lastMessage = L.build(e.last_message, n) : n.lastMessage = null, e.hasOwnProperty("inviter") && null !== e.inviter && "object" == typeof e.inviter && !f(e.inviter) ? n.inviter = new q(e.inviter) : n.inviter = null, n.invitedAt = e.invited_at || 0, e.hasOwnProperty("is_super") && null !== e.is_super && "boolean" == typeof e.is_super ? n.isSuper = e.is_super : n.isSuper = !1, e.hasOwnProperty("is_public") && null !== e.is_public && "boolean" == typeof e.is_public ? n.isPublic = e.is_public : n.isPublic = !1;
      }, this.isIdentical = function (e) {
        return !("object" != typeof e || !e.hasOwnProperty("url")) && e.url === this.url;
      }, this.isEqual = function (e) {
        return v(this, e);
      }, this.refresh = function (e) {
        V.getChannelWithoutCache(this.url, function (n, t) {
          if (S) {
            var r = n;
            n = t, t = r;
          }

          if (t) return void U(null, t, e);
          U(n, null, e);
        });
      }, this.update = function (e) {
        this._update(e), this.parse(e);
      }, this.registerScheduledUserMessage = function (e, n) {
        var t = this;
        if (!(e instanceof fe)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);

        var r = e.message,
            i = e._getScheduleString();

        if ("string" != typeof r || "string" != typeof i) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().registerScheduledUserMessage(e, {
          channelUrl: t.url,
          isOpenChannel: t.isOpenChannel()
        }, function (e, t) {
          if (t) return void U(null, t, n);
          var r = new D(e),
              i = Ie.getInstance().currentUser;
          i && r._sender && i.userId === r._sender.userId && (i.nickname !== r._sender.nickname && (i.nickname = r._sender.nickname), i.profileUrl !== r._sender.profileUrl && (i.profileUrl = r._sender.profileUrl), v(i.metaData, r._sender.metaData) || (i.metaData = r._sender.metaData)), U(r, null, n);
        });
      }, this.updateChannel = function () {
        var e = this,
            n = Array.prototype.slice.call(arguments),
            t = null,
            r = null,
            i = null,
            a = null,
            s = null,
            o = null,
            l = null,
            u = null;

        switch ("function" == typeof n.slice(-1)[0] && (o = n.pop()), n.length) {
          case 1:
            if (!(n[0] instanceof ce)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), o);
            var c = n[0];
            t = c.isDistinct, r = c.name, i = c.channelCover, a = c.data, s = c.customType, l = c.isPublic, u = c.accessCode;
            break;

          case 3:
            t = e.isDistinct, r = n[0], i = n[1], a = n[2];
            break;

          case 4:
            t = n[0], r = n[1], i = n[2], a = n[3];
            break;

          case 5:
            t = n[0], r = n[1], i = n[2], a = n[3], s = n[4];
            break;

          default:
            return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), o);
        }

        if ("string" != typeof r && null !== r && void 0 !== r || "string" != typeof i && f(i) && null !== i && void 0 !== i || "string" != typeof a && null !== a && void 0 !== a || "boolean" != typeof t && null !== t || "boolean" != typeof l && null !== l || "string" != typeof s && null !== s && void 0 !== s || "string" != typeof u && null !== u && void 0 !== u) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), o);
        se.getInstance().updateGroupChannel(e.url, t, r, i, a, s, l, u, function (e, n) {
          if (n) return void U(null, n, o);
          var t = V.upsert(e);
          U(t, null, o);
        });
      }, this.resetMyHistory = function (e) {
        se.getInstance().resetMyHistory(this.url, function (n, t) {
          if (t) return void U(null, t, e);
          U(n, null, e);
        });
      }, this.invite = function (e, n) {
        if ("string" == typeof e && e && (e = [{
          userId: e
        }]), !Array.isArray(e) || f(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        var t = [];

        for (var r in e) {
          if ("object" != typeof e[r] || f(e[r])) {
            U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
            break;
          }

          t.push(e[r].userId);
        }

        this.inviteWithUserIds(t, n);
      }, this.inviteWithUserIds = function (e, n) {
        if (!Array.isArray(e) || f(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().groupChannelInvite(this.url, e, function (e, t) {
          if (t) return void U(null, t, n);
          var r = V.upsert(e);
          U(r, null, n);
        });
      }, this.acceptInvitation = function (e, n) {
        "function" == typeof e && (n = e, e = null), se.getInstance().acceptInvitation(this.url, e, function (e, t) {
          if (t) return void U(null, t, n);
          var r = V.upsert(e);
          r.myMemberState = "joined", V.cachedChannels[r.url] = r, U(r, null, n);
        });
      }, this.declineInvitation = function (e) {
        var n = this;
        se.getInstance().declineInvitation(this.url, function (t, r) {
          if (r) return void U(null, r, e);
          n.myMemberState = "none", V.cachedChannels[n.url] = n, n.isPublic || V.removeCachedChannel(n.url), U(t, null, e);
        });
      }, this.hide = function (e, n) {
        if (1 === arguments.length && "function" == typeof e && (n = e, e = !1), null !== e && void 0 !== e || (e = !1), "boolean" != typeof e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        var t = this.url,
            r = this;
        se.getInstance().groupChannelHide(t, e, function (i, a) {
          if (a) return void U(null, a, n);
          r.isHidden = !0;
          var s = V.cachedChannels[t];
          s && (s.isHidden = !0, e && y(s, 0, 0), V.cachedChannels[t] = s), U(i, null, n);
        });
      }, this.join = function (e, n) {
        "function" == typeof e && (n = e, e = null);
        var t = this.url;
        se.getInstance().publicGroupChannelJoin(t, e, function (e, t) {
          if (t) return void U(null, t, n);
          var r = V.upsert(e);
          r.myMemberState = "joined", V.cachedChannels[r.url] = r, U(r, null, n);
        });
      }, this.leave = function (e) {
        var n = this.url;
        se.getInstance().groupChannelLeave(n, function (n, t) {
          if (t) return void U(null, t, e);
          U(null, null, e);
        });
      }, this.markAsRead = function () {
        this._sendMarkAsRead(null);
      }, this._sendMarkAsRead = function (e) {
        var n = this,
            t = x.bRead(n.url);
        Ie.getInstance().sendCommand(t, function (t, r) {
          if (r) return void U(null, new g(r.message, r.code), e);

          if (n.updateReadReceipt(Ie.getInstance().getCurrentUserId(), t.getJsonElement().ts), n.unreadMessageCount > 0 || n.unreadMentionCount > 0) {
            y(n, 0, 0);

            for (var i in Ie.getInstance().channelHandlers) {
              Ie.getInstance().channelHandlers[i].onChannelChanged(n);
            }
          }

          U(null, null, e);
        });
      }, this.getReadReceipt = function (e) {
        if (!(e instanceof L)) return t.log("message is not BaseMessage instance"), 0;
        if (e.messageType === L.MESSAGE_TYPE_ADMIN) return 0;
        var n = Ie.getInstance().currentUser,
            r = 0,
            i = e.createdAt,
            a = this.members;

        for (var s in a) {
          var o = a[s],
              l = o.userId;

          if (!(n.userId === l || e.sender && e.sender.userId === l)) {
            var u = this.cachedReadReceiptStatus[l];
            u || (u = 0), u < i && r++;
          }
        }

        return this.isSuper ? 0 : r;
      }, this.getReadMembers = function (e, n) {
        "boolean" != typeof n && (n = !1);
        var t = [];
        if (!Ie.getInstance().currentUser || this.isSuper || !e || e.isAdminMessage()) return t;
        var r = this.members;

        for (var i in r) {
          var a = r[i];

          if (n || a.userId !== Ie.getInstance().currentUser.userId && a.userId !== e.sender.userId) {
            var s = this.cachedReadReceiptStatus[a.userId];
            s || (s = 0), s >= e.createdAt && t.push(a);
          }
        }

        return t;
      }, this.getUnreadMembers = function (e, n) {
        "boolean" != typeof n && (n = !1);
        var t = [];
        if (!Ie.getInstance().currentUser || this.isSuper || !e || e.isAdminMessage()) return t;
        var r = this.members;

        for (var i in r) {
          var a = r[i];

          if (n || a.userId !== Ie.getInstance().currentUser.userId && a.userId !== e.sender.userId) {
            var s = this.cachedReadReceiptStatus[a.userId];
            s || (s = 0), s < e.createdAt && t.push(a);
          }
        }

        return t;
      }, this.getReadStatus = function (e) {
        "boolean" != typeof e && (e = !1);
        var n = {};
        if (!Ie.getInstance().currentUser || this.isSuper) return n;
        var t = this.members;

        for (var r in t) {
          var i = t[r],
              a = i.userId;

          if (e || a !== Ie.getInstance().currentUser.userId) {
            var s = this.cachedReadReceiptStatus[a];
            n[a] = {
              user: i,
              last_seen_at: parseInt(s)
            };
          }
        }

        return n;
      }, this.updateReadReceipt = function (e, n) {
        var t = e,
            r = this.cachedReadReceiptStatus[t],
            i = n;
        (!r || r < i) && (this.cachedReadReceiptStatus[t] = i);
      }, this.startTyping = function () {
        var e = new Date().getTime(),
            n = Ie.getInstance().Options.typingIndicatorThrottle;

        if (("number" != typeof n || n < s || n > o) && (n = 1e3), e - r >= n) {
          i = 0, r = e;
          var t = x.bTypeStart(this.url, r);
          Ie.getInstance().sendCommand(t, null);
        }
      }, this.endTyping = function () {
        var e = new Date().getTime(),
            n = Ie.getInstance().Options.typingIndicatorThrottle;

        if (("number" != typeof n || n < s || n > o) && (n = 1e3), e - i >= n) {
          r = 0, i = e;
          var t = x.bTypeEnd(this.url, i);
          Ie.getInstance().sendCommand(t, null);
        }
      }, this.invalidateTypingStatus = function () {
        var e = !1,
            t = new Date().getTime();

        for (var r in n) {
          t - n[r] >= 1e4 && (delete n[r], e = !0);
        }

        return e;
      }, this.updateTypingStatus = function (e, t) {
        t ? n[e.userId] = new Date().getTime() : delete n[e.userId];
      }, this.isTyping = function () {
        return 0 !== Object.keys(n).length;
      }, this.getTypingMembers = function () {
        var e = [];

        for (var t in n) {
          var r = this.memberMap[t];
          this.memberMap[t] && e.push(r);
        }

        return e;
      }, this.addMember = function (e) {
        if (!this.isSuper) {
          var n = this.removeMember(e);
          n && n.state === j.JOINED && (e.state = j.JOINED), this.memberMap[e.userId] = e, this.members.push(e), this.memberCount++, this.updateReadReceipt(e.userId, 0);
        }
      }, this.removeMember = function (e) {
        var n = null;

        if (!this.isSuper) {
          var t = e.userId;

          if (this.memberMap.hasOwnProperty(e.userId)) {
            delete this.memberMap[e.userId];

            for (var r in this.members) {
              var i = this.members[r];

              if (i.userId === t) {
                n = i, this.members.splice(r, 1);
                break;
              }
            }

            this.memberCount--;
          }
        }

        return n;
      }, this.updateJoinedMemberCount = function () {
        if (!this.isSuper) {
          for (var e = 0, n = this.members.length, t = 0; t < n; t++) {
            this.members[t].state === j.JOINED && e++;
          }

          this.joinedMemberCount = e;
        }
      };
      var a = 0;
      this.setLatestMemberCount = function (e, n, t) {
        "number" == typeof e && "number" == typeof n && "number" == typeof t && t >= a && (a = t, this.memberCount = e, this.joinedMemberCount = n);
      }, this.setPushPreference = function (e, n) {
        var t = this;
        se.getInstance().setPushPreference(this.url, e, function (e, r) {
          if (r) return void U(null, r, n);
          t.isPushEnabled = e.enable, U(e, null, n);
        });
      }, this.getPushPreference = function (e) {
        var n = this;
        se.getInstance().getPushPreference(this.url, function (t, r) {
          if (r) return void U(null, r, e);

          if (e) {
            var i;

            try {
              i = t.enable;
            } catch (e) {
              i = !1;
            }

            n.isPushEnabled = i, U(i, null, e);
          }
        });
      }, this.setMyCountPreference = function (e, n) {
        if ([V.CountPreference.ALL, V.CountPreference.UNREAD_MESSAGE_COUNT_ONLY, V.CountPreference.UNREAD_MENTION_COUNT_ONLY, V.CountPreference.OFF].indexOf(e) < 0) return void U(null, new g("Invalid parameters.", N.INVALID_PARAMETER), n);
        var t = this;
        se.getInstance().setCountPreference(this.url, e, function (e, r) {
          if (r) return void U(null, r, n);
          t.myCountPreference = e.count_preference, y(t, t.unreadMessageCount, t.unreadMentionCount), U(t.myCountPreference, null, n);
        });
      }, this.createMemberListQuery = function () {
        var e = this.url;
        return new W(e);
      }, this.banUser = function (e, n, t, r) {
        if (!e || !e.hasOwnProperty("userId")) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
        this.banUserWithUserId(e.userId, n, t, r);
      }, this.banUserWithUserId = function (e, n, t, r) {
        var i = this;
        if (!e || "string" != typeof e || "number" != typeof n || "string" != typeof t) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
        se.getInstance().banUser(i.url, e, t, n, !0, function (n, t) {
          if (t) return void U(null, t, r);
          i.removeMember({
            userId: e
          }), U(null, null, r);
        });
      }, this.unbanUser = function (e, n) {
        if (!e || !e.hasOwnProperty("userId")) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        this.unbanUserWithUserId(e.userId, n);
      }, this.unbanUserWithUserId = function (e, n) {
        if (!e || "string" != typeof e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().unbanUser(this.url, e, !0, function (e, t) {
          if (t) return void U(null, t, n);
          U(null, null, n);
        });
      }, this.muteUser = function (e, n, t, r) {
        if ("function" == typeof n && (r = n, n = -1, t = ""), !e || !e.hasOwnProperty("userId") || "number" != typeof n || n < 0 && -1 !== n || "string" != typeof t) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
        this.muteUserWithUserId(e.userId, n, t, r);
      }, this.muteUserWithUserId = function (e, n, t, r) {
        if ("function" == typeof n && (r = n, n = -1, t = ""), !e || "string" != typeof e || "number" != typeof n || n < 0 && -1 !== n || "string" != typeof t) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
        se.getInstance().muteUser(this.url, e, !0, n, t, function (e, n) {
          if (n) return void U(null, n, r);
          U(null, null, r);
        });
      }, this.unmuteUser = function (e, n) {
        if (!e || !e.hasOwnProperty("userId")) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        this.unmuteUserWithUserId(e.userId, n);
      }, this.unmuteUserWithUserId = function (e, n) {
        if (!e || "string" != typeof e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().unmuteUser(this.url, e, !0, function (e, t) {
          if (t) return void U(null, t, n);
          U(null, null, n);
        });
      }, this.freeze = function (e) {
        se.getInstance().freeze(this.url, !0, !0, function (n, t) {
          if (t) return void U(null, t, e);
          V.upsert(n), U(null, null, e);
        });
      }, this.unfreeze = function (e) {
        se.getInstance().freeze(this.url, !0, !1, function (n, t) {
          if (t) return void U(null, t, e);
          V.upsert(n), U(null, null, e);
        });
      }, this.createBannedUserListQuery = function () {
        return new ee(ee.BANNED_USER, this);
      }, this.channelType = F.CHANNEL_TYPE_GROUP, this.isDistinct = !1, this.isSuper = !1, this.isPublic = !1, this.unreadMessageCount = 0, this.inviter = null, this.members = [], this.memberMap = {}, this.lastMessage = {}, this.memberCount = 0, this.joinedMemberCount = 0, this.cachedReadReceiptStatus = {}, this.isPushEnabled, this.isHidden = !1, e && (this._update(e), this.parse(e));
    };

    I(F, V), V.buildFromSerializedData = function (e) {
      var n = A(e);
      return new V({
        channel_url: n.url,
        name: n.name,
        cover_url: n.coverUrl,
        data: n.data,
        custom_type: n.customType,
        invited_at: n.invitedAt,
        created_at: n.createdAt / 1e3,
        is_access_code_required: n.isAccessCodeRequired,
        is_distinct: n.isDistinct,
        is_super: n.isSuper,
        is_public: n.isPublic,
        freeze: n.isFrozen,
        is_ephemeral: n.isEphemeral,
        unread_message_count: n.unreadMessageCount,
        unread_mention_count: n.unreadMentionCount,
        is_push_enabled: n.isPushEnabled,
        count_preference: n.myCountPreference,
        is_hidden: n.isHidden,
        member_count: n.memberCount,
        joined_member_count: n.joinedMemberCount,
        member_state: n.myMemberState,
        my_role: n.myRole,
        is_muted: n.myMutedState,
        members: n.members.map(function (e) {
          return j.build(q.build(e.userId, e.nickname, e.profileUrl, e.connectionStatus, e.lastSeenAt, e.metaData, e.isActive, e.friendDiscoveryKey, e.friendName), e.state, e.isBlockedByMe, e.isBlockingMe);
        }),
        last_message: function (e) {
          return null !== e && void 0 !== e && "object" == typeof e ? e.messageType === L.MESSAGE_TYPE_USER ? new b(b.build(e.reqId, e.messageId, e.sender, {
            url: e.channelUrl,
            channelType: e.channelType
          }, e.message, e.data, e.customType, e.translations, e.createdAt, e.updatedAt, e.mentionType, e.mentionedUsers)) : e.messageType === L.MESSAGE_TYPE_FILE ? new w(w.build(e.reqId, e.messageId, e.sender, {
            url: e.channelUrl,
            channelType: e.channelType
          }, e.url, e.name, e.type, e.size, e.data, e.customType, e.createdAt, e.thumbnails, e.requireAuth, e.updatedAt, e.mentionType, e.mentionedUsers)) : new M(M.build(e.messageId, {
            url: e.channelUrl,
            channelType: e.channelType
          }, e.message, e.data, e.customType, e.translations, e.createdAt, e.updatedAt, e.mentionType, e.mentionedUsers)) : null;
        }(n.lastMessage),
        read_receipt: n.cachedReadReceiptStatus,
        inviter: null !== n.inviter && "undefined" != typeof n.inviter && "object" == typeof n.inviter ? q.build(n.inviter.userId, n.inviter.nickname, n.inviter.profileUrl, n.inviter.connectionStatus, n.inviter.lastSeenAt, n.inviter.metaData, n.inviter.isActive, n.inviter.friendDiscoveryKey, n.inviter.friendName) : null
      });
    }, V.createMyGroupChannelListQuery = function () {
      return new J();
    }, V.createPublicGroupChannelListQuery = function () {
      return new Q();
    }, V.memberState = {
      ALL: 0,
      JOINED: 1,
      INVITED: 2,
      INVITED_BY_FRIEND: 3,
      INVITED_BY_NON_FRIEND: 4
    }, V.memberStateFilter = {
      ALL: "all",
      JOINED: "joined_only",
      INVITED: "invited_only",
      INVITED_BY_FRIEND: "invited_by_friend",
      INVITED_BY_NON_FRIEND: "invited_by_non_friend"
    }, V.superChannelFilter = {
      ALL: "all",
      SUPER: "super",
      NON_SUPER: "nonsuper"
    }, V.publicChannelFilter = {
      ALL: "all",
      PUBLIC: "public",
      PRIVATE: "private"
    }, V.Role = {
      OPERATOR: "operator",
      NONE: "none"
    }, V.UnreadItemKey = {
      GROUP_CHANNEL_UNREAD_MENTION_COUNT: "group_channel_unread_mention_count",
      NONSUPER_UNREAD_MENTION_COUNT: "non_super_group_channel_unread_mention_count",
      SUPER_UNREAD_MENTION_COUNT: "super_group_channel_unread_mention_count",
      GROUP_CHANNEL_UNREAD_MESSAGE_COUNT: "group_channel_unread_message_count",
      NONSUPER_UNREAD_MESSAGE_COUNT: "non_super_group_channel_unread_message_count",
      SUPER_UNREAD_MESSAGE_COUNT: "super_group_channel_unread_message_count",
      GROUP_CHANNEL_INVITATION_COUNT: "group_channel_invitation_count",
      NONSUPER_INVITATION_COUNT: "non_super_group_channel_invitation_count",
      SUPER_INVITATION_COUNT: "super_group_channel_invitation_count"
    }, V.CountPreference = {
      ALL: "all",
      UNREAD_MESSAGE_COUNT_ONLY: "unread_message_count_only",
      UNREAD_MENTION_COUNT_ONLY: "unread_mention_count_only",
      OFF: "off"
    }, V.UnreadChannelFilter = {
      ALL: "all",
      UNREAD_MESSAGE: "unread_message"
    }, V.getChannelCount = function (e, n) {
      "function" == typeof e && 1 === arguments.length && (n = e, e = V.memberState.ALL), Ie.getInstance().getGroupChannelCount(e, n);
    }, V.getUnreadItemCount = function (e, n) {
      Ie.getInstance().getUnreadItemCount(e, n);
    }, V.getTotalUnreadMessageCount = function (e, n) {
      Ie.getInstance().getTotalUnreadMessageCount(e, n);
    }, V.getTotalUnreadChannelCount = function (e) {
      Ie.getInstance().getTotalUnreadChannelCount(e);
    }, V.createChannel = function () {
      var e = null,
          n = [],
          t = null,
          r = null,
          i = null,
          a = null,
          s = null,
          o = null,
          l = null,
          u = {
        isPublic: null,
        channelUrl: null
      },
          c = [],
          d = null,
          h = null;

      switch (arguments.length) {
        case 2:
          if (arguments[0] instanceof ce) {
            var p = arguments[0];
            n = p._inviteUserIds, e = [], t = p.isDistinct, r = p.isSuper, i = p.name, a = p.channelCover, s = p.data, l = p.customType, c = p._operatorIds, u.isPublic = p.isPublic, u.channelUrl = p.channelUrl, d = p.isEphemeral, h = p.accessCode, o = arguments[1];
            break;
          }

          e = arguments[0], t = !1, o = arguments[1];
          break;

        case 3:
          e = arguments[0], t = arguments[1], o = arguments[2];
          break;

        case 4:
          e = arguments[0], t = arguments[1], l = arguments[2], o = arguments[3];
          break;

        case 6:
          e = arguments[0], t = arguments[1], i = arguments[2], a = arguments[3], s = arguments[4], o = arguments[5];
          break;

        case 7:
          e = arguments[0], t = arguments[1], i = arguments[2], a = arguments[3], s = arguments[4], l = arguments[5], o = arguments[6];
      }

      if (!Array.isArray(e) || "boolean" != typeof t && null !== t || "boolean" != typeof r && null !== r || "boolean" != typeof d && null !== d || "boolean" != typeof u.isPublic && null !== u.isPublic || "string" != typeof u.channelUrl && null !== u.channelUrl || "string" != typeof i && null !== i && void 0 !== i || "string" != typeof a && f(a) && null !== a && void 0 !== a || "string" != typeof s && null !== s && void 0 !== s || "string" != typeof l && null !== l && void 0 !== l || "string" != typeof h && null !== h && void 0 !== h) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), o);
      e.forEach(function (e) {
        n.push(e.userId);
      }), V.createChannelWithUserIds(n, t, i, a, s, l, r, u, c, d, h, o);
    }, V.createChannelWithUserIds = function () {
      var e = null,
          n = null,
          t = null,
          r = null,
          i = null,
          a = null,
          s = null,
          o = null,
          l = [],
          u = {
        isPublic: null,
        channelUrl: null
      },
          c = null,
          d = null;

      switch (arguments.length) {
        case 2:
          e = arguments[0], n = !1, a = arguments[1];
          break;

        case 3:
          e = arguments[0], n = arguments[1], a = arguments[2];
          break;

        case 4:
          e = arguments[0], n = arguments[1], s = arguments[2], a = arguments[3];
          break;

        case 6:
          e = arguments[0], n = arguments[1], t = arguments[2], r = arguments[3], i = arguments[4], a = arguments[5];
          break;

        case 7:
          e = arguments[0], n = arguments[1], t = arguments[2], r = arguments[3], i = arguments[4], s = arguments[5], a = arguments[6];
          break;

        case 8:
          e = arguments[0], n = arguments[1], t = arguments[2], r = arguments[3], i = arguments[4], s = arguments[5], o = arguments[6], a = arguments[7];
          break;

        case 9:
          e = arguments[0], n = arguments[1], t = arguments[2], r = arguments[3], i = arguments[4], s = arguments[5], o = arguments[6], u.isPublic = arguments[7].isPublic, u.channelUrl = arguments[7].channelUrl, a = arguments[8];
          break;

        case 10:
          e = arguments[0], n = arguments[1], t = arguments[2], r = arguments[3], i = arguments[4], s = arguments[5], o = arguments[6], u.isPublic = arguments[7].isPublic, u.channelUrl = arguments[7].channelUrl, l = arguments[8], a = arguments[9];
          break;

        case 11:
          e = arguments[0], n = arguments[1], t = arguments[2], r = arguments[3], i = arguments[4], s = arguments[5], o = arguments[6], u.isPublic = arguments[7].isPublic, u.channelUrl = arguments[7].channelUrl, l = arguments[8], c = arguments[9], a = arguments[10];
          break;

        case 12:
          e = arguments[0], n = arguments[1], t = arguments[2], r = arguments[3], i = arguments[4], s = arguments[5], o = arguments[6], u.isPublic = arguments[7].isPublic, u.channelUrl = arguments[7].channelUrl, l = arguments[8], c = arguments[9], d = arguments[10], a = arguments[11];
      }

      if (!Array.isArray(e) || "boolean" != typeof n && null !== n || "boolean" != typeof o && null !== o || "boolean" != typeof c && null !== c || "boolean" != typeof u.isPublic && null !== u.isPublic || "string" != typeof u.channelUrl && null !== u.channelUrl || "string" != typeof t && null !== t && void 0 !== t || "string" != typeof r && f(r) && null !== r && void 0 !== r || "string" != typeof i && null !== i && void 0 !== i || "string" != typeof s && null !== s && void 0 !== s || "string" != typeof d && null !== d && void 0 !== d) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), a);
      u.isPublic || (d = null);
      var h = e.filter(function (e, n, t) {
        return n === t.indexOf(e);
      });
      se.getInstance().createGroupChannel(h, n, t, r, i, s, o, u, l, c, d, function (e, n) {
        if (n) return void U(null, n, a);
        var t = new V(e);
        V.cachedChannels[t.url] = t, U(t, null, a);
      });
    }, V.cachedChannels = {}, V.clearCache = function () {
      V.cachedChannels = {}, Ie.getInstance()._clearFileQueue();
    }, V.removeCachedChannel = function (e) {
      delete V.cachedChannels[e], Ie.getInstance()._deleteFileQueue(e);
    }, V.upsert = function (e) {
      var n = new V(e);

      if (V.cachedChannels.hasOwnProperty(n.url)) {
        if (n.isEphemeral) {
          var t = V.cachedChannels[n.url];
          e.last_message = t.lastMessage, e.unread_message_count = t.unreadMessageCount;
        }

        V.cachedChannels[n.url].update(e);
      } else V.cachedChannels[n.url] = n;

      return V.cachedChannels[n.url];
    }, V.getChannelWithoutCache = function (e, n) {
      if (!e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
      se.getInstance().getGroupChannel(e, !0, !0, function (e, t) {
        if (t) return void U(null, t, n);
        var r = V.upsert(e);
        U(r, null, n);
      });
    }, V.getChannel = function (e, n) {
      if (!e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
      V.cachedChannels.hasOwnProperty(e) ? U(V.cachedChannels[e], null, n) : V.getChannelWithoutCache(e, n);
    }, V.markAsReadAllLastSentAt, V.markAsReadAll = function (e) {
      Ie.getInstance().markAsReadAll(e);
    };

    var Y = function Y(e) {
      e && (this.category = e.hasOwnProperty("cat") ? parseInt(e.cat) : 0, this.data = e.hasOwnProperty("data") ? e.data : null, this.channelUrl = e.hasOwnProperty("channel_url") ? String(e.channel_url) : "", this.channelType = e.hasOwnProperty("channel_type") ? String(e.channel_type) : F.CHANNEL_TYPE_GROUP), this.isGroupChannel = function () {
        return this.channelType === F.CHANNEL_TYPE_GROUP;
      }, this.isOpenChannel = function () {
        return this.channelType === F.CHANNEL_TYPE_OPEN;
      };
    };

    Y.CATEGORY_NONE = 0, Y.CATEGORY_CHANNEL_ENTER = 10102, Y.CATEGORY_CHANNEL_EXIT = 10103, Y.CATEGORY_USER_CHANNEL_MUTE = 10201, Y.CATEGORY_USER_CHANNEL_UNMUTE = 10200, Y.CATEGORY_USER_CHANNEL_BAN = 10601, Y.CATEGORY_USER_CHANNEL_UNBAN = 10600, Y.CATEGORY_CHANNEL_FREEZE = 10701, Y.CATEGORY_CHANNEL_UNFREEZE = 10700, Y.CATEGORY_TYPING_START = 10900, Y.CATEGORY_TYPING_END = 10901, Y.CATEGORY_CHANNEL_JOIN = 1e4, Y.CATEGORY_CHANNEL_LEAVE = 10001, Y.CATEGORY_CHANNEL_INVITE = 10020, Y.CATEGORY_CHANNEL_DECLINE_INVITE = 10022, Y.CATEGORY_CHANNEL_PROP_CHANGED = 11e3, Y.CATEGORY_CHANNEL_DELETED = 12e3, Y.CATEGORY_CHANNEL_META_DATA_CHANGED = 11100, Y.CATEGORY_CHANNEL_META_COUNTERS_CHANGED = 11200, Y.CATEGORY_CHANNEL_HIDE = 13e3;

    var B = function B(e) {
      e && (this.category = e.hasOwnProperty("cat") ? parseInt(e.cat) : 0);
    };

    B.CATEGORY_USER_BLOCK = 20001, B.CATEGORY_USER_UNBLOCK = 2e4, B.CATEGORY_FRIEND_DISCOVERED = 20900;

    var K = function K(e) {
      e && (this.reader = new q(e.user), this.timestamp = parseInt(e.ts), this.channelUrl = e.hasOwnProperty("channel_url") ? String(e.channel_url) : "", this.channelType = e.hasOwnProperty("channel_type") ? String(e.channel_type) : F.CHANNEL_TYPE_GROUP);
    },
        q = function q(e) {
      this.nickname = "", this.profileUrl = "", this.userId = "", this.connectionStatus = "", this.lastSeenAt = null, this.metaData = {}, this.isActive = !0, this.friendDiscoveryKey = null, this.friendName = null, this.getOriginalProfileUrl = function () {
        var e = "";

        if (e = this.profileUrl.indexOf("://") > -1 ? this.profileUrl.split("/")[2] : this.profileUrl.split("/")[0], e = e.split("?")[0], (e.indexOf("sendbird.com") > -1 || e.indexOf("intoz.com") > -1) && this.profileUrl.indexOf(e + "/profile_images/") > -1) {
          var n = this.profileUrl.replace("profile_images/", "");
          return n === this.profileUrl ? "" : n;
        }

        return "";
      }, this._update = function (e) {
        e.hasOwnProperty("guest_id") && (this.userId = String(e.guest_id)), e.hasOwnProperty("user_id") && (this.userId = String(e.user_id)), e.hasOwnProperty("name") && (this.nickname = String(e.name)), e.hasOwnProperty("nickname") && (this.nickname = String(e.nickname)), e.hasOwnProperty("image") && (this.profileUrl = String(e.image)), e.hasOwnProperty("profile_url") && (this.profileUrl = String(e.profile_url)), e.hasOwnProperty("is_online") ? e.is_online === q.NON_AVAILABLE ? this.connectionStatus = q.NON_AVAILABLE : this.connectionStatus = e.is_online ? q.ONLINE : q.OFFLINE : this.connectionStatus = q.NON_AVAILABLE, e.hasOwnProperty("last_seen_at") ? this.lastSeenAt = parseInt(e.last_seen_at) : this.lastSeenAt = 0, e.hasOwnProperty("metadata") ? this.metaData = e.metadata : this.metaData = {}, e.hasOwnProperty("is_active") ? this.isActive = "undefined" == typeof e.is_active || e.is_active : this.isActive = !0, e.hasOwnProperty("friend_discovery_key") ? this.friendDiscoveryKey = e.friend_discovery_key : this.friendDiscoveryKey = null, e.hasOwnProperty("friend_name") ? this.friendName = e.friend_name : this.friendName = null;
      }, this._updateMetaData = function (e, n) {
        var t = this,
            r = Object.keys(e);
        n ? r.forEach(function (e) {
          delete t.metaData[e];
        }) : r.forEach(function (n) {
          t.metaData[n] = e[n];
        });

        for (var i in V.cachedChannels) {
          if (V.cachedChannels.hasOwnProperty(i)) {
            var a = V.cachedChannels[i];

            if (a.memberMap.hasOwnProperty(t.userId)) {
              var s = a.memberMap[t.userId];
              s.metaData = t.metaData;
            }
          }
        }
      }, this.createMetaData = function (e, n) {
        var t = this;
        if ("function" == typeof e && 1 === arguments.length && (n = e, e = {}), "object" != typeof e || f(e) || Array.isArray(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().createUserMetaData(e, function (e, r) {
          if (r) return void U(null, r, n);
          t._updateMetaData(e), U(e, null, n);
        });
      }, this.updateMetaData = function (e, n, t) {
        var r = this;
        if ("function" == typeof e && 1 === arguments.length && (t = e, e = {}), "function" == typeof n && 2 === arguments.length && (t = n, n = !1), "object" != typeof e || f(e) || Array.isArray(e) || "boolean" != typeof n) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
        se.getInstance().updateUserMetaData(e, n, function (e, n) {
          if (n) return void U(null, n, t);
          r._updateMetaData(e), U(e, null, t);
        });
      }, this.deleteAllMetaData = function (e) {
        var n = this,
            t = n.metaData;
        se.getInstance().deleteAllUserMetaData(function (r, i) {
          if (i) return void U(null, i, e);
          n._updateMetaData(t, !0), U(r, null, e);
        });
      }, this.deleteMetaData = function (e, n) {
        var t = this;
        if ("function" == typeof e && 1 === arguments.length && (n = e, e = null), "string" != typeof e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        var r = {};
        r[e] = "", se.getInstance().deleteUserMetaData(e, function (e, i) {
          if (i) return void U(null, i, n);
          t._updateMetaData(r, !0), U(e, null, n);
        });
      }, this.serialize = function () {
        var e = JSON.parse(JSON.stringify(this));
        return E(e);
      }, e && this._update(e);
    };

    q.NON_AVAILABLE = "nonavailable", q.ONLINE = "online", q.OFFLINE = "offline", q.build = function (e, n, t, r, i, a, s, o, l) {
      return {
        user_id: e,
        nickname: n,
        profile_url: t,
        is_online: r,
        last_seen_at: i,
        metadata: a,
        is_active: s,
        friend_discovery_key: o,
        friend_name: l
      };
    }, q.buildFromSerializedData = function (e) {
      var n = A(e);
      return new q(q.build(n.userId, n.nickname, n.profileUrl, n.connectionStatus, n.lastSeenAt, n.metaData, n.isActive, n.friendDiscoveryKey, n.friendName));
    };

    var j = function j(e) {
      this.state = "", this.isBlockedByMe = !1, this.isBlockingMe = !1, this.parse = function (e) {
        this.state = e.state, e.hasOwnProperty("is_blocked_by_me") && (this.isBlockedByMe = e.is_blocked_by_me), e.hasOwnProperty("is_blocking_me") && (this.isBlockingMe = e.is_blocking_me);
      }, e && (this._update(e), this.parse(e));
    };

    I(q, j), j.JOINED = "joined", j.INVITED = "invited", j.build = function (e, n, t, r) {
      var i = e;
      return i.state = n, i.is_blocked_by_me = t, i.is_blocking_me = r, i;
    }, j.buildFromSerializedData = function (e) {
      var n = A(e);
      return new j(j.build(q.build(n.userId, n.nickname, n.profileUrl, n.connectionStatus, n.lastSeenAt, n.metaData, n.isActive, n.friendDiscoveryKey, n.friendName), n.state, n.isBlockedByMe, n.isBlockingMe));
    };

    var x = function x(e, n, t) {
      this.isAckRequired = function () {
        return "MESG" === this.command || "FILE" === this.command || "ENTR" === this.command || "EXIT" === this.command || "READ" === this.command || "MEDI" === this.command || "FEDI" === this.command;
      }, this.encode = function () {
        return this.command + this.payload + "\n";
      }, this.decode = function (e) {
        e = e.trim(), this.command = e.substring(0, 4), this.payload = e.substring(4);
      }, this.getJsonElement = function () {
        return JSON.parse(this.payload);
      }, this.isRequestIdCommand = function () {
        return this.isAckRequired() || "EROR" === this.command;
      }, this.command, this.payload, this.requestId;
      var r = this;

      if (0 !== arguments.length) {
        var i;

        switch (arguments.length) {
          case 1:
            var a = arguments[0];
            if (!a || a.length <= 4) return r.command = "NOOP", void (r.payload = "{}");

            if (a = a.trim(), r.command = a.substring(0, 4), r.payload = a.substring(4), r.isRequestIdCommand()) {
              var s = r.getJsonElement();
              s && (r.requestId = s.hasOwnProperty("req_id") ? s.req_id : "");
            }

            break;

          case 3:
            i = arguments[2];

          case 2:
            var o = arguments[0],
                l = arguments[1];
            i = i || "", r.command = o, r.requestId = i, r.requestId || r.isRequestIdCommand() && (r.requestId = x.generateRequestId()), l.req_id = r.requestId, r.payload = JSON.stringify(l);
        }
      }
    };

    x.bMessage = function (e, n, t, r, i, a, s, o, l) {
      var u = {};
      return u.channel_url = e, u.message = n, u.data = t, i && Object.keys(i).length > 0 && (u.metaarray = i), a && (u.mention_type = a), u.mentioned_user_ids = [], a === de.MentionType.CHANNEL ? u.mentioned_user_ids = [] : Array.isArray(s) && s.length > 0 && (u.mentioned_user_ids = s), r && (u.custom_type = r), o.length > 0 && (u.target_langs = o), l && l !== he.PushNotificationDeliveryOption.DEFAULT && (u.push_option = l), new x("MESG", u);
    }, x.bRead = function (e) {
      var n = {};
      return n.channel_url = e, new x("READ", n);
    }, x.bTypeStart = function (e, n) {
      var t = {};
      return t.channel_url = e, t.time = n, new x("TPST", t);
    }, x.bTypeEnd = function (e, n) {
      var t = {};
      return t.channel_url = e, t.time = n, new x("TPEN", t);
    }, x.bFile = function (e, n, t, r, i, a, s, o, l, u, c, d, h, p) {
      var f = {};
      return f.channel_url = n, f.url = t, f.name = r || "", f.type = i || "", f.size = a || 0, f.custom = s, o && (f.custom_type = o), l && (f.thumbnails = l), u && (f.require_auth = u), c && Object.keys(c).length > 0 && (f.metaarray = c), d && (f.mention_type = d), f.mentioned_user_ids = [], d === de.MentionType.CHANNEL ? f.mentioned_user_ids = [] : Array.isArray(h) && h.length > 0 && (f.mentioned_user_ids = h), p && p !== pe.PushNotificationDeliveryOption.DEFAULT && (f.push_option = p), new x("FILE", f, e);
    }, x.bPing = function () {
      var e = {};
      return e.id = new Date().getTime(), new x("PING", e);
    }, x.bEnter = function (e) {
      var n = {};
      return n.channel_url = e, new x("ENTR", n);
    }, x.bExit = function (e) {
      var n = {};
      return n.channel_url = e, new x("EXIT", n);
    }, x.bUpdateUserMessage = function (e, n, t, r, i, a, s, o) {
      var l = {};
      return l.channel_url = e, l.msg_id = n, null != t && t !== undefined && (l.message = t), null != r && r !== undefined && (l.data = r), null != i && i !== undefined && (l.custom_type = i), a && (l.mention_type = a), a === de.MentionType.CHANNEL ? l.mentioned_user_ids = [] : Array.isArray(s) && s.length > 0 && (l.mentioned_user_ids = s), o && (l.metaarray = o), new x("MEDI", l);
    }, x.bUpdateFileMessage = function (e, n, t, r, i, a, s) {
      var o = {};
      return o.channel_url = e, o.msg_id = n, null != t && t !== undefined && (o.data = t), null != r && r !== undefined && (o.custom_type = r), i && (o.mention_type = i), i === de.MentionType.CHANNEL ? o.mentioned_user_ids = [] : Array.isArray(a) && a.length > 0 && (o.mentioned_user_ids = a), s && (o.metaarray = s), new x("FEDI", o);
    }, x.requestIdSeed = new Date().getTime(), x.generateRequestId = function () {
      return x.requestIdSeed++, String(x.requestIdSeed);
    };

    var z = function z(e) {
      this.isLoading = !1, this.hasNext = !0, this.limit = 20;
      var n = "",
          t = this;

      this.next = function (r) {
        return t.hasNext ? t.isLoading ? void U(null, new g("Query in progress.", N.QUERY_IN_PROGRESS), r) : "number" != typeof t.limit || t.limit < 1 ? void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r) : (t.isLoading = !0, void se.getInstance().loadOperatorList(e.url, e.isOpenChannel(), n, t.limit, function (e, i) {
          if (i) return t.isLoading = !1, void U(null, i, r);
          var a = e;
          (!(n = String(a.next)) || n.length <= 0) && (t.hasNext = !1);
          var s = a.operators.map(function (e) {
            return new q(e);
          });
          t.isLoading = !1, U(s, null, r);
        })) : void U([], null, r);
      };
    },
        W = function W(e) {
      this.isLoading = !1, this.hasNext = !0, this.limit = 20, this.mutedMemberFilter = W.MUTED_MEMBER_FILTER.ALL, this.operatorFilter = W.OPERATOR_FILTER.ALL, this.memberStateFilter = V.memberStateFilter.ALL, this.nicknameStartsWithFilter = null;
      var n = W.Order.MEMBER_NICKNAME_ALPHABETICAL,
          t = "",
          r = this;

      this.next = function (i) {
        return r.hasNext ? r.isLoading ? void U(null, new g("Query in progress.", N.QUERY_IN_PROGRESS), i) : "number" != typeof r.limit || r.limit < 1 || "string" != typeof r.mutedMemberFilter || [W.MUTED_MEMBER_FILTER.ALL, W.MUTED_MEMBER_FILTER.MUTED, W.MUTED_MEMBER_FILTER.UNMUTED].indexOf(r.mutedMemberFilter.toLowerCase()) < 0 || "string" != typeof r.operatorFilter || [W.OPERATOR_FILTER.ALL, W.OPERATOR_FILTER.OPERATOR, W.OPERATOR_FILTER.NONOPERATOR].indexOf(r.operatorFilter.toLowerCase()) < 0 || "string" != typeof r.memberStateFilter || [V.memberStateFilter.ALL, V.memberStateFilter.JOINED, V.memberStateFilter.INVITED, V.memberStateFilter.INVITED_BY_FRIEND, V.memberStateFilter.INVITED_BY_NON_FRIEND].indexOf(r.memberStateFilter.toLowerCase()) < 0 || null !== r.nicknameStartsWithFilter && "string" != typeof r.nicknameStartsWithFilter ? void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), i) : (r.isLoading = !0, void se.getInstance().loadGroupChannelMemberList(e, t, r.limit, r.mutedMemberFilter, r.operatorFilter, r.memberStateFilter, r.nicknameStartsWithFilter, n, function (e, n) {
          if (n) return r.isLoading = !1, void U(null, n, i);
          var a = e;
          (!(t = String(a.next)) || t.length <= 0) && (r.hasNext = !1);
          var s = a.members.map(function (e) {
            return new j(e);
          });
          r.isLoading = !1, U(s, null, i);
        })) : void U([], null, i);
      };
    };

    W.MUTED_MEMBER_FILTER = {
      ALL: "all",
      MUTED: "muted",
      UNMUTED: "unmuted"
    }, W.OPERATOR_FILTER = {
      ALL: "all",
      OPERATOR: "operator",
      NONOPERATOR: "nonoperator"
    }, W.Order = {
      MEMBER_NICKNAME_ALPHABETICAL: "member_nickname_alphabetical"
    };

    var J = function J() {
      this.isLoading = !1, this.hasNext = !0, this.limit = 20, this.includeEmpty = !1, this.order = J.ORDER_LATEST_LAST_MESSAGE, this.userIdsFilter = [], this.userIdsFilterExactMatch = !1, this.queryType = "AND";
      var e = {
        userIds: [],
        includeMode: !0,
        queryType: Q.USER_IDS_INCLUDE_QUERY_TYPE.AND
      };
      this._userIdsExactFilter = [], this._userIdsIncludeFilter = [], this._userIdsIncludeFilterQueryType = Q.USER_IDS_INCLUDE_QUERY_TYPE.AND, h ? (this.userIdsExactFilter = this._userIdsExactFilter, this.userIdsIncludeFilter = this._userIdsIncludeFilter, this.userIdsIncludeFilterQueryType = this._userIdsIncludeFilterQueryType) : (Object.defineProperty(this, "userIdsExactFilter", {
        get: function get() {
          return this._userIdsExactFilter;
        },
        set: function set(n) {
          Array.isArray(n) && (this._userIdsExactFilter = n, this._userIdsIncludeFilter = [], e = {
            userIds: this._userIdsExactFilter,
            includeMode: !1
          });
        }
      }), Object.defineProperty(this, "userIdsIncludeFilter", {
        get: function get() {
          return this._userIdsIncludeFilter;
        },
        set: function set(n) {
          Array.isArray(n) && (this._userIdsIncludeFilter = n, this._userIdsExactFilter = [], e = {
            userIds: this._userIdsIncludeFilter,
            includeMode: !0
          });
        }
      }), Object.defineProperty(this, "userIdsIncludeFilterQueryType", {
        get: function get() {
          return this._userIdsIncludeFilterQueryType;
        },
        set: function set(n) {
          this._userIdsIncludeFilterQueryType = n, e = {
            queryType: this._userIdsIncludeFilterQueryType
          };
        }
      })), this.nicknameContainsFilter = "", this.channelNameContainsFilter = "", this.memberStateFilter = V.memberStateFilter.ALL, this.customTypeFilter = "", this.customTypesFilter = [], this.channelUrlsFilter = [], this.superChannelFilter = V.superChannelFilter.ALL, this.publicChannelFilter = V.publicChannelFilter.ALL, this.customTypeStartsWithFilter = null, this.unreadChannelFilter = V.UnreadChannelFilter.ALL, this.metadataOrderKeyFilter = null;
      var n = "",
          t = this;

      this.next = function (r) {
        if (!t.hasNext) return void U([], null, r);
        if (t.isLoading) return void U(null, new g("Query in progress.", N.QUERY_IN_PROGRESS), r);
        if (null !== t.nicknameContainsFilter && "undefined" != typeof t.nicknameContainsFilter || (t.nicknameContainsFilter = ""), null !== t.channelNameContainsFilter && "undefined" != typeof t.channelNameContainsFilter || (t.channelNameContainsFilter = ""), null !== t.customTypeStartsWithFilter && "string" != typeof t.customTypeStartsWithFilter) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
        if (!Array.isArray(t._userIdsExactFilter) || !Array.isArray(t._userIdsIncludeFilter) || "string" != typeof t._userIdsIncludeFilterQueryType || [Q.USER_IDS_INCLUDE_QUERY_TYPE.AND, Q.USER_IDS_INCLUDE_QUERY_TYPE.OR].indexOf(t._userIdsIncludeFilterQueryType.toUpperCase()) < 0) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);

        if ("number" == typeof t.memberStateFilter) {
          if (typeof t.memberStateFilter < 0 || typeof t.memberStateFilter > 4) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
          var i = ["all", "joined_only", "invited_only", "invited_by_friend", "invited_by_non_friend"];
          t.memberStateFilter = i[t.memberStateFilter];
        }

        if (!_(t.limit) || !Array.isArray(t.userIdsFilter) || "boolean" != typeof t.includeEmpty || "boolean" != typeof t.userIdsFilterExactMatch || "string" != typeof t.customTypeFilter || !Array.isArray(t.customTypesFilter) || "string" != typeof t.queryType || ["AND", "OR"].indexOf(t.queryType.toUpperCase()) < 0 || "string" != typeof t.order || [J.ORDER_CHRONOLOGICAL, J.ORDER_LATEST_LAST_MESSAGE, J.CHANNEL_NAME_ALPHABETICAL, J.METADATA_VALUE_ALPHABETICAL].indexOf(t.order.toLowerCase()) < 0 || "string" != typeof t.memberStateFilter || [V.memberStateFilter.ALL, V.memberStateFilter.JOINED, V.memberStateFilter.INVITED, V.memberStateFilter.INVITED_BY_FRIEND, V.memberStateFilter.INVITED_BY_NON_FRIEND].indexOf(t.memberStateFilter.toLowerCase()) < 0 || "string" != typeof t.nicknameContainsFilter || "string" != typeof t.channelNameContainsFilter || !Array.isArray(t.channelUrlsFilter) || "string" != typeof t.superChannelFilter || [V.superChannelFilter.ALL, V.superChannelFilter.SUPER, V.superChannelFilter.NON_SUPER].indexOf(t.superChannelFilter.toLowerCase()) < 0 || "string" != typeof t.publicChannelFilter || [V.publicChannelFilter.ALL, V.publicChannelFilter.PUBLIC, V.publicChannelFilter.PRIVATE].indexOf(t.publicChannelFilter.toLowerCase()) < 0 || "string" != typeof t.unreadChannelFilter || [V.UnreadChannelFilter.ALL, V.UnreadChannelFilter.UNREAD_MESSAGE].indexOf(t.unreadChannelFilter) < 0 || null !== t.metadataOrderKeyFilter && "string" != typeof t.metadataOrderKeyFilter) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), r);
        Array.isArray(t.userIdsFilter) && t.userIdsFilter.length > 0 && (e = {
          userIds: t.userIdsFilter,
          includeMode: !t.userIdsFilterExactMatch,
          queryType: t.queryType
        }), t.isLoading = !0, se.getInstance().loadUserGroupChannelList(n, t.limit, t.includeEmpty, t.order, e, t.nicknameContainsFilter, t.channelNameContainsFilter, t.channelUrlsFilter, t.customTypeFilter, t.customTypesFilter, t.customTypeStartsWithFilter, t.memberStateFilter, t.superChannelFilter, t.publicChannelFilter, t.unreadChannelFilter, t.metadataOrderKeyFilter, function (e, i) {
          if (i) return t.isLoading = !1, void U(null, i, r);
          var a = e;
          (!(n = String(a.next)) || n.length <= 0) && (t.hasNext = !1);
          var s = a.channels,
              o = [];

          for (var l in s) {
            var u = V.upsert(s[l]);
            o.push(u);
          }

          t.isLoading = !1, U(o, null, r);
        });
      };
    };

    J.ORDER_LATEST_LAST_MESSAGE = "latest_last_message", J.ORDER_CHRONOLOGICAL = "chronological", J.CHANNEL_NAME_ALPHABETICAL = "channel_name_alphabetical", J.METADATA_VALUE_ALPHABETICAL = "metadata_value_alphabetical", J.MEMBER_STATE_INVITED_ONLY = "invited_only", J.MEMBER_STATE_JOINED_ONLY = "joined_only", J.MEMBER_STATE_ALL = "all";

    var Q = function Q() {
      var e = "";
      this.isLoading = !1, this.hasNext = !0, this.limit = 20, this.includeEmpty = !0, this.order = Q.ORDER_CHRONOLOGICAL, this.channelNameContainsFilter = null, this.channelUrlsFilter = [], this.customTypesFilter = [], this.customTypeStartsWithFilter = null, this.superChannelFilter = V.superChannelFilter.ALL, this.membershipFilter = Q.MEMBERSHIP_TYPE.JOINED, this.metadataOrderKeyFilter = null;
      var n = this;

      this.next = function (t) {
        return n.hasNext ? n.isLoading ? void U(null, new g("Query in progress.", N.QUERY_IN_PROGRESS), t) : !_(n.limit) || "boolean" != typeof n.includeEmpty || !Array.isArray(n.customTypesFilter) || !Array.isArray(n.channelUrlsFilter) || null !== n.channelNameContainsFilter && "string" != typeof n.channelNameContainsFilter || null !== n.customTypeStartsWithFilter && "string" != typeof n.customTypeStartsWithFilter || "string" != typeof n.order || [Q.ORDER_CHRONOLOGICAL, Q.ORDER_LATEST_LAST_MESSAGE, Q.CHANNEL_NAME_ALPHABETICAL, Q.METADATA_VALUE_ALPHABETICAL].indexOf(n.order.toLowerCase()) < 0 || null !== n.metadataOrderKeyFilter && "string" != typeof n.metadataOrderKeyFilter ? void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t) : "string" != typeof n.superChannelFilter || [V.superChannelFilter.ALL, V.superChannelFilter.SUPER, V.superChannelFilter.NON_SUPER].indexOf(n.superChannelFilter.toLowerCase()) < 0 || "string" != typeof n.membershipFilter || [Q.MEMBERSHIP_TYPE.ALL, Q.MEMBERSHIP_TYPE.JOINED].indexOf(n.membershipFilter.toLowerCase()) < 0 ? void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t) : (n.isLoading = !0, void se.getInstance().loadPublicGroupChannelList(e, n.limit, n.includeEmpty, n.order, n.channelNameContainsFilter, n.channelUrlsFilter, n.customTypesFilter, n.customTypeStartsWithFilter, n.superChannelFilter, n.membershipFilter, n.metadataOrderKeyFilter, function (r, i) {
          if (i) return n.isLoading = !1, void U(null, i, t);
          var a = r;
          (!(e = String(a.next)) || e.length <= 0) && (n.hasNext = !1);
          var s = a.channels,
              o = [];

          for (var l in s) {
            var u = V.upsert(s[l]);
            o.push(u);
          }

          n.isLoading = !1, U(o, null, t);
        })) : void U([], null, t);
      };
    };

    Q.ORDER_CHRONOLOGICAL = "chronological", Q.CHANNEL_NAME_ALPHABETICAL = "channel_name_alphabetical", Q.METADATA_VALUE_ALPHABETICAL = "metadata_value_alphabetical", Q.USER_IDS_INCLUDE_QUERY_TYPE = {
      AND: "AND",
      OR: "OR"
    }, Q.MEMBERSHIP_TYPE = {
      ALL: "all",
      JOINED: "joined"
    };

    var X = function X(e) {
      this.isLoading = !1;
      var n = e,
          t = this;
      this.next = function (e, r, i, a) {
        if (t.isLoading) return void U(null, new g("Query in progress.", N.QUERY_IN_PROGRESS), a);

        if (4 !== arguments.length) {
          if ("function" != typeof a) {
            var s = Array.prototype.slice.call(arguments);
            "function" == typeof s.slice(-1)[0] && (a = s.pop());
          }

          return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), a);
        }

        if (!_(e) || !_(r) || "boolean" != typeof i) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), a);
        t.isLoading = !0, se.getInstance().messageList(n.isOpenChannel(), n.url, e, 0, r, !1, i, "", "", [], !1, function (e, r) {
          if (r) return t.isLoading = !1, void U(null, r, a);
          var i = e.messages,
              s = [];

          for (var o in i) {
            var l = L.build(i[o], n);
            l && s.push(l);
          }

          t.isLoading = !1, U(s, null, a);
        });
      }, this.prev = function (e, r, i, a) {
        if (t.isLoading) return void U(null, new g("Query in progress.", N.QUERY_IN_PROGRESS), a);

        if (4 !== arguments.length) {
          if ("function" != typeof a) {
            var s = Array.prototype.slice.call(arguments);
            "function" == typeof s.slice(-1)[0] && (a = s.pop());
          }

          return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), a);
        }

        if (!_(e) || !_(r) || "boolean" != typeof i) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), a);
        t.isLoading = !0, se.getInstance().messageList(n.isOpenChannel(), n.url, e, r, 0, !1, i, "", "", [], !1, function (e, r) {
          if (r) return t.isLoading = !1, void U(null, r, a);
          var i = e.messages,
              s = [];

          for (var o in i) {
            var l = L.build(i[o], n);
            l && s.push(l);
          }

          t.isLoading = !1, U(s, null, a);
        });
      }, this.load = function (e, r, i, a, s) {
        if (t.isLoading) return void U(null, new g("Query in progress.", N.QUERY_IN_PROGRESS), s);

        if (5 !== arguments.length) {
          if ("function" != typeof s) {
            var o = Array.prototype.slice.call(arguments);
            "function" == typeof o.slice(-1)[0] && (s = o.pop());
          }

          return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), s);
        }

        if (!_(e) || !_(r) || !_(i) || "boolean" != typeof a) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), s);
        t.isLoading = !0, se.getInstance().messageList(n.isOpenChannel(), n.url, e, r, i, !0, a, "", "", [], !1, function (e, r) {
          if (r) return t.isLoading = !1, void U(null, r, s);
          var i = e.messages,
              a = [];

          for (var o in i) {
            var l = L.build(i[o], n);
            l && a.push(l);
          }

          t.isLoading = !1, U(a, null, s);
        });
      };
    },
        Z = function Z() {
      var e = "";
      this.limit = 20, this.isLoading = !1, this.hasNext = !0, this.nameKeyword = null, this.urlKeyword = null, this.customType = null;
      var n = this;

      this.next = function (t) {
        return this.hasNext ? this.isLoading ? void U(null, new g("Query in progress.", N.QUERY_IN_PROGRESS), t) : "string" != typeof n.nameKeyword && null !== n.nameKeyword || "string" != typeof n.urlKeyword && null !== n.urlKeyword || "string" != typeof n.customType && null !== n.customType || !_(n.limit) ? void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t) : (n.isLoading = !0, void se.getInstance().loadOpenChannelList(e, n.limit, n.nameKeyword, n.urlKeyword, n.customType, function (r, i) {
          if (i) return n.isLoading = !1, void U(null, i, t);
          var a = r;

          try {
            e = String(a.next);
          } catch (n) {
            e = "";
          }

          e || (n.hasNext = !1);
          var s = a.channels,
              o = [];
          s.forEach(function (e) {
            var n = k.upsert(e);
            o.push(n);
          }), n.isLoading = !1, U(o, null, t);
        })) : void U([], null, t);
      };
    },
        $ = function $(e) {
      var n = e,
          t = 0x8000000000000000;
      this.hasMore = !0, this.isLoading = !1;
      var r = this;
      this.limit = 20, this.reverse = !1, this.messageTypeFilter = null, this.customTypeFilter = null, this.senderUserIdsFilter = [], this.includeMetaArray = !1, this.load = function () {
        var e = null,
            i = Array.prototype.slice.call(arguments);

        switch ("function" == typeof i.slice(-1)[0] && (e = i.pop()), i.length) {
          case 2:
            this.limit = i[0], this.reverse = i[1];
            break;

          case 3:
            this.limit = i[0], this.reverse = i[1], this.messageTypeFilter = i[2];
        }

        if (null === this.messageTypeFilter || "undefined" == typeof this.messageTypeFilter || this.messageTypeFilter === m.MessageTypeFilter.ALL ? this.messageTypeFilter = "" : this.messageTypeFilter.toString().toLowerCase() === L.MESSAGE_TYPE_USER || this.messageTypeFilter === m.MessageTypeFilter.USER ? this.messageTypeFilter = "MESG" : this.messageTypeFilter.toString().toLowerCase() === L.MESSAGE_TYPE_FILE || this.messageTypeFilter === m.MessageTypeFilter.FILE ? this.messageTypeFilter = "FILE" : this.messageTypeFilter.toString().toLowerCase() !== L.MESSAGE_TYPE_ADMIN && this.messageTypeFilter !== m.MessageTypeFilter.ADMIN || (this.messageTypeFilter = "ADMM"), !_(this.limit) || "boolean" != typeof this.reverse || null !== this.messageTypeFilter && "string" != typeof this.messageTypeFilter || null !== this.customTypeFilter && "string" != typeof this.customTypeFilter || !Array.isArray(this.senderUserIdsFilter)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), e);

        for (var a = 0; a < this.senderUserIdsFilter.length; a++) {
          if ("string" != typeof this.senderUserIdsFilter[a]) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), e);
        }

        return r.hasMore ? r.isLoading ? void U(null, new g("Query in progress.", N.QUERY_IN_PROGRESS), e) : (r.isLoading = !0, void se.getInstance().messageList(n.isOpenChannel(), n.url, t, this.limit, 0, !1, this.reverse, this.messageTypeFilter, this.customTypeFilter, this.senderUserIdsFilter, this.includeMetaArray, function (i, a) {
          if (a) return r.isLoading = !1, void U(null, a, e);
          var s = i.messages,
              o = [];

          for (var l in s) {
            var u = L.build(s[l], n);
            u && (o.push(u), u.createdAt <= t && (t = u.createdAt));
          }

          (o.length <= 0 || o.length < r.limit) && (r.hasMore = !1), r.isLoading = !1, U(o, null, e);
        })) : void U([], null, e);
      };
    },
        ee = function ee(e, n) {
      var t,
          r,
          i,
          a = "";
      this.hasNext = !0, this.limit = 20, this.isLoading = !1, this.userIds = [], this.metaDataKey = "", this.metaDataValues = [];
      var s = this;

      switch (n && (r = n), t = e) {
        case ee.ALL_USER:
        case ee.BLOCKED_USER:
          i = "users";
          break;

        case ee.FILTERED_USER:
          this.userIds = n, i = "users";
          break;

        case ee.PARTICIPANT:
          i = "participants";
          break;

        case ee.MUTED_USER:
          i = "muted_list";
          break;

        case ee.BANNED_USER:
          i = "banned_list";
      }

      this.next = function (n) {
        if (!s.hasNext) return void U([], null, n);
        if (s.isLoading) return void U(null, new g("Query in progress.", N.QUERY_IN_PROGRESS), n);
        if (!_(s.limit) || !Array.isArray(s.userIds) || "string" != typeof s.metaDataKey || !Array.isArray(s.metaDataValues) || s.metaDataKey && f(s.metaDataValues) || !s.metaDataKey && !f(s.metaDataValues)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        s.isLoading = !0;

        var o = function o(t, r) {
          if (r) return s.isLoading = !1, void U(null, r, n);
          (a = t.next) || (s.hasNext = !1);
          var o = t[i],
              l = [];

          for (var u in o) {
            e === ee.BANNED_USER ? l.push(new q(o[u].user)) : l.push(new q(o[u]));
          }

          s.isLoading = !1, U(l, null, n);
        };

        switch (t) {
          case ee.ALL_USER:
            se.getInstance().loadUserList(a, s.limit, [], s.metaDataKey, s.metaDataValues, o);
            break;

          case ee.FILTERED_USER:
            se.getInstance().loadUserList(a, s.limit, s.userIds, s.metaDataKey, s.metaDataValues, o);
            break;

          case ee.BLOCKED_USER:
            se.getInstance().loadBlockedUserList(Ie.getInstance().getCurrentUserId(), a, s.limit, o);
            break;

          case ee.PARTICIPANT:
            se.getInstance().loadOpenChannelParticipantList(r.url, a, s.limit, o);
            break;

          case ee.MUTED_USER:
            se.getInstance().loadMutedUserList(r, a, s.limit, o);
            break;

          case ee.BANNED_USER:
            se.getInstance().loadBannedUserList(r, a, s.limit, o);
        }
      };
    };

    ee.ALL_USER = "alluser", ee.FILTERED_USER = "filtereduser", ee.BLOCKED_USER = "blockeduser", ee.PARTICIPANT = "participant", ee.MUTED_USER = "muteduser", ee.BANNED_USER = "banneduser";

    var ne = 15e3,
        te = 5e3,
        re = function re() {
      var e,
          n,
          i = function i() {
        r && t.log("PING");
        var e = x.bPing();
        Ie.getInstance().wsClient.send(e), n = setTimeout(function () {
          r && t.log("PING Timeout"), a(), Ie.getInstance().wsClient._WSClientOnError();
        }, te);
      };

      this.pong = function () {
        clearTimeout(n), n = null;
      }, this.start = function () {
        this.stop(), i(), e = setInterval(function () {
          i();
        }, ne);
      };

      var a = function a() {
        clearInterval(e), e = null, clearTimeout(n), n = null;
      };

      this.stop = function () {
        a();
      };
    },
        ie = new re(),
        ae = function ae(e) {
      var n,
          i,
          a = !1,
          s = 0,
          o = e;
      o || (o = new ae.WSClientHandler());

      var u = function u() {
        s = new Date().getTime();
      };

      this._WSClientOnError = function () {
        o && o.onError();
      }, this.getConnectionState = function () {
        try {
          return 1 === n.readyState ? Ie.getInstance().ConnectionState.OPEN : 0 === n.readyState ? Ie.getInstance().ConnectionState.CONNECTING : Ie.getInstance().ConnectionState.CLOSED;
        } catch (e) {
          return Ie.getInstance().ConnectionState.CLOSED;
        }
      }, this.connect = function (e, s, c) {
        r && t.log("WSClient connect called"), i = c;
        var d = null,
            h = !1;

        try {
          d = "undefined" == typeof WebSocket ? require("ws") : WebSocket;
        } catch (e) {
          d = WebSocket;
        }

        try {
          var p = "/?p=JS&pv=" + encodeURIComponent(l) + "&sv=" + encodeURIComponent("3.0.85") + "&ai=" + encodeURIComponent(T);
          if (se.getInstance().sessionKey ? p += "&key=" + encodeURIComponent(se.getInstance().sessionKey) : p += "&user_id=" + encodeURIComponent(e) + "&access_token=" + encodeURIComponent(s), !(n = new d(i + p))) return Ie.getInstance().isReconnectingOnError = !0, void o.onError("ws is not exist.");
        } catch (e) {
          return Ie.getInstance().isReconnectingOnError = !0, void o.onError(e);
        }

        if (r) try {
          window.ws = n;
        } catch (e) {}
        n.onopen = function (e) {
          ie && ie.start(), r && t.log("WSClient onopen called"), o.onOpen(e);
        }, n.onmessage = function (e) {
          u();
          var n = e.data.split("\n");

          for (var i in n) {
            var a = n[i];

            if (a && "string" == typeof a) {
              try {
                if ("PONG" === a.substring(0, 4)) {
                  ie.pong();
                  continue;
                }
              } catch (e) {
                r && t.log("ws.onmessage-command check error: ", e);
              }

              o.onMessage(a);
            }
          }
        }, n.onclose = function (e) {
          r && t.log("WSClient ws.onclose called - e, explicitDisconnect: ", e, a), ie && ie.stop(), a ? o.onClose(e) : h || o.onError(e), a = !1;
        }, n.onerror = function (e) {
          r && t.log("WSClient ws.onerror called: ", e), ie && ie.stop(), h = !0, Ie.getInstance().isReconnectingOnError = !0, o.onError(e);
        };
      }, this.disconnect = function (e, i) {
        r && t.log("WSClient disconnect called [explicit]: ", e), ie && ie.stop(), a = !0 === e, n && (n.onopen = function () {}, n.onmessage = function () {}, n.onclose = function () {
          i && i();
        }, n.onerror = function () {}, n.close(), n = null), a ? o.onClose() : o.onError(), a = !1;
      }, this.send = function (e, t) {
        1 !== n.readyState ? t && t(null, new g("Connection is not valid. Please reconnect.", N.WEBSOCKET_CONNECTION_CLOSED)) : (n.send(e.encode()), t && t(null, null));
      };
    };

    ae.WSClientHandler = function () {
      this.onReady = function () {}, this.onOpen = function () {}, this.onClose = function () {}, this.onMessage = function () {}, this.onError = function () {};
    };

    var se = function se() {
      var e = se.getInstance();
      if (e) return e;
      this.sessionKey;
      this.registerScheduledUserMessage = function (e, n, t) {
        Ie.getInstance().ConnectionManager.ready(function (r, a) {
          if (a) return void t(null, a);
          var s = "";
          s = n.isOpenChannel ? se.API_OPENCHANNELS_CHANNELURL_SCHEDULED_MESSAGES.replace("%s", encodeURIComponent(n.channelUrl)) : se.API_GROUPCHANNELS_CHANNELURL_SCHEDULED_MESSAGES.replace("%s", encodeURIComponent(n.channelUrl));
          var o = {
            scheduled_dt: e._getScheduleString(),
            user_id: r.userId,
            message: e.message,
            data: e.data
          };
          e.customType && (o.custom_type = e.customType), e.metaArrayKeys && Object.keys(e.metaArrayKeys).length > 0 && (o.metaarray = e.metaArrayKeys), e.mentionType && (o.mention_type = e._mentionType), e._mentionType === de.MentionType.CHANNEL ? o.mentioned_user_ids = [] : Array.isArray(e._mentionedIds) && e._mentionedIds.length > 0 && (o.mentioned_user_ids = e._mentionedIds), e.translationTargetLanguages && e.translationTargetLanguages.length > 0 && (o.translation_target_langs = e.translationTargetLanguages), e.pushNotificationDeliveryOption && e.pushNotificationDeliveryOption !== de.PushNotificationDeliveryOption.DEFAULT && (o.push_option = e.pushNotificationDeliveryOption), i(s, o, t);
        });
      }, this.getMessageChangeLogsByToken = function (e, n, t, i, a) {
        Ie.getInstance().ConnectionManager.ready(function (s, o) {
          if (o) return void a(null, o);
          var l = "";
          l = e ? se.API_OPENCHANNELS_CHANNELURL_MESSAGES_CHANGELOGS.replace("%s", encodeURIComponent(n)) : se.API_GROUPCHANNELS_CHANNELURL_MESSAGES_CHANGELOGS.replace("%s", encodeURIComponent(n));
          var u = {};
          t && (u.token = t), "boolean" == typeof i && (u.with_meta_array = i), r(l, u, a);
        });
      }, this.setChannelInvitationPreference = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var i = se.API_USERS_USERID_GROUP_CHANNEL_INVITATION_PREFERENCE.replace("%s", encodeURIComponent(t.userId));
          a(i, {
            auto_accept: e
          }, n);
        });
      }, this.getChannelInvitationPreference = function (e) {
        Ie.getInstance().ConnectionManager.ready(function (n, t) {
          if (t) return void e(null, t);
          var i = se.API_USERS_USERID_GROUP_CHANNEL_INVITATION_PREFERENCE.replace("%s", encodeURIComponent(n.userId));
          r(i, e);
        });
      }, this.getGroupChannelCount = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, i) {
          if (i) return void n(null, i);
          var a = se.API_USERS_USERID_GROUP_CHANNEL_COUNT.replace("%s", encodeURIComponent(t.userId)),
              s = "";
          s = e === V.memberState.JOINED ? "joined" : e === V.memberState.INVITED ? "invited" : e === V.memberState.INVITED_BY_FRIEND ? "invited_by_friend" : e === V.memberState.INVITED_BY_NON_FRIEND ? "invited_by_non_friend" : "all", r(a, {
            state: s
          }, n);
        });
      }, this.getUnreadItemCount = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, i) {
          if (i) return void n(null, i);
          var a = se.API_USERS_USERID_UNREAD_ITEM_COUNT.replace("%s", encodeURIComponent(t.userId));
          r(a, {
            item_keys: e
          }, n);
        });
      }, this.getTotalUnreadMessageCount = function (e, n, t) {
        Ie.getInstance().ConnectionManager.ready(function (i, a) {
          if (a) return void t(null, a);
          var s = se.API_USERS_USERID_UNREAD_MESSAGE_COUNT.replace("%s", encodeURIComponent(i.userId)),
              o = {
            super_mode: n
          };
          null !== e && e.length > 0 && (o.custom_types = e), r(s, o, t);
        });
      }, this.getTotalUnreadChannelCount = function (e) {
        Ie.getInstance().ConnectionManager.ready(function (n, t) {
          if (t) return void e(null, t);
          var i = se.API_USERS_USERID_UNREAD_CHANNEL_COUNT.replace("%s", encodeURIComponent(n.userId));
          r(i, e);
        });
      }, this.getMyMutedInfo = function (e, n, t, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = e ? se.API_GROUPCHANNELS_CHANNELURL_MUTE_USERID.replace("%s", encodeURIComponent(n)).replace("%s", encodeURIComponent(t)) : se.API_OPENCHANNELS_CHANNELURL_MUTE_USERID.replace("%s", encodeURIComponent(n)).replace("%s", encodeURIComponent(t));
          r(o, i);
        });
      }, this.checkRouting = function (e) {
        Ie.getInstance() && Ie.getInstance().customApiHost && Ie.getInstance().customWsHost ? "function" == typeof e && e({
          API_HOST: Ie.getInstance().customApiHost,
          WS_HOST: Ie.getInstance().customWsHost
        }) : e({
          API_HOST: se.API_ROUTING_URL.replace("%s", T),
          WS_HOST: "wss://ws-%s.sendbird.com".replace("%s", T)
        }, null);
      };

      var n = function n(e, _n2, t, r, i, a, s, o, l) {
        se.getInstance().checkRouting(function (n, u) {
          if (u) return void s(null, new g("Request failed.", N.REQUEST_FAILED));
          var c = {
            file: t,
            fileType: r,
            channelUrl: a,
            thumbnailSizes: i
          };
          R.upload(n.API_HOST + e, c, l, o, s);
        });
      },
          t = function t(e, n, _t2) {
        "function" == typeof n && (_t2 = n, n = {}), se.getInstance().checkRouting(function (r, i) {
          i ? _t2(null, new g("Request failed.", N.REQUEST_FAILED)) : R["delete"](r.API_HOST + e, n, _t2);
        });
      },
          r = function r(e, n, t) {
        "function" == typeof n && (t = n, n = {}), se.getInstance().checkRouting(function (r, i) {
          i ? t(null, new g("Request failed.", N.REQUEST_FAILED)) : R.get(r.API_HOST + e, n, t);
        });
      },
          i = function i(e, n, t) {
        "function" == typeof n && (t = n, n = {}), se.getInstance().checkRouting(function (r, i) {
          i ? t(null, i) : R.post(r.API_HOST + e, n, t);
        });
      },
          a = function a(e, n, t) {
        "function" == typeof n && (t = n, n = {}), se.getInstance().checkRouting(function (r, i) {
          i ? t(null, i) : R.put(r.API_HOST + e, n, t);
        });
      };

      this.addFriends = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var a = se.API_FRIENDS.replace("%s", encodeURIComponent(t.userId));
          i(a, {
            user_ids: e
          }, n);
        });
      }, this.deleteFriends = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void n(null, i);
          var a = se.API_FRIENDS.replace("%s", encodeURIComponent(r.userId));
          t(a, {
            user_ids: e
          }, n);
        });
      }, this.deleteFriendDiscoveries = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void n(null, i);
          var a = se.API_FRIENDS_DISCOVERIES.replace("%s", encodeURIComponent(r.userId));
          t(a, {
            friend_discovery_keys: e
          }, n);
        });
      }, this.uploadFriendDiscoveries = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var i = se.API_FRIENDS_DISCOVERIES.replace("%s", encodeURIComponent(t.userId)),
              s = {
            friend_discoveries: []
          };
          e.forEach(function (e) {
            s.friend_discoveries.push({
              friend_discovery_key: e.friendDiscoveryKey,
              friend_name: "string" == typeof e.friendName || e.friendName ? e.friendName : null
            });
          }), a(i, s, n);
        });
      }, this.getFriendChangeLogsByToken = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, i) {
          if (i) return void n(null, i);
          var a = se.API_FRIENDS_CHANGE_LOGS.replace("%s", encodeURIComponent(t.userId)),
              s = {};
          e && (s.token = e), r(a, s, n);
        });
      }, this.friendListQuery = function (e, n, t) {
        Ie.getInstance().ConnectionManager.ready(function (i, a) {
          if (a) return void t(null, a);
          var s = se.API_FRIENDS.replace("%s", encodeURIComponent(i.userId));
          r(s, {
            limit: n,
            token: e
          }, t);
        });
      }, this.createUserMetaData = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var a = se.API_USERS_USERID_METADATA.replace("%s", encodeURIComponent(t.userId)),
              s = {};
          s.metadata = e, i(a, s, n);
        });
      }, this.updateUserMetaData = function (e, n, t) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void t(null, i);
          var s = se.API_USERS_USERID_METADATA.replace("%s", encodeURIComponent(r.userId)),
              o = {};
          o.metadata = e, o.upsert = n, a(s, o, t);
        });
      }, this.deleteAllUserMetaData = function (e) {
        Ie.getInstance().ConnectionManager.ready(function (n, r) {
          if (r) return void e(null, r);
          var i = se.API_USERS_USERID_METADATA.replace("%s", encodeURIComponent(n.userId));
          t(i, {}, e);
        });
      }, this.deleteUserMetaData = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void n(null, i);
          var a = se.API_USERS_USERID_METADATA_KEY.replace("%s", encodeURIComponent(r.userId)).replace("%s", encodeURIComponent(e));
          t(a, {}, n);
        });
      }, this.resetMyHistory = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var i = se.API_GROUPCHANNELS_RESET_USER_HISTORY.replace("%s", encodeURIComponent(e));
          a(i, {}, n);
        });
      }, this.groupChannelInvite = function (e, n, t) {
        Ie.getInstance().ConnectionManager.ready(function (r, a) {
          if (a) return void t(null, a);
          var s = se.API_GROUPCHANNELS_CHANNELURL_INVITE.replace("%s", encodeURIComponent(e)),
              o = {},
              l = [];

          try {
            Array.isArray(n) ? l = n : l.push(n);
          } catch (e) {
            t(null, new g("Invalid parameter.", N.INVALID_PARAMETER));
          }

          o.user_ids = l, i(s, o, t);
        });
      }, this.acceptInvitation = function (e, n, t) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void t(null, i);
          var s = se.API_GROUPCHANNELS_CHANNELURL_ACCEPT_INVITATION.replace("%s", encodeURIComponent(e)),
              o = {};
          o.user_id = r.userId, n && (o.access_code = n), a(s, o, t);
        });
      }, this.declineInvitation = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var i = se.API_GROUPCHANNELS_CHANNELURL_DECLINE_INVITATION.replace("%s", encodeURIComponent(e)),
              s = {};
          s.user_id = t.userId, a(i, s, n);
        });
      }, this.groupChannelHide = function (e, n, t) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void t(null, i);
          var s = se.API_GROUPCHANNELS_CHANNELURL_HIDE.replace("%s", encodeURIComponent(e)),
              o = {};
          o.user_id = r.userId, o.hide_previous_messages = n, a(s, o, t);
        });
      }, this.publicGroupChannelJoin = function (e, n, t) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void t(null, i);
          var s = se.API_GROUPCHANNELS_CHANNELURL_JOIN.replace("%s", encodeURIComponent(e)),
              o = {};
          o.user_id = r.userId, n && (o.access_code = n), a(s, o, t);
        });
      }, this.groupChannelLeave = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var i = se.API_GROUPCHANNELS_CHANNELURL_LEAVE.replace("%s", encodeURIComponent(e)),
              s = {};
          s.user_id = t.userId, a(i, s, n);
        });
      }, this.groupChannelMarkAsRead = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var i = se.API_GROUPCHANNELS_CHANNELURL_MESSAGES_MARKASREAD.replace("%s", encodeURIComponent(e)),
              s = {};
          s.user_id = t.userId, a(i, s, n);
        });
      }, this.groupChannelMarkAsReadAll = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var i = se.API_USERS_USERID_MARKASREADALL.replace("%s", encodeURIComponent(t.userId)),
              s = {};
          e && (s.channel_urls = e), a(i, s, n);
        });
      }, this.messageList = function (e, n, t, i, a, s, o, l, u, c, d, h) {
        Ie.getInstance().ConnectionManager.ready(function (p, f) {
          if (f) return void h(null, f);

          var _;

          _ = e ? String(se.API_OPENCHANNELS_CHANNELURL_MESSAGES.replace("%s", n)) : String(se.API_GROUPCHANNELS_CHANNELURL_MESSAGES.replace("%s", n));
          var I = {};
          I.is_sdk = String(!0), I.message_ts = String(t), I.prev_limit = String(i), I.next_limit = String(a), I.include = String(s), I.reverse = String(o), l && (I.message_type = String(l)), u && (I.custom_type = String(u)), c.length > 0 && (I.sender_ids = c), "boolean" == typeof d && (I.with_meta_array = d), r(_, I, h);
        });
      }, this.messageListByID = function (e, n, t, i, a, s, o, l, u, c, d, h) {
        Ie.getInstance().ConnectionManager.ready(function (p, f) {
          if (f) return void h(null, f);

          var _;

          _ = e ? String(se.API_OPENCHANNELS_CHANNELURL_MESSAGES.replace("%s", n)) : String(se.API_GROUPCHANNELS_CHANNELURL_MESSAGES.replace("%s", n));
          var I = {};
          I.is_sdk = String(!0), I.message_id = t, I.prev_limit = String(i), I.next_limit = String(a), I.include = String(s), I.reverse = String(o), l && (I.message_type = String(l)), u && (I.custom_type = String(u)), c.length > 0 && (I.sender_ids = c), "boolean" == typeof d && (I.with_meta_array = d), r(_, I, h);
        });
      }, this.updateUserInfo = function (e, n, t) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void t(null, i);
          var s = {};
          e && (s.nickname = e), n && (s.profile_url = n);
          var o = String(se.API_USERS_USERID).replace("%s", encodeURIComponent(r.userId));
          a(o, s, t);
        });
      }, this.updateCurrentUserInfoWithFile = function (e, n, t) {
        var r = this;
        Ie.getInstance().ConnectionManager.ready(function (i, s) {
          if (s) return void t(null, s);
          if ("string" == typeof n) r.updateUserInfo(i.userId, e, n, t);else {
            var o = u ? new u() : new FormData();
            o.append("nickname", e), o.append("profile_file", n, n.name);
            var l = String(se.API_USERS_USERID).replace("%s", encodeURIComponent(i.userId));
            a(l, o, t);
          }
        });
      }, this.getGroupChannel = function (e, n, t, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = se.API_GROUPCHANNELS_CHANNELURL.replace("%s", encodeURIComponent(e)),
              l = {
            member: String(n),
            read_receipt: String(t)
          };
          r(o, l, i);
        });
      }, this.getOpenChannel = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, i) {
          if (i) return void n(null, i);
          var a = se.API_OPENCHANNELS_CHANNELURL.replace("%s", encodeURIComponent(e));
          r(a, n);
        });
      }, this.createGroupChannel = function (e, n, t, r, a, s, o, l, c, d, h, p) {
        Ie.getInstance().ConnectionManager.ready(function (f, _) {
          if (_) return void p(null, _);
          var I = se.API_GROUPCHANNELS,
              g = [];
          "string" == typeof e ? g.push(e) : e.forEach(function (e) {
            g.push(e);
          }), g.push(f.userId);
          var m,
              E = g.filter(function (e, n) {
            return g.indexOf(e) === n;
          }),
              A = l.isPublic,
              y = l.channelUrl;
          r && "string" != typeof r ? (m = u ? new u() : new FormData(), r && m.append("cover_file", r, r.name), m.append("user_ids", E), null !== y && m.append("channel_url", y), null !== n && m.append("is_distinct", n), null !== o && m.append("is_super", o), null !== A && m.append("is_public", A), null !== d && m.append("is_ephemeral", d), h && m.append("access_code", h), null !== t && "string" == typeof t && m.append("name", t), a && m.append("data", a), s && m.append("custom_type", s), Array.isArray(c) && c.length > 0 && m.append("operator_ids", c)) : (m = {}, null !== r && "string" == typeof r && (m.cover_url = r), m.user_ids = E, null !== y && (m.channel_url = y), null !== n && (m.is_distinct = n), null !== o && (m.is_super = o), null !== A && (m.is_public = A), null !== d && (m.is_ephemeral = d), h && (m.access_code = h), null !== t && "string" == typeof t && (m.name = t), a && (m.data = a), s && (m.custom_type = s), Array.isArray(c) && c.length > 0 && (m.operator_ids = c)), i(I, m, p);
        });
      }, this.createOpenChannel = function (e, n, t, r, a, s) {
        Ie.getInstance().ConnectionManager.ready(function (o, l) {
          if (l) return void s(null, l);
          var c,
              d = String(se.API_OPENCHANNELS);
          n && "string" != typeof n ? (c = u ? new u() : new FormData(), n && c.append("cover_file", n, n.name), null !== e && "string" == typeof e && c.append("name", e), t && c.append("data", t), r && (Array.isArray(r) ? c.append("operators", r) : c.append("operators", [r])), a && c.append("custom_type", a)) : (c = {}, null !== n && "string" == typeof n && (c.cover_url = n), null !== e && "string" == typeof e && (c.name = e), t && (c.data = t), r && (Array.isArray(r) ? c.operators = r : c.operators = [r]), a && (c.custom_type = a)), i(d, c, s);
        });
      }, this.updateGroupChannel = function (e, n, t, r, i, s, o, l, c) {
        Ie.getInstance().ConnectionManager.ready(function (d, h) {
          if (h) return void c(null, h);
          var p,
              f = String(se.API_GROUPCHANNELS_CHANNELURL.replace("%s", encodeURIComponent(e)));
          r && "string" != typeof r ? (p = u ? new u() : new FormData(), null !== n && p.append("is_distinct", n), null !== o && p.append("is_public", o), null !== l && p.append("access_code", l), r && p.append("cover_file", r, r.name), null !== t && "string" == typeof t && p.append("name", t), null !== i && "string" == typeof i && p.append("data", i), null !== s && "string" == typeof s && p.append("custom_type", s)) : (p = {}, null !== n && (p.is_distinct = n), null !== o && (p.is_public = o), null !== l && (p.access_code = l), null !== r && "string" == typeof r && (p.cover_url = r), null !== t && "string" == typeof t && (p.name = t), null !== i && "string" == typeof i && (p.data = i), null !== s && "string" == typeof s && (p.custom_type = s)), a(f, p, c);
        });
      }, this.updateOpenChannel = function (e, n, t, r, i, s, o) {
        Ie.getInstance().ConnectionManager.ready(function (l, c) {
          if (c) return void o(null, c);
          var d,
              h = String(se.API_OPENCHANNELS_CHANNELURL.replace("%s", encodeURIComponent(e)));
          t && "string" != typeof t ? (d = u ? new u() : new FormData(), t && d.append("cover_file", t, t.name), null !== n && "string" == typeof n && d.append("name", n), null !== r && "string" == typeof r && d.append("data", r), null !== i && (Array.isArray(i) ? d.append("operators", i) : d.append("operators", [i])), null !== s && "string" == typeof s && d.append("custom_type", s)) : (d = {}, null !== t && "string" == typeof t && (d.cover_url = t), null !== n && "string" == typeof n && (d.name = n), null !== r && "string" == typeof r && (d.data = r), null !== i && (Array.isArray(i) ? d.operators = i : d.operators = [i]), null !== s && "string" == typeof s && (d.custom_type = s)), a(h, d, o);
        });
      }, this.deleteOpenChannel = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void n(null, i);
          var a = String(se.API_OPENCHANNELS_CHANNELURL.replace("%s", encodeURIComponent(e)));
          t(a, {}, n);
        });
      }, this.createMetaCounters = function (e, n, t, r) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void r(null, s);
          var o;
          o = e ? se.API_OPENCHANNELS_CHANNELURL_METACOUNTER.replace("%s", encodeURIComponent(n)) : se.API_GROUPCHANNELS_CHANNELURL_METACOUNTER.replace("%s", encodeURIComponent(n));
          var l = {};
          l.metacounter = t, i(o, l, r);
        });
      }, this.updateMetaCounters = function (e, n, t, r, i, s) {
        Ie.getInstance().ConnectionManager.ready(function (o, l) {
          if (l) return void s(null, l);
          var u;
          u = e ? se.API_OPENCHANNELS_CHANNELURL_METACOUNTER.replace("%s", encodeURIComponent(n)) : se.API_GROUPCHANNELS_CHANNELURL_METACOUNTER.replace("%s", encodeURIComponent(n));
          var c = {};

          switch (c.metacounter = t, c.upsert = r, i) {
            case se.UPDATE_META_COUNTER_MODE_SET:
              c.mode = "set";
              break;

            case se.UPDATE_META_COUNTER_MODE_INC:
              c.mode = "increase";
              break;

            case se.UPDATE_META_COUNTER_MODE_DEC:
              c.mode = "decrease";
          }

          a(u, c, s);
        });
      }, this.getAllMetaCounters = function (e, n, t) {
        this.getMetaCounters(e, n, [], t);
      }, this.getMetaCounters = function (e, n, t, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o;
          o = e ? se.API_OPENCHANNELS_CHANNELURL_METACOUNTER.replace("%s", encodeURIComponent(n)) : se.API_GROUPCHANNELS_CHANNELURL_METACOUNTER.replace("%s", encodeURIComponent(n)), r(o, {
            keys: t
          }, i);
        });
      }, this.deleteMetaCounter = function (e, n, r, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = "";
          o = e ? se.API_OPENCHANNELS_CHANNELURL_METACOUNTER_KEY.replace("%s", encodeURIComponent(n)).replace("%s", r) : se.API_GROUPCHANNELS_CHANNELURL_METACOUNTER_KEY.replace("%s", encodeURIComponent(n)).replace("%s", r), t(o, {}, i);
        });
      }, this.deleteAllMetaCounters = function (e, n, r) {
        Ie.getInstance().ConnectionManager.ready(function (i, a) {
          if (a) return void r(null, a);
          var s = "";
          s = e ? se.API_OPENCHANNELS_CHANNELURL_METACOUNTER.replace("%s", encodeURIComponent(n)) : se.API_GROUPCHANNELS_CHANNELURL_METACOUNTER.replace("%s", encodeURIComponent(n)), t(s, {}, r);
        });
      }, this.createMetaData = function (e, n, t, r) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void r(null, s);
          var o = "";
          o = e ? se.API_OPENCHANNELS_CHANNELURL_METADATA.replace("%s", encodeURIComponent(n)) : se.API_GROUPCHANNELS_CHANNELURL_METADATA.replace("%s", encodeURIComponent(n));
          var l = {},
              u = {};

          for (var c in t) {
            var d = t[c];
            u[c] = d;
          }

          l.metadata = u, i(o, l, r);
        });
      }, this.updateMetaData = function (e, n, t, r, i) {
        Ie.getInstance().ConnectionManager.ready(function (s, o) {
          if (o) return void i(null, o);
          var l = "";
          l = e ? se.API_OPENCHANNELS_CHANNELURL_METADATA.replace("%s", encodeURIComponent(n)) : se.API_GROUPCHANNELS_CHANNELURL_METADATA.replace("%s", encodeURIComponent(n));
          var u = {},
              c = {};

          for (var d in t) {
            var h = t[d];
            c[d] = h;
          }

          u.metadata = c, u.upsert = r, a(l, u, i);
        });
      }, this.getAllMetaData = function (e, n, t) {
        this.getMetaData(e, n, [], t);
      }, this.getMetaData = function (e, n, t, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = "";
          o = e ? se.API_OPENCHANNELS_CHANNELURL_METADATA.replace("%s", encodeURIComponent(n)) : se.API_GROUPCHANNELS_CHANNELURL_METADATA.replace("%s", encodeURIComponent(n)), r(o, {
            keys: t
          }, i);
        });
      }, this.deleteMetaData = function (e, n, r, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = "";
          o = e ? se.API_OPENCHANNELS_CHANNELURL_METADATA_KEY.replace("%s", encodeURIComponent(n)).replace("%s", r) : se.API_GROUPCHANNELS_CHANNELURL_METADATA_KEY.replace("%s", encodeURIComponent(n)).replace("%s", r), t(o, {}, i);
        });
      }, this.deleteAllMetaData = function (e, n, r) {
        Ie.getInstance().ConnectionManager.ready(function (i, a) {
          if (a) return void r(null, a);
          var s = "";
          s = e ? se.API_OPENCHANNELS_CHANNELURL_METADATA.replace("%s", encodeURIComponent(n)) : se.API_GROUPCHANNELS_CHANNELURL_METADATA.replace("%s", encodeURIComponent(n)), t(s, {}, r);
        });
      }, this.loadUserList = function (e, n, t, i, a, s) {
        Ie.getInstance().ConnectionManager.ready(function (o, l) {
          if (l) return void s(null, l);
          var u = se.API_USERS,
              c = {
            token: e,
            limit: String(n)
          };
          if (!f(t)) try {
            c.user_ids = t;
          } catch (e) {}
          i && !f(a) && (c.metadatakey = i, c.metadatavalues_in = a), r(u, c, s);
        });
      }, this.loadBlockedUserList = function (e, n, t, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = se.API_USERS_USERID_BLOCK.replace("%s", encodeURIComponent(e)),
              l = {
            token: n,
            limit: String(t)
          };
          r(o, l, i);
        });
      }, this.loadOpenChannelList = function (e, n, t, i, a, s) {
        Ie.getInstance().ConnectionManager.ready(function (o, l) {
          if (l) return void s(null, l);
          var u = se.API_OPENCHANNELS,
              c = {
            token: e,
            limit: String(n)
          };
          null !== t && (c.name_contains = t), i && (c.url_contains = i), null !== a && (c.custom_type = a), r(u, c, s);
        });
      }, this.sendFileMessageAPI = function (e, n, t, r, a, s, o, l, u, c, d, h, p, f, _) {
        Ie.getInstance().ConnectionManager.ready(function (I, g) {
          if (g) return void _(null, g);
          var m = n ? se.API_OPENCHANNELS_CHANNELURL_MESSAGES.replace("%s", encodeURIComponent(e)) : se.API_GROUPCHANNELS_CHANNELURL_MESSAGES.replace("%s", encodeURIComponent(e)),
              E = {
            message_type: "FILE",
            user_id: I.userId,
            url: t,
            mention_type: h,
            mentioned_user_ids: []
          };

          if (null !== r && void 0 !== r && (E.file_name = r), null !== a && void 0 !== a && (E.file_size = a), null !== s && void 0 !== s && (E.file_type = s), null !== o && void 0 !== o && (E.custom_field = o), null !== l && void 0 !== l && (E.custom_type = l), u && (E.thumbnails = u), c && (E.require_auth = c), null !== d && d !== undefined && Array.isArray(d)) {
            var A = !0;

            for (var y in d) {
              var v = d[y];

              if ("string" != typeof v || "" === v) {
                A = !1;
                break;
              }
            }

            if (A) {
              var N = {};

              for (var y in d) {
                var v = d[y];
                N[v] = [];
              }

              E.metaarray = N;
            }
          }

          h === de.MentionType.CHANNEL ? E.mentioned_user_ids = [] : Array.isArray(p) && p.length > 0 && (E.mentioned_user_ids = p), f && f !== pe.PushNotificationDeliveryOption.DEFAULT && (E.push_option = f), i(m, E, _);
        }, !0);
      }, this.uploadFile = function (e, t, r, i, a, s, o) {
        Ie.getInstance().ConnectionManager.ready(function (l, u) {
          if (u) return void a(null, u);
          n(se.API_STORAGE_FILE, 0, e, t, r, i, a, s, o);
        });
      }, this.loadOperatorList = function (e, n, t, i, a) {
        Ie.getInstance().ConnectionManager.ready(function (s, o) {
          if (o) return void a(null, o);
          var l = n ? se.API_OPENCHANNELS_OPERATORS.replace("%url", encodeURIComponent(e)) : se.API_GROUPCHANNELS_OPERATORS.replace("%url", encodeURIComponent(e));
          r(l, {
            token: t,
            limit: i
          }, a);
        });
      }, this.loadGroupChannelMemberList = function (e, n, t, i, a, s, o, l, u) {
        Ie.getInstance().ConnectionManager.ready(function (c, d) {
          if (d) return void u(null, d);
          var h = se.API_GROUPCHANNELS_MEMBERS.replace("%url", encodeURIComponent(e)),
              p = {
            token: n,
            limit: t,
            muted_member_filter: i.toLowerCase(),
            operator_filter: a.toLowerCase(),
            member_state_filter: s,
            order: l.toLowerCase()
          };
          o && (p.nickname_startswith = o), r(h, p, u);
        });
      }, this.loadPublicGroupChannelList = function (e, n, t, i, a, s, o, l, u, c, d, h) {
        Ie.getInstance().ConnectionManager.ready(function (p, f) {
          if (f) return void h(null, f);
          var _ = se.API_GROUPCHANNELS,
              I = {
            public_mode: V.publicChannelFilter.PUBLIC,
            token: e,
            limit: String(n),
            show_member: !0,
            show_read_receipt: !0,
            show_empty: String(t),
            order: i
          };
          if (a) try {
            I.name_contains = a;
          } catch (e) {}
          if (s.length > 0) try {
            I.channel_urls = s;
          } catch (e) {}
          o.length > 0 && (I.custom_types = o), l && (I.custom_type_startswith = l), d && (I.metadata_order_key = d), I.super_mode = u, I.public_membership_mode = c, r(_, I, h);
        });
      }, this.loadUserGroupChannelList = function (e, n, t, i, a, s, o, l, u, c, d, h, p, f, _, I, g) {
        Ie.getInstance().ConnectionManager.ready(function (m, E) {
          if (E) return void g(null, E);
          var A = se.API_MYGROUPCHANNELS.replace("%s", encodeURIComponent(m.userId)),
              y = a.userIds,
              v = !a.includeMode,
              N = a.queryType,
              C = {
            token: e,
            limit: String(n),
            show_member: !0,
            show_read_receipt: !0,
            show_empty: String(t),
            order: i,
            member_state_filter: h
          };
          if (c.length > 0 ? C.custom_types = c : u && (C.custom_type = u), s) try {
            C.members_nickname_contains = s;
          } catch (e) {}
          if (o) try {
            C.name_contains = o;
          } catch (e) {}
          if (y.length > 0) try {
            v ? C.members_exactly_in = y : (C.members_include_in = y, C.query_type = N);
          } catch (e) {}
          if (l.length > 0) try {
            C.channel_urls = l;
          } catch (e) {}
          C.super_mode = p, C.public_mode = f, C.unread_filter = _, I && (C.metadata_order_key = I), d && (C.custom_type_startswith = d), r(A, C, g);
        });
      }, this.loadOpenChannelParticipantList = function (e, n, t, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = se.API_OPENCHANNELS_CHANNELURL_PARTICIPANTS.replace("%s", e),
              l = {
            token: n,
            limit: String(t)
          };
          r(o, l, i);
        });
      }, this.loadMutedUserList = function (e, n, t, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = e.isOpenChannel() ? se.API_OPENCHANNELS_CHANNELURL_MUTE.replace("%s", e.url) : se.API_GROUPCHANNELS_CHANNELURL_MUTE.replace("%s", e.url),
              l = {
            token: n,
            limit: String(t)
          };
          r(o, l, i);
        });
      }, this.loadBannedUserList = function (e, n, t, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = e.isOpenChannel() ? se.API_OPENCHANNELS_CHANNELURL_BAN.replace("%s", e.url) : se.API_GROUPCHANNELS_CHANNELURL_BAN.replace("%s", e.url),
              l = {
            token: n,
            limit: String(t)
          };
          r(o, l, i);
        });
      }, this.setPushTemplate = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var i = se.API_USERS_USERID_PUSH_TEMPLATE.replace("%s", encodeURIComponent(t.userId));
          a(i, {
            name: e
          }, n);
        });
      }, this.getPushTemplate = function (e) {
        Ie.getInstance().ConnectionManager.ready(function (n, t) {
          if (t) return void e(null, t);
          var i = se.API_USERS_USERID_PUSH_TEMPLATE.replace("%s", encodeURIComponent(n.userId));
          r(i, e);
        });
      }, this.setDoNotDisturb = function (e, n, t, r, i, s, o) {
        Ie.getInstance().ConnectionManager.ready(function (l, u) {
          if (u) return void o(null, u);
          var c = se.API_USERS_USERID_PUSHPREFERENCE.replace("%s", encodeURIComponent(l.userId));
          a(c, {
            do_not_disturb: e,
            start_hour: n,
            start_min: t,
            end_hour: r,
            end_min: i,
            timezone: s
          }, o);
        });
      }, this.getDoNotDisturb = function (e) {
        Ie.getInstance().ConnectionManager.ready(function (n, t) {
          if (t) return void e(null, t);
          var i = se.API_USERS_USERID_PUSHPREFERENCE.replace("%s", encodeURIComponent(n.userId));
          r(i, e);
        });
      }, this.setPushPreference = function (e, n, t) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void t(null, i);
          var s = se.API_USERS_USERID_PUSHPREFERENCE_CHANNELURL.replace("%s", encodeURIComponent(r.userId)).replace("%s", encodeURIComponent(e)),
              o = {};
          o.enable = n, a(s, o, t);
        });
      }, this.getPushPreference = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, i) {
          if (i) return void n(null, i);
          var a = se.API_USERS_USERID_PUSHPREFERENCE_CHANNELURL.replace("%s", encodeURIComponent(t.userId)).replace("%s", encodeURIComponent(e));
          r(a, n);
        });
      }, this.setCountPreference = function (e, n, t) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void t(null, i);
          var s = se.API_USERS_COUNT_PREFERENCE.replace("%s", encodeURIComponent(r.userId)).replace("%s", encodeURIComponent(e)),
              o = {};
          o.count_preference = n, a(s, o, t);
        });
      }, this.registerGCMPushToken = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var a = se.API_USERS_USERID_PUSH_GCM.replace("%s", encodeURIComponent(t.userId));
          i(a, {
            gcm_reg_token: e
          }, n);
        });
      }, this.unregisterGCMPushToken = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void n(null, i);
          var a = se.API_USERS_USERID_PUSH_GCM_TOKEN.replace("%s", encodeURIComponent(r.userId)).replace("%s", encodeURIComponent(e));
          t(a, n);
        });
      }, this.unregisterGCMPushTokenAll = function (e) {
        Ie.getInstance().ConnectionManager.ready(function (n, r) {
          if (r) return void e(null, r);
          var i = se.API_USERS_USERID_PUSH_GCM.replace("%s", encodeURIComponent(n.userId));
          t(i, e);
        });
      }, this.registerAPNSPushToken = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var a = se.API_USERS_USERID_PUSH_APNS.replace("%s", encodeURIComponent(t.userId));
          i(a, {
            apns_device_token: e
          }, n);
        });
      }, this.unregisterAPNSPushToken = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void n(null, i);
          var a = se.API_USERS_USERID_PUSH_APNS_TOKEN.replace("%s", encodeURIComponent(r.userId)).replace("%s", encodeURIComponent(e));
          t(a, n);
        });
      }, this.unregisterAPNSPushTokenAll = function (e) {
        Ie.getInstance().ConnectionManager.ready(function (n, r) {
          if (r) return void e(null, r);
          var i = se.API_USERS_USERID_PUSH_APNS.replace("%s", encodeURIComponent(n.userId));
          t(i, e);
        });
      }, this.unregisterPushTokenAll = function (e) {
        Ie.getInstance().ConnectionManager.ready(function (n, r) {
          if (r) return void e(null, r);
          var i = se.API_USERS_USERID_PUSH.replace("%s", encodeURIComponent(n.userId));
          t(i, e);
        });
      }, this.blockUser = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void n(null, r);
          var a = se.API_USERS_USERID_BLOCK.replace("%s", encodeURIComponent(t.userId));
          i(a, {
            target_id: e
          }, n);
        });
      }, this.unblockUser = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (r, i) {
          if (i) return void n(null, i);
          var a = se.API_USERS_USERID_BLOCK_TARGETID.replace("%s", encodeURIComponent(r.userId)).replace("%s", encodeURIComponent(e));
          t(a, {}, n);
        });
      }, this.banUser = function (e, n, t, r, a, s) {
        Ie.getInstance().ConnectionManager.ready(function (o, l) {
          if (l) return void s(null, l);
          var u = a ? se.API_GROUPCHANNELS_CHANNELURL_BAN.replace("%s", encodeURIComponent(e)) : se.API_OPENCHANNELS_CHANNELURL_BAN.replace("%s", encodeURIComponent(e)),
              c = {
            user_id: n
          };
          t && (c.description = t), c.seconds = String(r), i(u, c, s);
        });
      }, this.unbanUser = function (e, n, r, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = r ? se.API_GROUPCHANNELS_CHANNELURL_BAN_USERID.replace("%s", encodeURIComponent(e)).replace("%s", encodeURIComponent(n)) : se.API_OPENCHANNELS_CHANNELURL_BAN_USERID.replace("%s", encodeURIComponent(e)).replace("%s", encodeURIComponent(n));
          t(o, {}, i);
        });
      }, this.muteUser = function (e, n, t, r, a, s) {
        Ie.getInstance().ConnectionManager.ready(function (o, l) {
          if (l) return void s(null, l);
          var u = t ? se.API_GROUPCHANNELS_CHANNELURL_MUTE.replace("%s", encodeURIComponent(e)) : se.API_OPENCHANNELS_CHANNELURL_MUTE.replace("%s", encodeURIComponent(e)),
              c = {
            user_id: n
          };
          r && (r > 0 || -1 !== r) && (c.seconds = r), a && (c.description = a), i(u, c, s);
        });
      }, this.unmuteUser = function (e, n, r, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = r ? se.API_GROUPCHANNELS_CHANNELURL_MUTE_USERID.replace("%s", encodeURIComponent(e)).replace("%s", encodeURIComponent(n)) : se.API_OPENCHANNELS_CHANNELURL_MUTE_USERID.replace("%s", encodeURIComponent(e)).replace("%s", encodeURIComponent(n));
          t(o, {}, i);
        });
      }, this.deleteMessage = function (e, n, r, i) {
        Ie.getInstance().ConnectionManager.ready(function (a, s) {
          if (s) return void i(null, s);
          var o = "";
          o = e ? se.API_OPENCHANNELS_CHANNELURL_MESSAGES_MESSAGEID.replace("%s", encodeURIComponent(n)).replace("%s", encodeURIComponent(r)) : se.API_GROUPCHANNELS_CHANNELURL_MESSAGES_MESSAGEID.replace("%s", encodeURIComponent(n)).replace("%s", encodeURIComponent(r)), t(o, {}, i);
        });
      }, this.freeze = function (e, n, t, r) {
        Ie.getInstance().ConnectionManager.ready(function (i, s) {
          if (s) return void r(null, s);
          var o = n ? se.API_GROUPCHANNELS_CHANNELURL_FREEZE.replace("%s", encodeURIComponent(e)) : se.API_OPENCHANNELS_CHANNELURL_FREEZE.replace("%s", encodeURIComponent(e));
          a(o, {
            freeze: t
          }, r);
        });
      };
    },
        oe = null;

    se.getInstance = function () {
      return null === oe ? null : oe;
    }, se.API_VERSION = "v3", se.API_ROUTING_URL = "https://api-%s.sendbird.com", se.API_USERS = "/%v/users".replace("%v", se.API_VERSION), se.API_USERS_USERID_LOGIN = "/%v/users/%s/login".replace("%v", se.API_VERSION), se.API_USERS_USERID = "/%v/users/%s".replace("%v", se.API_VERSION), se.API_USERS_USERID_UNREAD_ITEM_COUNT = "/%v/users/%s/unread_item_count".replace("%v", se.API_VERSION), se.API_USERS_USERID_METADATA = "/%v/users/%s/metadata".replace("%v", se.API_VERSION), se.API_USERS_USERID_METADATA_KEY = "/%v/users/%s/metadata/%s".replace("%v", se.API_VERSION), se.API_USERS_USERID_UNREAD_MESSAGE_COUNT = "/%v/users/%s/unread_message_count".replace("%v", se.API_VERSION), se.API_USERS_USERID_UNREAD_CHANNEL_COUNT = "/%v/users/%s/unread_channel_count".replace("%v", se.API_VERSION), se.API_USERS_USERID_MARKASREADALL = "/%v/users/%s/mark_as_read_all".replace("%v", se.API_VERSION), se.API_USERS_USERID_PUSH_GCM_TOKEN = "/%v/users/%s/push/gcm/%s".replace("%v", se.API_VERSION), se.API_USERS_USERID_PUSH_GCM = "/%v/users/%s/push/gcm".replace("%v", se.API_VERSION), se.API_USERS_USERID_PUSHPREFERENCE_CHANNELURL = "/%v/users/%s/push_preference/%s".replace("%v", se.API_VERSION), se.API_USERS_USERID_PUSHPREFERENCE = "/%v/users/%s/push_preference/".replace("%v", se.API_VERSION), se.API_USERS_USERID_PUSH_TEMPLATE = "/%v/users/%s/push/template".replace("%v", se.API_VERSION), se.API_USERS_USERID_BLOCK = "/%v/users/%s/block".replace("%v", se.API_VERSION), se.API_USERS_USERID_BLOCK_TARGETID = "/%v/users/%s/block/%s".replace("%v", se.API_VERSION), se.API_USERS_USERID_PUSH_APNS_TOKEN = "/%v/users/%s/push/apns/%s".replace("%v", se.API_VERSION), se.API_USERS_USERID_PUSH_APNS = "/%v/users/%s/push/apns".replace("%v", se.API_VERSION), se.API_USERS_USERID_PUSH = "/%v/users/%s/push".replace("%v", se.API_VERSION), se.API_USERS_USERID_GROUP_CHANNEL_INVITATION_PREFERENCE = "/%v/users/%s/channel_invitation_preference".replace("%v", se.API_VERSION), se.API_USERS_USERID_GROUP_CHANNEL_COUNT = "/%v/users/%s/group_channel_count".replace("%v", se.API_VERSION), se.API_USERS_COUNT_PREFERENCE = "/%v/users/%s/count_preference/%s".replace("%v", se.API_VERSION), se.API_OPENCHANNELS = "/%v/open_channels".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL = "/%v/open_channels/%s".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_MESSAGES = "/%v/open_channels/%s/messages".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_MESSAGES_MESSAGEID = "/%v/open_channels/%s/messages/%s".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_SCHEDULED_MESSAGES = "/%v/open_channels/%s/scheduled_messages".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_PARTICIPANTS = "/%v/open_channels/%s/participants".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_METADATA = "/%v/open_channels/%s/metadata".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_METADATA_KEY = "/%v/open_channels/%s/metadata/%s".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_METACOUNTER = "/%v/open_channels/%s/metacounter".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_METACOUNTER_KEY = "/%v/open_channels/%s/metacounter/%s".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_BAN = "/%v/open_channels/%s/ban".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_BAN_USERID = "/%v/open_channels/%s/ban/%s".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_MUTE = "/%v/open_channels/%s/mute".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_MUTE_USERID = "/%v/open_channels/%s/mute/%s".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_FREEZE = "/%v/open_channels/%s/freeze".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS = "/%v/group_channels".replace("%v", se.API_VERSION), se.API_MYGROUPCHANNELS = "/%v/users/%s/my_group_channels".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL = "/%v/group_channels/%s".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_INVITE = "/%v/group_channels/%s/invite".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_ACCEPT_INVITATION = "/%v/group_channels/%s/accept".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_DECLINE_INVITATION = "/%v/group_channels/%s/decline".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_HIDE = "/%v/group_channels/%s/hide".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_LEAVE = "/%v/group_channels/%s/leave".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_JOIN = "/%v/group_channels/%s/join".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_MESSAGES = "/%v/group_channels/%s/messages".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_MESSAGES_MARKASREAD = "/%v/group_channels/%s/messages/mark_as_read".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_MESSAGES_TOTALCOUNT = "/%v/group_channels/%s/messages/total_count".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_MESSAGES_UNREADCOUNT = "/%v/group_channels/%s/messages/unread_count".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_MESSAGES_MESSAGEID = "/%v/group_channels/%s/messages/%s".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_SCHEDULED_MESSAGES = "/%v/group_channels/%s/scheduled_messages".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_MEMBERS = "/%v/group_channels/%s/members".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_METADATA = "/%v/group_channels/%s/metadata".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_METADATA_KEY = "/%v/group_channels/%s/metadata/%s".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_METACOUNTER = "/%v/group_channels/%s/metacounter".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_METACOUNTER_KEY = "/%v/group_channels/%s/metacounter/%s".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_RESET_USER_HISTORY = "/%v/group_channels/%s/reset_user_history".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_MEMBERS = "/%v/group_channels/%url/members".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_BAN = "/%v/group_channels/%s/ban".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_BAN_USERID = "/%v/group_channels/%s/ban/%s".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_MUTE = "/%v/group_channels/%s/mute".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_MUTE_USERID = "/%v/group_channels/%s/mute/%s".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_FREEZE = "/%v/group_channels/%s/freeze".replace("%v", se.API_VERSION), se.API_STORAGE_FILE = "/%v/storage/file".replace("%v", se.API_VERSION), se.API_STORAGE_PROFILE = "/%v/storage/profile_image".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_CHANNELURL_MESSAGES_CHANGELOGS = "/%v/open_channels/%s/messages/changelogs".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_CHANNELURL_MESSAGES_CHANGELOGS = "/%v/group_channels/%s/messages/changelogs".replace("%v", se.API_VERSION), se.API_FRIENDS = "/%v/users/%s/friends".replace("%v", se.API_VERSION), se.API_FRIENDS_CHANGE_LOGS = "/%v/users/%s/friends/changelogs".replace("%v", se.API_VERSION), se.API_FRIENDS_DISCOVERIES = "/%v/users/%s/friend_discoveries".replace("%v", se.API_VERSION), se.API_GROUPCHANNELS_OPERATORS = "/%v/group_channels/%url/operators".replace("%v", se.API_VERSION), se.API_OPENCHANNELS_OPERATORS = "/%v/open_channels/%url/operators".replace("%v", se.API_VERSION), se.UPDATE_META_COUNTER_MODE_SET = 0, se.UPDATE_META_COUNTER_MODE_INC = 1, se.UPDATE_META_COUNTER_MODE_DEC = 2;

    var le = function le() {
      var e = "";
      this.isLoading = !1, this.hasMore = !0, this.limit = 20;
      var n = this;

      this.next = function (t) {
        return _(n.limit) ? n.hasMore ? n.isLoading ? void U(null, new g("Query in progress.", N.QUERY_IN_PROGRESS), t) : (n.isLoading = !0, void se.getInstance().friendListQuery(e, n.limit, function (r, i) {
          if (i) return n.isLoading = !1, void U(null, i, t);
          var a = r.users,
              s = a.map(function (e) {
            return new q(e);
          });
          n.hasMore = r.has_more, n.isLoading = !1, e = r.next, U(s, null, t);
        })) : void U([], null, t) : void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
      };
    },
        ue = function ue(e, n, t, r) {
      h ? this[t] = e[n] : Object.defineProperty(e, t, {
        get: function get() {
          return "_coverUrl" === n || "_coverImage" === n ? e._channelCover : e[n];
        },
        set: function set(t) {
          if ("file" === r) {
            if ("string" == typeof t || "object" != typeof t) return;
          } else if (r && typeof t !== r) return;

          e[n] = t, "_coverUrl" !== n && "_coverImage" !== n || (e._channelCover = t);
        }
      });
    },
        ce = function ce() {
      this._isDistinct = null, ue(this, "_isDistinct", "isDistinct", "boolean"), this._isSuper = null, ue(this, "_isSuper", "isSuper", "boolean"), this._isPublic = null, ue(this, "_isPublic", "isPublic", "boolean"), this._channelUrl = null, ue(this, "_channelUrl", "channelUrl", "string"), this._name = null, ue(this, "_name", "name", "string"), this._data = null, ue(this, "_data", "data", "string"), this._customType = null, ue(this, "_customType", "customType", "string"), this._channelCover = null, ue(this, "_channelCover", "channelCover", null), this._coverUrl = null, ue(this, "_coverUrl", "coverUrl", "string"), this._coverImage = null, ue(this, "_coverImage", "coverImage", "file"), this._accessCode = null, ue(this, "_accessCode", "accessCode", "string"), this._operatorIds = [], this._operators = null, h ? this.operators = this._operators : Object.defineProperty(this, "operators", {
        get: function get() {
          return this._operators;
        },
        set: function set(e) {
          if (Array.isArray(e)) {
            for (var n = [], t = 0; t < e.length; t++) {
              e[t].hasOwnProperty("userId") ? n.push(e[t].userId) : n = [];
            }

            n.length === e.length && (this._operatorIds = n);
          }
        }
      }), this._operatorUserIds = null, h ? this.operatorUserIds = this._operatorUserIds : Object.defineProperty(this, "operatorUserIds", {
        get: function get() {
          return this._operatorUserIds;
        },
        set: function set(e) {
          if (Array.isArray(e)) {
            for (var n = [], t = 0; t < e.length; t++) {
              "string" == typeof e[t] ? n.push(e[t]) : n = [];
            }

            n.length === e.length && (this._operatorIds = n);
          }
        }
      }), this._isEphemeral = null, ue(this, "_isEphemeral", "isEphemeral", "boolean"), this._inviteUserIds = [], this.addUsers = function (e) {
        if (Array.isArray(e)) {
          for (var n = e.length, t = [], r = 0; r < n; r++) {
            e[r].hasOwnProperty("userId") ? t.push(e[r].userId) : t = [];
          }

          t.length > 0 && (this._inviteUserIds = this._inviteUserIds.concat(t));
        }
      }, this.addUser = function (e) {
        e.hasOwnProperty("userId") && this._inviteUserIds.push(e.userId);
      }, this.addUserIds = function (e) {
        if (Array.isArray(e)) {
          for (var n = e.length, t = [], r = 0; r < n; r++) {
            "string" == typeof e[r] ? t.push(e[r]) : t = [];
          }

          t.length > 0 && (this._inviteUserIds = this._inviteUserIds.concat(t));
        }
      }, this.addUserId = function (e) {
        "string" == typeof e && this._inviteUserIds.push(e);
      };
    },
        de = function de() {};

    de.MentionType = {
      USERS: "users",
      CHANNEL: "channel"
    }, de.PushNotificationDeliveryOption = {
      DEFAULT: "default",
      SUPPRESS: "suppress"
    };

    var he = function he() {
      this._message = null, ue(this, "_message", "message", "string"), this._translationTargetLanguages = null, h ? this.translationTargetLanguages = this._translationTargetLanguages : Object.defineProperty(this, "translationTargetLanguages", {
        get: function get() {
          return this._translationTargetLanguages;
        },
        set: function set(e) {
          if (Array.isArray(e)) {
            for (var n = 0; n < e.length; n++) {
              if ("string" != typeof e[n]) return void (this._translationTargetLanguages = []);
            }

            this._translationTargetLanguages = e;
          }
        }
      }), this._targetLanguages = null, h ? this.targetLanguages = this._translationTargetLanguages : Object.defineProperty(this, "targetLanguages", {
        get: function get() {
          return this._translationTargetLanguages;
        },
        set: function set(e) {
          this.translationTargetLanguages = e;
        }
      }), this._data = null, ue(this, "_data", "data", "string"), this._customType = null, ue(this, "_customType", "customType", "string"), this._mentionType = de.MentionType.USERS, h ? this.mentionType = this._mentionType : Object.defineProperty(this, "mentionType", {
        get: function get() {
          return this._mentionType;
        },
        set: function set(e) {
          [de.MentionType.USERS, de.MentionType.CHANNEL].indexOf(e) < 0 || (this._mentionType = e);
        }
      }), this._metaArrayKeys = [], h ? this.metaArrayKeys = this._metaArrayKeys : Object.defineProperty(this, "metaArrayKeys", {
        get: function get() {
          return this._metaArrayKeys;
        },
        set: function set(e) {
          var n = [];
          if (Array.isArray(e)) for (var t = 0; t < e.length; t++) {
            "string" == typeof e[t] && n.indexOf(e[t]) < 0 && n.push(e[t]);
          }
          this._metaArrayKeys = n;
        }
      }), this._mentionedIds = [], this._mentionedUsers = null, h ? this.mentionedUsers = this._mentionedUsers : Object.defineProperty(this, "mentionedUsers", {
        get: function get() {
          return this._mentionedUsers;
        },
        set: function set(e) {
          if (Array.isArray(e)) {
            for (var n = [], t = [], r = {}, i = 0; i < e.length; i++) {
              if (!e[i].hasOwnProperty("userId")) return this._mentionedIds = [], void (this._mentionedUsers = []);
              r[e[i].userId] || (r[e[i].userId] = !0, Ie.getInstance().getCurrentUserId() !== e[i].userId && (n.push(e[i]), t.push(e[i].userId)));
            }

            this._mentionedUserIds = [], this._mentionedIds = t, this._mentionedUsers = n;
          }
        }
      }), this._mentionedUserIds = null, h ? this.mentionedUserIds = this._mentionedUserIds : Object.defineProperty(this, "mentionedUserIds", {
        get: function get() {
          return this._mentionedUserIds;
        },
        set: function set(e) {
          if (Array.isArray(e)) {
            for (var n = [], t = {}, r = 0; r < e.length; r++) {
              if ("string" != typeof e[r]) return this._mentionedIds = [], void (this._mentionedUserIds = []);
              t[e[r]] || (t[e[r]] = !0, Ie.getInstance().getCurrentUserId() !== e[r] && n.push(e[r]));
            }

            this._mentionedUsers = [], this._mentionedIds = n, this._mentionedUserIds = n;
          }
        }
      }), this._pushNotificationDeliveryOption = null, ue(this, "_pushNotificationDeliveryOption", "pushNotificationDeliveryOption", "string");
    };

    he.PushNotificationDeliveryOption = {
      DEFAULT: "default",
      SUPPRESS: "suppress"
    };

    var pe = function pe() {
      this._file = null, h ? this.file = this._file : Object.defineProperty(this, "file", {
        get: function get() {
          return this._file;
        },
        set: function set(e) {
          "string" != typeof e && "object" == typeof e && (this._fileUrl = null, this._file = e);
        }
      }), this._fileUrl = null, h ? this.fileUrl = this._fileUrl : Object.defineProperty(this, "fileUrl", {
        get: function get() {
          return this._fileUrl;
        },
        set: function set(e) {
          "string" == typeof e && (this._file = null, this._fileUrl = e);
        }
      }), this._thumbnailSizes = null, h ? this.thumbnailSizes = this._thumbnailSizes : Object.defineProperty(this, "thumbnailSizes", {
        get: function get() {
          return this._thumbnailSizes;
        },
        set: function set(e) {
          if (Array.isArray(e)) {
            for (var n = 0; n < e.length; n++) {
              if ("object" != typeof e[n] || "number" != typeof e[n].maxWidth || "number" != typeof e[n].maxHeight) return void (this._thumbnailSizes = []);
            }

            this._thumbnailSizes = e;
          }
        }
      }), this._fileName = null, ue(this, "_fileName", "fileName", "string"), this._mimeType = null, ue(this, "_mimeType", "mimeType", "string"), this._fileSize = null, ue(this, "_fileSize", "fileSize", "number"), this._data = null, ue(this, "_data", "data", "string"), this._customType = null, ue(this, "_customType", "customType", "string"), this._metaArrayKeys = [], h ? this.metaArrayKeys = this._metaArrayKeys : Object.defineProperty(this, "metaArrayKeys", {
        get: function get() {
          return this._metaArrayKeys;
        },
        set: function set(e) {
          var n = [];
          if (Array.isArray(e)) for (var t = 0; t < e.length; t++) {
            "string" == typeof e[t] && n.indexOf(e[t]) < 0 && n.push(e[t]);
          }
          this._metaArrayKeys = n;
        }
      }), this._mentionType = de.MentionType.USERS, h ? this.mentionType = this._mentionType : Object.defineProperty(this, "mentionType", {
        get: function get() {
          return this._mentionType;
        },
        set: function set(e) {
          [de.MentionType.USERS, de.MentionType.CHANNEL].indexOf(e) < 0 || (this._mentionType = e);
        }
      }), this._mentionedIds = [], this._mentionedUsers = null, h ? this.mentionedUsers = this._mentionedUsers : Object.defineProperty(this, "mentionedUsers", {
        get: function get() {
          return this._mentionedUsers;
        },
        set: function set(e) {
          if (Array.isArray(e)) {
            for (var n = [], t = [], r = {}, i = 0; i < e.length; i++) {
              if (!e[i].hasOwnProperty("userId")) return this._mentionedIds = [], void (this._mentionedUsers = []);
              r[e[i].userId] || (r[e[i].userId] = !0, Ie.getInstance().getCurrentUserId() !== e[i].userId && (n.push(e[i]), t.push(e[i].userId)));
            }

            this._mentionedUserIds = [], this._mentionedIds = t, this._mentionedUsers = n;
          }
        }
      }), this._mentionedUserIds = null, h ? this.mentionedUserIds = this._mentionedUserIds : Object.defineProperty(this, "mentionedUserIds", {
        get: function get() {
          return this._mentionedUserIds;
        },
        set: function set(e) {
          if (Array.isArray(e)) {
            for (var n = [], t = {}, r = 0; r < e.length; r++) {
              if ("string" != typeof e[r]) return this._mentionedIds = [], void (this._mentionedUserIds = []);
              t[e[r]] || (t[e[r]] = !0, Ie.getInstance().getCurrentUserId() !== e[r] && n.push(e[r]));
            }

            this._mentionedUsers = [], this._mentionedIds = n, this._mentionedUserIds = n;
          }
        }
      }), this._pushNotificationDeliveryOption = null, ue(this, "_pushNotificationDeliveryOption", "pushNotificationDeliveryOption", "string");
    };

    pe.PushNotificationDeliveryOption = {
      DEFAULT: "default",
      SUPPRESS: "suppress"
    };

    var fe = function fe(e) {
      this._message = null, ue(this, "_message", "message", "string"), this._translationTargetLanguages = null, h ? this.translationTargetLanguages = this._translationTargetLanguages : Object.defineProperty(this, "translationTargetLanguages", {
        get: function get() {
          return this._translationTargetLanguages;
        },
        set: function set(e) {
          if (Array.isArray(e)) {
            for (var n = 0; n < e.length; n++) {
              if ("string" != typeof e[n]) return void (this._translationTargetLanguages = []);
            }

            this._translationTargetLanguages = e;
          }
        }
      }), this._data = null, ue(this, "_data", "data", "string"), this._customType = null, ue(this, "_customType", "customType", "string"), this._mentionType = de.MentionType.USERS, h ? this.mentionType = this._mentionType : Object.defineProperty(this, "mentionType", {
        get: function get() {
          return this._mentionType;
        },
        set: function set(e) {
          [de.MentionType.USERS, de.MentionType.CHANNEL].indexOf(e) < 0 || (this._mentionType = e);
        }
      }), this._metaArrayKeys = [], h ? this.metaArrayKeys = this._metaArrayKeys : Object.defineProperty(this, "metaArrayKeys", {
        get: function get() {
          return this._metaArrayKeys;
        },
        set: function set(e) {
          var n = [];
          if (Array.isArray(e)) for (var t = 0; t < e.length; t++) {
            "string" == typeof e[t] && n.indexOf(e[t]) < 0 && n.push(e[t]);
          }
          this._metaArrayKeys = n;
        }
      }), this._mentionedIds = [], this._mentionedUsers = null, h ? this.mentionedUsers = this._mentionedUsers : Object.defineProperty(this, "mentionedUsers", {
        get: function get() {
          return this._mentionedUsers;
        },
        set: function set(e) {
          if (Array.isArray(e)) {
            for (var n = [], t = [], r = {}, i = 0; i < e.length; i++) {
              if (!e[i].hasOwnProperty("userId")) return this._mentionedIds = [], void (this._mentionedUsers = []);
              r[e[i].userId] || (r[e[i].userId] = !0, Ie.getInstance().getCurrentUserId() !== e[i].userId && (n.push(e[i]), t.push(e[i].userId)));
            }

            this._mentionedUserIds = [], this._mentionedIds = t, this._mentionedUsers = n;
          }
        }
      }), this._mentionedUserIds = null, h ? this.mentionedUserIds = this._mentionedUserIds : Object.defineProperty(this, "mentionedUserIds", {
        get: function get() {
          return this._mentionedUserIds;
        },
        set: function set(e) {
          if (Array.isArray(e)) {
            for (var n = [], t = {}, r = 0; r < e.length; r++) {
              if ("string" != typeof e[r]) return this._mentionedIds = [], void (this._mentionedUserIds = []);
              t[e[r]] || (t[e[r]] = !0, Ie.getInstance().getCurrentUserId() !== e[r] && n.push(e[r]));
            }

            this._mentionedUsers = [], this._mentionedIds = n, this._mentionedUserIds = n;
          }
        }
      }), this._pushNotificationDeliveryOption = null, ue(this, "_pushNotificationDeliveryOption", "pushNotificationDeliveryOption", "string"), this._year = null, ue(this, "_year", "year", "number"), this._month = null, ue(this, "_month", "month", "number"), this._day = null, ue(this, "_day", "day", "number"), this._hour = null, ue(this, "_hour", "hour", "number"), this._min = null, ue(this, "_min", "min", "number"), this._timezone = null, ue(this, "_timezone", "timezone", "string"), this._scheduledDateTimeString = null, h ? this.scheduledDateTimeString = this._scheduledDateTimeString : Object.defineProperty(this, "scheduledDateTimeString", {
        get: function get() {
          return this._scheduledDateTimeString ? this._scheduledDateTimeString : "number" == typeof this._year && 4 === this._year.toString().length && "number" == typeof this._month && this._month >= 1 && this._month <= 12 && "number" == typeof this._day && this._day >= 1 && this._day <= 31 && "number" == typeof this._hour && this._hour >= 0 && this._hour <= 24 && "number" == typeof this._min && this._min >= 0 && this._min <= 60 && "string" == typeof this._timezone && this._timezone.length > 0 ? this._year.toString() + "-" + ("0" + this._month.toString()).substr(-2) + "-" + ("0" + this._day.toString()).substr(-2) + " " + ("0" + this._hour.toString()).substr(-2) + ":" + ("0" + this._min.toString()).substr(-2) : null;
        },
        set: function set(e) {
          e && "string" == typeof e && (this._scheduledDateTimeString = e);
        }
      }), this.setSchedule = function (e, n, t, r, i, a) {
        "number" == typeof e && 4 === e.toString().length && "number" == typeof n && n >= 1 && n <= 12 && "number" == typeof t && t >= 1 && t <= 31 && "number" == typeof r && r >= 0 && r <= 24 && "number" == typeof i && i >= 0 && i <= 60 && "string" == typeof a && a.length > 0 && (this.scheduledDateTimeString = e.toString() + "-" + ("0" + n.toString()).substr(-2) + "-" + ("0" + t.toString()).substr(-2) + " " + ("0" + r.toString()).substr(-2) + ":" + ("0" + i.toString()).substr(-2), this.timezone = a);
      }, this._getScheduleString = function () {
        return this.scheduledDateTimeString ? this.scheduledDateTimeString + " " + this.timezone : "number" == typeof this.year && 4 === this.year.toString().length && "number" == typeof this.month && this.month >= 1 && this.month <= 12 && "number" == typeof this.day && this.day >= 1 && this.day <= 31 && "number" == typeof this.hour && this.hour >= 0 && this.hour <= 24 && "number" == typeof this.min && this.min >= 0 && this.min <= 60 && "string" == typeof this.timezone && this.timezone.length > 0 ? this.year.toString() + "-" + ("0" + this.month.toString()).substr(-2) + "-" + ("0" + this.day.toString()).substr(-2) + " " + ("0" + this.hour.toString()).substr(-2) + ":" + ("0" + this.min.toString()).substr(-2) + " " + this.timezone : null;
      }, this._update = function (e) {
        e.hasOwnProperty("message") && (this.message = e.message), e.hasOwnProperty("year") && (this.year = e.year), e.hasOwnProperty("month") && (this.month = e.month), e.hasOwnProperty("day") && (this.day = e.day), e.hasOwnProperty("hour") && (this.hour = e.hour), e.hasOwnProperty("min") && (this.min = e.min), e.hasOwnProperty("timezone") && (this.timezone = e.timezone);
      }, e && this._update(e);
    },
        _e = function _e() {
      this.networkHandlers = {}, this.authenticateTimer = 1e4, this.authInfoRequester = null;
      var e = 0,
          n = [],
          t = new g("Connection should be made first.", N.CONNECTION_REQUIRED),
          r = new g("Invalid parameter.", N.INVALID_PARAMETER);
      this.addReadyHandler = function (e) {
        e && "function" == typeof e && n.push(e);
      }, this.ready = function (e, n) {
        var t = Ie.getInstance();
        return n ? void e(t.currentUser, null) : (this.addReadyHandler(e), t.isReconnectingOnError ? void this.errorAllReadyHandler() : void (t.getConnectionState() === t.ConnectionState.OPEN ? this.processAllReadyHandler(null) : t.getConnectionState() === t.ConnectionState.CONNECTING || this.errorAllReadyHandler()));
      }, this.processAllReadyHandler = function (e) {
        if (n.length > 0) {
          var t = n;
          n = [], t.forEach(function (n) {
            n && "function" == typeof n && n(Ie.getInstance().currentUser, e);
          }), t = [];
        }
      }, this.errorAllReadyHandler = function () {
        this.processAllReadyHandler(t);
      }, this.NetworkHandler = function () {
        this.onReconnected = function () {};
      }, this.addNetworkHandler = function (e, n) {
        this.networkHandlers[e] = n;
      }, this.removeNetworkHandler = function (e) {
        delete this.networkHandlers[e];
      }, this.removeAllNetworkHandler = function () {
        this.networkHandlers = {};
      }, this.authenticate = function (n) {
        var i = this,
            a = Ie.getInstance();
        if (a.getConnectionState() === a.ConnectionState.OPEN || a.reconnecting) a.connecting = !1, U(a.currentUser, null, n);else if (i.authInfoRequester && "function" == typeof i.authInfoRequester) {
          a.connecting = !0, e++;
          var s = setTimeout(function () {
            s = null, e--, 0 === e && 0 === a.connectionCallback.length && (a.connecting = !1), i.errorAllReadyHandler(), U(null, t, n);
          }, i.authenticateTimer);
          i.authInfoRequester(function (t) {
            if (s) {
              clearTimeout(s), s = null, e--;

              var i = function i(e, t) {
                a.connecting = !1, t ? U(null, new g(t.message, t.code), n) : U(e, null, n);
              };

              t && t.hasOwnProperty("userId") ? t.apiHost && t.wsHost ? a.connect(t.userId, t.accessToken, t.apiHost, t.wsHost, i) : a.connect(t.userId, t.accessToken, i) : U(null, r, n);
            }
          });
        } else U(null, r, n);
      };
    },
        Ie = function Ie(e) {
      var n = Ie.getInstance();
      if (n) return n;

      try {
        if (!e.hasOwnProperty("appId")) return t.log("Must be set appId"), null;
      } catch (e) {
        return t.log("Must be set appId"), null;
      }

      this.connecting = !1, this.reconnecting = !1, this.isReconnectingOnError = !1, this.ConnectionManager = new _e(), this.GCMPushToken = "", this.APNSPushToken = "", this.PUSH_TEMPLATE_DEFAULT = "default", this.PUSH_TEMPLATE_ALTERNATIVE = "alternative", this.isSessionOpened = !1, this.pushTokenRegistrationState = {
        SUCCESS: "success",
        PENDING: "pending",
        ERROR: "error"
      }, this.loginTimer, this.onLoginTimerCancel, this.globalTimer, this.reconnectTimer, this.onReconnectTimerCancel, this.currentUser = null, this.getCurrentUserId = function () {
        return Ie.getInstance().currentUser ? Ie.getInstance().currentUser.userId : null;
      }, this.wsClient, this.ConnectionState = {
        CONNECTING: "CONNECTING",
        OPEN: "OPEN",
        CLOSING: "CLOSING",
        CLOSED: "CLOSED"
      }, this.connectionState = this.ConnectionState, this._connectedAt = 0, this.getLastConnectedAt = function () {
        var e = this;
        return e.getConnectionState() === e.ConnectionState.OPEN && e.currentUser ? e._connectedAt : 0;
      }, this.BaseChannel = m, this.User = q, this.Member = j, this.OpenChannel = k, this.GroupChannel = V, this.UserMessage = b, this.FileMessage = w, this.AdminMessage = M, this.userEventHandlers = {}, this.channelHandlers = {}, this.connectionHandlers = {}, this.connectionCallback = [];

      var l = function l(e, n) {
        var t = Ie.getInstance().connectionCallback;
        Ie.getInstance().connectionCallback = [], t.forEach(function (t) {
          U(e, n, t);
        }), t = [];
      };

      this.GroupChannelParams = ce, this.BaseMessageParams = de, this.FileMessageParams = pe, this.UserMessageParams = he, this.ScheduledUserMessageParams = fe, this.GroupChannelTotalUnreadMessageCountParams = G, this._ackStateMap = {}, T = e.appId, ge = this, oe = se.getInstance(), oe || (oe = new se()), this.Options = {
        _useMemberAsMessageSender: !0,

        get UseMemberAsMessageSender() {
          return this._useMemberAsMessageSender;
        },

        set UseMemberAsMessageSender(e) {
          "boolean" == typeof e && (this._useMemberAsMessageSender = e);
        },

        get useMemberAsMessageSender() {
          return this._useMemberAsMessageSender;
        },

        set useMemberAsMessageSender(e) {
          "boolean" == typeof e && (this._useMemberAsMessageSender = e);
        },

        _typingIndicatorThrottle: 1e3,

        get typingIndicatorThrottle() {
          return this._typingIndicatorThrottle;
        },

        set typingIndicatorThrottle(e) {
          "number" == typeof e && e >= s && e <= o && (this._typingIndicatorThrottle = e);
        }

      }, this.customApiHost = null, this.customWsHost = null, this.UserEventHandler = function () {
        this.onFriendsDiscovered = function (e) {};
      }, this.addUserEventHandler = function (e, n) {
        Ie.getInstance().userEventHandlers[e] = n;
      }, this.removeUserEventHandler = function (e) {
        delete Ie.getInstance().userEventHandlers[e];
      }, this.removeAllUserEventHandler = function () {
        Ie.getInstance().userEventHandlers = {};
      }, this.ChannelHandler = function () {
        this.onMessageReceived = function (e, n) {}, this.onMessageUpdated = function (e, n) {}, this.onMessageDeleted = function (e, n) {}, this.onReadReceiptUpdated = function (e) {}, this.onTypingStatusUpdated = function (e) {}, this.onUserJoined = function (e, n) {}, this.onUserLeft = function (e, n) {}, this.onUserEntered = function (e, n) {}, this.onUserExited = function (e, n) {}, this.onUserMuted = function (e, n) {}, this.onUserUnmuted = function (e, n) {}, this.onUserBanned = function (e, n) {}, this.onUserUnbanned = function (e, n) {}, this.onChannelFrozen = function (e) {}, this.onChannelUnfrozen = function (e) {}, this.onChannelChanged = function (e) {}, this.onChannelDeleted = function (e) {}, this.onUserReceivedInvitation = function (e, n, t) {}, this.onUserDeclinedInvitation = function (e, n, t) {}, this.onMetaDataCreated = function (e, n) {}, this.onMetaDataUpdated = function (e, n) {}, this.onMetaDataDeleted = function (e, n) {}, this.onMetaCountersCreated = function (e, n) {}, this.onMetaCountersUpdated = function (e, n) {}, this.onMetaCountersDeleted = function (e, n) {}, this.onChannelHidden = function (e) {}, this.onMentionReceived = function (e, n) {};
      }, this.addChannelHandler = function (e, n) {
        Ie.getInstance().channelHandlers[e] = n;
      }, this.removeChannelHandler = function (e) {
        delete Ie.getInstance().channelHandlers[e];
      }, this.removeAllChannelHandlers = function () {
        Ie.getInstance().channelHandlers = {};
      }, this.ConnectionHandler = function () {
        this.onReconnectStarted = function () {}, this.onReconnectSucceeded = function () {}, this.onReconnectFailed = function () {};
      }, this.addConnectionHandler = function (e, n) {
        Ie.getInstance().connectionHandlers[e] = n;
      }, this.removeConnectionHandler = function (e) {
        delete Ie.getInstance().connectionHandlers[e];
      }, this.removeAllConnectionHandlers = function () {
        Ie.getInstance().connectionHandlers = {};
      }, this.createUserListQuery = function (e) {
        return e ? new ee(ee.FILTERED_USER, e) : new ee(ee.ALL_USER);
      }, this.createBlockedUserListQuery = function () {
        return new ee(ee.BLOCKED_USER);
      }, this.getApplicationId = function () {
        return T;
      }, this.getDebugMode = function () {
        return r;
      }, this.setDebugMode = function (e) {
        r = e;
      }, this.setAPIHost = function (e) {
        a = e;
      }, this.setWSHost = function (e) {
        i = e;
      }, this.clearCurrentApiHost = function () {
        this.customApiHost = null;
      }, this.getCurrentApiHost = function () {
        return this.customApiHost ? this.customApiHost : a;
      }, this.clearCurrentWsHost = function () {
        this.customWsHost = null;
      }, this.getCurrentWsHost = function () {
        return this.customWsHost ? this.customWsHost : i;
      }, this.setErrorFirstCallback = function (e) {
        S = e;
      }, this.getErrorFirstCallback = function () {
        return S;
      }, this.getConnectionState = function () {
        try {
          if (Ie.getInstance()) {
            var e = Ie.getInstance();
            return e.connecting || e.reconnecting ? e.ConnectionState.CONNECTING : e.wsClient ? e.connecting || e.reconnecting ? e.ConnectionState.CONNECTING : e.isSessionOpened ? e.wsClient.getConnectionState() : e.ConnectionState.CLOSED : e.ConnectionState.CLOSED;
          }

          return Ie.getInstance().ConnectionState.CLOSED;
        } catch (e) {
          return Ie.getInstance().ConnectionState.CLOSED;
        }
      }, this.hasLoggedIn = function () {
        return Ie.getInstance().currentUser && se.getInstance().sessionKey;
      };
      var u = {};
      this._createFileQueue = function (e, n) {
        return u.hasOwnProperty(e) || (u[e] = new H(e, n)), u[e];
      }, this._getFileQueue = function (e) {
        return u.hasOwnProperty(e) ? u[e] : null;
      }, this._clearFileQueue = function () {
        u = {};
      }, this._deleteFileQueue = function (e) {
        u.hasOwnProperty(e) && delete u[e];
      }, this._fileUploadRequest = {};

      var c = function c(e) {
        var n = Ie.getInstance();
        return n._ackStateMap.hasOwnProperty(e) ? n._ackStateMap[e] : null;
      },
          h = function h(e) {
        var n = (Ie.getInstance(), new x(e));
        "LOGI" === n.command && (I = {
          all: 0,
          custom_types: {},
          ts: 0
        }), E(n.getJsonElement());
        var r = n.requestId;

        if (r) {
          var i = c(r);
          if (null == i) return;
          clearTimeout(i.timer);
          var a = i.handler;
          if (a) if ("EROR" === n.command) {
            var s = n.getJsonElement(),
                o = new g(s.message, s.code);
            a(null, o);
          } else a(n, null);

          try {
            delete Ie.getInstance()._ackStateMap[n.requestId];
          } catch (e) {}
        } else switch (ie && "LOGI" !== n.command && ie.start(), n.command) {
          case "LOGI":
            if (Ie.getInstance().loginTimer) {
              clearTimeout(Ie.getInstance().loginTimer), Ie.getInstance().loginTimer = null, Ie.getInstance().onLoginTimerCancel = null;
              var l = n.getJsonElement();

              if (l.hasOwnProperty("error")) {
                Ie.getInstance().isSessionOpened = !1;
                var u = l.code,
                    d = l.message;
                Ie.getInstance().loginHandler(null, new g(d, u));
              } else Ie.getInstance().isSessionOpened = !0, l.hasOwnProperty("key") && (se.getInstance().sessionKey = l.key), l.hasOwnProperty("ekey") && (se.getInstance().ekey = l.ekey), l.hasOwnProperty("user_id") && (Ie.getInstance().currentUser = new q(l)), l.hasOwnProperty("ping_interval") && "number" == typeof l.ping_interval && l.ping_interval > 0 && (ne = 1e3 * l.ping_interval), l.hasOwnProperty("pong_timeout") && "number" == typeof l.pong_timeout && l.pong_timeout > 0 && (te = 1e3 * l.pong_timeout), l.hasOwnProperty("login_ts") && "number" == typeof l.login_ts && (Ie.getInstance()._connectedAt = l.login_ts), ie && ie.start(), Ie.getInstance().loginHandler(Ie.getInstance().currentUser, null);

              Ie.getInstance().connecting = !1, Ie.getInstance().reconnecting = !1;
            }

            break;

          case "MESG":
          case "FILE":
          case "BRDM":
          case "ADMM":
            var h = "",
                f = !1;
            if ("MESG" === n.command ? h = new b(n.getJsonElement()) : "FILE" === n.command ? h = new w(n.getJsonElement()) : (h = new M(n.getJsonElement()), n.getJsonElement().hasOwnProperty("silent") && (f = n.getJsonElement().silent)), !h) return;

            if (h.isGroupChannel()) {
              var m = V.cachedChannels.hasOwnProperty(h.channelUrl);
              V.getChannel(h.channelUrl, function (e, n) {
                if (S) {
                  var t = e;
                  e = n, n = t;
                }

                if (n) return void (a && a(null, n));

                if (e.isHidden = !1, V.cachedChannels[e.url] = e, h._sender && e.memberMap.hasOwnProperty(h._sender.userId)) {
                  var r = e.memberMap[h._sender.userId];
                  r.nickname !== h._sender.nickname && (r.nickname = h._sender.nickname), r.profileUrl !== h._sender.profileUrl && (r.profileUrl = h._sender.profileUrl), r.metaData !== h._sender.metaData && (r.metaData = h._sender.metaData);
                }

                var i = Ie.getInstance().currentUser;
                i && h._sender && i.userId === h._sender.userId && (i.nickname !== h._sender.nickname && (i.nickname = h._sender.nickname), i.profileUrl !== h._sender.profileUrl && (i.profileUrl = h._sender.profileUrl), v(i.metaData, h._sender.metaData) || (i.metaData = h._sender.metaData));
                var s = !1;
                if (h.mentionType === de.MentionType.CHANNEL) h.sender && h.sender.userId === Ie.getInstance().getCurrentUserId() || (s = !0);else if (h.mentionType === de.MentionType.USERS) for (var o in h.mentionedUsers) {
                  if ((!h.sender || h.sender.userId !== Ie.getInstance().getCurrentUserId()) && h.mentionedUsers[o].userId === Ie.getInstance().getCurrentUserId()) {
                    s = !0;
                    break;
                  }
                }
                if (f || (e.isEphemeral ? ((!e.lastMessage || e.lastMessage.createdAt < h.createdAt) && (e.lastMessage = h), h.sender && h.sender.userId === Ie.getInstance().getCurrentUserId() || y(e, e.unreadMessageCount + 1, e.unreadMentionCount + (s ? 1 : 0))) : m && ((!e.lastMessage || e.lastMessage.createdAt < h.createdAt) && (e.lastMessage = h), h.sender && h.sender.userId === Ie.getInstance().getCurrentUserId() || y(e, e.unreadMessageCount + 1, e.unreadMentionCount + (s ? 1 : 0)))), !f) for (var o in Ie.getInstance().channelHandlers) {
                  var l = Ie.getInstance().channelHandlers[o];
                  l.onChannelChanged(e);
                }

                for (var o in Ie.getInstance().channelHandlers) {
                  var l = Ie.getInstance().channelHandlers[o];
                  l.onMessageReceived(e, h), s && l.onMentionReceived(e, h);
                }
              });
            } else k.getChannel(h.channelUrl, function (e, n) {
              if (S) {
                var t = e;
                e = n, n = t;
              }

              if (n) return void (a && a(null, n));
              var r = !1;
              if (h.mentionType === de.MentionType.CHANNEL) r = !0;else if (h.mentionType === de.MentionType.USERS) for (var i in h.mentionedUsers) {
                if (h.mentionedUsers[i].userId === Ie.getInstance().getCurrentUserId()) {
                  r = !0;
                  break;
                }
              }

              for (var i in Ie.getInstance().channelHandlers) {
                var s = Ie.getInstance().channelHandlers[i];
                k.enteredChannels[e.url] && s.onMessageReceived(e, h), r && s.onMentionReceived(e, h);
              }
            });

            break;

          case "MEDI":
          case "FEDI":
          case "AEDI":
            var f = !1,
                h = "";
            if ("MEDI" === n.command ? h = new b(n.getJsonElement()) : "FEDI" === n.command ? h = new w(n.getJsonElement()) : (h = new M(n.getJsonElement()), n.getJsonElement().hasOwnProperty("silent") && (f = n.getJsonElement().silent)), !h) return;

            if (h.isGroupChannel()) {
              var m = V.cachedChannels.hasOwnProperty(h.channelUrl);
              V.getChannel(h.channelUrl, function (e, t) {
                if (S) {
                  var r = e;
                  e = t, t = r;
                }

                if (t) return void (a && a(null, t));
                var i = e.cachedReadReceiptStatus[Ie.getInstance().getCurrentUserId()],
                    s = i && i >= h.createAt;

                if (h._sender && e.memberMap.hasOwnProperty(h._sender.userId)) {
                  var o = e.memberMap[h._sender.userId];
                  o.nickname !== h._sender.nickname && (o.nickname = h._sender.nickname), o.profileUrl !== h._sender.profileUrl && (o.profileUrl = h._sender.profileUrl), o.metaData !== h._sender.metaData && (o.metaData = h._sender.metaData);
                }

                var l = Ie.getInstance().currentUser;
                l && h._sender && l.userId === h._sender.userId && (l.nickname !== h._sender.nickname && (l.nickname = h._sender.nickname), l.profileUrl !== h._sender.profileUrl && (l.profileUrl = h._sender.profileUrl), v(l.metaData, h._sender.metaData) || (l.metaData = h._sender.metaData));
                var u = !1,
                    c = n.getJsonElement();

                if ((!h.sender || h.sender.userId !== Ie.getInstance().getCurrentUserId()) && !s && c && c.hasOwnProperty("old_values")) {
                  var d = c.old_values.mention_type || h.mentionType,
                      p = c.old_values.mentioned_user_ids || h.mentionedUsers.map(function (e) {
                    return e.userId;
                  });

                  if (d === de.MentionType.USERS && h.mentionType === de.MentionType.USERS) {
                    var _ = !1,
                        I = !1;

                    for (var g in p) {
                      if (p[g] === Ie.getInstance().getCurrentUserId()) {
                        _ = !0;
                        break;
                      }
                    }

                    for (var g in h.mentionedUsers) {
                      if (h.mentionedUsers[g].userId === Ie.getInstance().getCurrentUserId()) {
                        I = !0;
                        break;
                      }
                    }

                    !_ && I && (u = !0, m && y(e, e.unreadMessageCount, e.unreadMentionCount + 1));
                  } else if (d === de.MentionType.USERS && h.mentionType === de.MentionType.CHANNEL) {
                    var E = !1;

                    for (var g in p) {
                      if (p[g] === Ie.getInstance().getCurrentUserId()) {
                        E = !0;
                        break;
                      }
                    }

                    E || (u = !0, m && y(e, e.unreadMessageCount, e.unreadMentionCount + 1));
                  }
                }

                var A = !1;
                if (e.lastMessage && e.lastMessage.messageId === h.messageId && (m ? e.lastMessage.updatedAt < h.updatedAt && (e.lastMessage = h, A = !0) : A = !0), !f && (A || u)) for (var g in Ie.getInstance().channelHandlers) {
                  var N = Ie.getInstance().channelHandlers[g];
                  N.onChannelChanged(e);
                }

                for (var g in Ie.getInstance().channelHandlers) {
                  var N = Ie.getInstance().channelHandlers[g];
                  N.onMessageUpdated(e, h), u && N.onMentionReceived(e, h);
                }
              });
            } else k.getChannel(h.channelUrl, function (e, n) {
              if (S) {
                var t = e;
                e = n, n = t;
              }

              if (n) return void (a && a(null, n));

              for (var r in Ie.getInstance().channelHandlers) {
                Ie.getInstance().channelHandlers[r].onMessageUpdated(e, h);
              }
            });

            break;

          case "READ":
            var A = new K(n.getJsonElement()),
                m = V.cachedChannels.hasOwnProperty(A.channelUrl);
            V.getChannel(A.channelUrl, function (e, n) {
              if (S) {
                var t = e;
                e = n, n = t;
              }

              if (n) return void (a && a(null, n));

              if (m && e.updateReadReceipt(A.reader.userId, A.timestamp), A.reader.userId === Ie.getInstance().getCurrentUserId()) {
                if (m) {
                  if ((e.unreadMessageCount > 0 || e.unreadMentionCount > 0) && (y(e, 0, 0), 0 === e.unreadMessageCount || 0 === e.unreadMentionCount)) for (var r in Ie.getInstance().channelHandlers) {
                    var i = Ie.getInstance().channelHandlers[r];
                    i.onChannelChanged(e);
                  }
                } else if (0 === e.unreadMessageCount || 0 === e.unreadMentionCount) for (var r in Ie.getInstance().channelHandlers) {
                  var i = Ie.getInstance().channelHandlers[r];
                  i.onChannelChanged(e);
                }
              } else for (var r in Ie.getInstance().channelHandlers) {
                var i = Ie.getInstance().channelHandlers[r];
                i.onReadReceiptUpdated(e);
              }
            });
            break;

          case "TPST":
          case "TPEN":
          case "MTIO":
            break;

          case "SYEV":
            _(n);

            break;

          case "USEV":
            p(n);
            break;

          case "DELM":
            var N = n.getJsonElement(),
                C = String(N.channel_type),
                R = String(N.channel_url),
                U = String(N.msg_id);

            switch (C) {
              case F.CHANNEL_TYPE_OPEN:
                k.getChannel(R, function (e, n) {
                  if (S) {
                    var r = e;
                    e = n, n = r;
                  }

                  if (n) return void t.log("Discard a command.");

                  for (var i in Ie.getInstance().channelHandlers) {
                    Ie.getInstance().channelHandlers[i].onMessageDeleted(e, U);
                  }
                });
                break;

              case F.CHANNEL_TYPE_GROUP:
                V.getChannel(R, function (e, n) {
                  if (S) {
                    var r = e;
                    e = n, n = r;
                  }

                  if (n) return void t.log("Discard a command.");

                  for (var i in Ie.getInstance().channelHandlers) {
                    Ie.getInstance().channelHandlers[i].onMessageDeleted(e, U);
                  }
                });
            }

        }
      },
          p = function p(e) {
        var n = new Y(e.getJsonElement());

        switch (n.category) {
          case B.CATEGORY_USER_BLOCK:
          case B.CATEGORY_USER_UNBLOCK:
            var t = n.data.blocker.user_id,
                r = n.data.blockee.user_id;
            Object.keys(V.cachedChannels).forEach(function (e) {
              var i = V.cachedChannels[e];

              try {
                Ie.getInstance().getCurrentUserId() === t ? i.memberMap[r].isBlockedByMe = n.category === B.CATEGORY_USER_BLOCK : Ie.getInstance().getCurrentUserId() === r && (i.memberMap[t].isBlockingMe = n.category === B.CATEGORY_USER_BLOCK);
              } catch (e) {}
            });
            break;

          case B.CATEGORY_FRIEND_DISCOVERED:
            var i = n.data.friend_discoveries,
                a = i.map(function (e) {
              return new q(e);
            });

            for (var s in Ie.getInstance().userEventHandlers) {
              Ie.getInstance().userEventHandlers[s].onFriendsDiscovered(a);
            }

        }
      },
          _ = function _(e) {
        var n = e.getJsonElement(),
            r = new Y(n);

        switch (r.category) {
          case Y.CATEGORY_CHANNEL_JOIN:
          case Y.CATEGORY_CHANNEL_LEAVE:
            V.getChannel(r.channelUrl, function (i, a) {
              if (S) {
                var s = i;
                i = a, a = s;
              }

              if (a) return void t.log("Discard a command: " + e.command + ":" + r.category);
              var o = r.data.hasOwnProperty("member_count") ? r.data.member_count : null,
                  l = r.data.hasOwnProperty("joined_member_count") ? r.data.joined_member_count : null;

              if (r.category === Y.CATEGORY_CHANNEL_JOIN) {
                (r.data.hasOwnProperty("users") ? r.data.users : function (e) {
                  return e.state = j.JOINED, [e];
                }(r.data)).forEach(function (e) {
                  !function (e, t, r) {
                    i.isSuper ? i.setLatestMemberCount(t, r, n.ts) : (e.state = j.JOINED, i.addMember(new j(e)), i.updateJoinedMemberCount());
                    var a = new q(e);
                    a.userId === Ie.getInstance().getCurrentUserId() && (i.myMemberState = "joined", V.cachedChannels[i.url] = i);

                    for (var s in Ie.getInstance().channelHandlers) {
                      Ie.getInstance().channelHandlers[s].onUserJoined(i, a);
                    }
                  }(e, o, l);
                });
              } else {
                var u = new q(r.data);
                u.userId === Ie.getInstance().getCurrentUserId() ? (i.isPublic || V.removeCachedChannel(r.channelUrl), i.myMemberState = "none", i.invitedAt = 0, y(i, 0, 0)) : V.cachedChannels[i.url] = i, i.isSuper ? i.setLatestMemberCount(o, l, n.ts) : (i.removeMember(u), i.updateJoinedMemberCount());

                for (var c in Ie.getInstance().channelHandlers) {
                  Ie.getInstance().channelHandlers[c].onUserLeft(i, u);
                }
              }
            });
            break;

          case Y.CATEGORY_CHANNEL_INVITE:
            V.getChannel(r.channelUrl, function (i, a) {
              if (S) {
                var s = i;
                i = a, a = s;
              }

              if (a) return void t.log("Discard a command: " + e.command + ":" + r.category);
              var o = null;
              r.data && r.data.inviter && !f(r.data.inviter) && (o = new q(r.data.inviter));
              var l = [];

              for (var u in r.data.invitees) {
                var c = new q(r.data.invitees[u]);
                l.push(c), r.data.invitees[u].state = j.INVITED;
                var d = new j(r.data.invitees[u]);

                if (i.isSuper) {
                  var h = r.data.hasOwnProperty("member_count") ? r.data.member_count : null,
                      p = r.data.hasOwnProperty("joined_member_count") ? r.data.joined_member_count : null;
                  i.setLatestMemberCount(h, p, n.ts);
                } else i.addMember(d);

                d.userId === Ie.getInstance().getCurrentUserId() && (i.isHidden = !1, "joined" !== i.myMemberState && (i.myMemberState = "invited"), i.invitedAt = n.ts, V.cachedChannels[i.url] = i);
              }

              for (var u in Ie.getInstance().channelHandlers) {
                Ie.getInstance().channelHandlers[u].onUserReceivedInvitation(i, o, l);
              }
            });
            break;

          case Y.CATEGORY_CHANNEL_DECLINE_INVITE:
            V.getChannel(r.channelUrl, function (i, a) {
              if (S) {
                var s = i;
                i = a, a = s;
              }

              if (a) return void t.log("Discard a command: " + e.command + ":" + r.category);
              var o = null;
              r.data && r.data.inviter && !f(r.data.inviter) && (o = new q(r.data.inviter));
              var l = new q(r.data.invitee);

              if (l.userId === Ie.getInstance().getCurrentUserId() && (i.invitedAt = 0, i.myMemberState = "none", i.isPublic || V.removeCachedChannel(r.channelUrl)), i.isSuper) {
                var u = r.data.hasOwnProperty("member_count") ? r.data.member_count : null,
                    c = r.data.hasOwnProperty("joined_member_count") ? r.data.joined_member_count : null;
                i.setLatestMemberCount(u, c, n.ts);
              } else i.removeMember(l);

              l.userId !== Ie.getInstance().getCurrentUserId() && (V.cachedChannels[i.url] = i);

              for (var d in Ie.getInstance().channelHandlers) {
                Ie.getInstance().channelHandlers[d].onUserDeclinedInvitation(i, o, l);
              }
            });
            break;

          case Y.CATEGORY_TYPING_START:
          case Y.CATEGORY_TYPING_END:
            V.getChannel(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);
              var s = new q(r.data);
              r.category === Y.CATEGORY_TYPING_START ? n.updateTypingStatus(s, !0) : n.updateTypingStatus(s, !1);

              for (var o in Ie.getInstance().channelHandlers) {
                Ie.getInstance().channelHandlers[o].onTypingStatusUpdated(n);
              }
            });
            break;

          case Y.CATEGORY_CHANNEL_ENTER:
          case Y.CATEGORY_CHANNEL_EXIT:
            k.getChannel(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);
              r.data.hasOwnProperty("participant_count") && (n.participantCount = r.data.participant_count);
              var s = new q(r.data);
              if (r.category === Y.CATEGORY_CHANNEL_ENTER) for (var o in Ie.getInstance().channelHandlers) {
                var l = Ie.getInstance().channelHandlers[o];
                l.onUserEntered(n, s);
              } else for (var o in Ie.getInstance().channelHandlers) {
                var l = Ie.getInstance().channelHandlers[o];
                l.onUserExited(n, s);
              }
            });
            break;

          case Y.CATEGORY_USER_CHANNEL_MUTE:
          case Y.CATEGORY_USER_CHANNEL_UNMUTE:
            r.isOpenChannel() ? k.getChannel(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);
              var s = new q(r.data);
              if (r.category === Y.CATEGORY_USER_CHANNEL_MUTE) for (var o in Ie.getInstance().channelHandlers) {
                var l = Ie.getInstance().channelHandlers[o];
                l.onUserMuted(n, s);
              } else for (var o in Ie.getInstance().channelHandlers) {
                var l = Ie.getInstance().channelHandlers[o];
                l.onUserUnmuted(n, s);
              }
            }) : V.getChannel(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);
              var s = new q(r.data);
              if (s.userId === Ie.getInstance().getCurrentUserId() && (n.myMutedState = r.category === Y.CATEGORY_USER_CHANNEL_MUTE ? "muted" : "unmuted"), r.category === Y.CATEGORY_USER_CHANNEL_MUTE) for (var o in Ie.getInstance().channelHandlers) {
                var l = Ie.getInstance().channelHandlers[o];
                l.onUserMuted(n, s);
              } else for (var o in Ie.getInstance().channelHandlers) {
                var l = Ie.getInstance().channelHandlers[o];
                l.onUserUnmuted(n, s);
              }
            });
            break;

          case Y.CATEGORY_USER_CHANNEL_BAN:
          case Y.CATEGORY_USER_CHANNEL_UNBAN:
            r.isOpenChannel() ? k.getChannel(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);
              var s = new q(r.data);

              if (r.category === Y.CATEGORY_USER_CHANNEL_BAN) {
                s.userId === Ie.getInstance().getCurrentUserId() && (delete k.enteredChannels[r.channelUrl], Ie.getInstance()._deleteFileQueue(r.channelUrl));

                for (var o in Ie.getInstance().channelHandlers) {
                  var l = Ie.getInstance().channelHandlers[o];
                  l.onUserBanned(n, s);
                }
              } else for (var o in Ie.getInstance().channelHandlers) {
                var l = Ie.getInstance().channelHandlers[o];
                l.onUserUnbanned(n, s);
              }
            }) : V.getChannel(r.channelUrl, function (i, a) {
              if (S) {
                var s = i;
                i = a, a = s;
              }

              if (a) return void t.log("Discard a command: " + e.command + ":" + r.category);
              var o = new q(r.data);

              if (r.category === Y.CATEGORY_USER_CHANNEL_BAN) {
                if (o.userId === Ie.getInstance().getCurrentUserId() && (i.isPublic || V.removeCachedChannel(r.channelUrl), i.myMemberState = "none", i.invitedAt = 0, y(i, 0, 0)), i.isSuper) {
                  var l = r.data.hasOwnProperty("member_count") ? r.data.member_count : null,
                      u = r.data.hasOwnProperty("joined_member_count") ? r.data.joined_member_count : null;
                  i.setLatestMemberCount(l, u, n.ts);
                } else i.removeMember(o), i.updateJoinedMemberCount();

                for (var c in Ie.getInstance().channelHandlers) {
                  var d = Ie.getInstance().channelHandlers[c];
                  d.onUserBanned(i, o);
                }
              } else for (var c in Ie.getInstance().channelHandlers) {
                var d = Ie.getInstance().channelHandlers[c];
                d.onUserUnbanned(i, o);
              }
            });
            break;

          case Y.CATEGORY_CHANNEL_FREEZE:
          case Y.CATEGORY_CHANNEL_UNFREEZE:
            r.isOpenChannel() ? k.getChannel(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);
              if (n.isFrozen = r.data.freeze, k.cachedChannels[n.url] = n, r.category === Y.CATEGORY_CHANNEL_FREEZE) for (var s in Ie.getInstance().channelHandlers) {
                var o = Ie.getInstance().channelHandlers[s];
                o.onChannelFrozen(n);
              } else for (var s in Ie.getInstance().channelHandlers) {
                var o = Ie.getInstance().channelHandlers[s];
                o.onChannelUnfrozen(n);
              }
            }) : V.getChannel(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);
              if (n.isFrozen = r.data.freeze, V.cachedChannels[n.url] = n, r.category === Y.CATEGORY_CHANNEL_FREEZE) for (var s in Ie.getInstance().channelHandlers) {
                var o = Ie.getInstance().channelHandlers[s];
                o.onChannelFrozen(n);
              } else for (var s in Ie.getInstance().channelHandlers) {
                var o = Ie.getInstance().channelHandlers[s];
                o.onChannelUnfrozen(n);
              }
            });
            break;

          case Y.CATEGORY_CHANNEL_DELETED:
            if (r.isGroupChannel()) {
              V.removeCachedChannel(r.channelUrl);

              for (var i in Ie.getInstance().channelHandlers) {
                var a = Ie.getInstance().channelHandlers[i];
                a.onChannelDeleted(r.channelUrl, "group");
              }
            } else {
              k.removeCachedChannel(r.channelUrl), delete k.enteredChannels[r.channelUrl], Ie.getInstance()._deleteFileQueue(r.channelUrl);

              for (var i in Ie.getInstance().channelHandlers) {
                var a = Ie.getInstance().channelHandlers[i];
                a.onChannelDeleted(r.channelUrl, "open");
              }
            }

            break;

          case Y.CATEGORY_CHANNEL_PROP_CHANGED:
            r.isOpenChannel() ? k.getChannelWithoutCache(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);

              for (var s in Ie.getInstance().channelHandlers) {
                Ie.getInstance().channelHandlers[s].onChannelChanged(n);
              }
            }) : V.getChannelWithoutCache(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);
              var s = n.unreadMessageCount,
                  o = n.unreadMentionCount;
              n.myCountPreference !== V.CountPreference.ALL && (n.myCountPreference === V.CountPreference.UNREAD_MESSAGE_COUNT_ONLY ? o = 0 : n.myCountPreference === V.CountPreference.UNREAD_MENTION_COUNT_ONLY ? s = 0 : (s = 0, o = 0)), y(n, s, o);

              for (var l in Ie.getInstance().channelHandlers) {
                Ie.getInstance().channelHandlers[l].onChannelChanged(n);
              }
            });
            break;

          case Y.CATEGORY_CHANNEL_META_DATA_CHANGED:
          case Y.CATEGORY_CHANNEL_META_COUNTERS_CHANGED:
            var s = r.data.hasOwnProperty("created"),
                o = r.data.hasOwnProperty("updated"),
                l = r.data.hasOwnProperty("deleted");
            r.isOpenChannel() ? k.getChannel(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);

              for (var u in Ie.getInstance().channelHandlers) {
                var c = Ie.getInstance().channelHandlers[u];
                r.category === Y.CATEGORY_CHANNEL_META_DATA_CHANGED ? (s && c.onMetaDataCreated(n, r.data.created), o && c.onMetaDataUpdated(n, r.data.updated), l && c.onMetaDataDeleted(n, r.data.deleted)) : (s && c.onMetaCountersCreated(n, r.data.created), o && c.onMetaCountersUpdated(n, r.data.updated), l && c.onMetaCountersDeleted(n, r.data.deleted));
              }
            }) : V.getChannel(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);

              for (var u in Ie.getInstance().channelHandlers) {
                var c = Ie.getInstance().channelHandlers[u];
                r.category === Y.CATEGORY_CHANNEL_META_DATA_CHANGED ? (s && c.onMetaDataCreated(n, r.data.created), o && c.onMetaDataUpdated(n, r.data.updated), l && c.onMetaDataDeleted(n, r.data.deleted)) : (s && c.onMetaCountersCreated(n, r.data.created), o && c.onMetaCountersUpdated(n, r.data.updated), l && c.onMetaCountersDeleted(n, r.data.deleted));
              }
            });
            break;

          case Y.CATEGORY_CHANNEL_HIDE:
            V.getChannel(r.channelUrl, function (n, i) {
              if (S) {
                var a = n;
                n = i, i = a;
              }

              if (i) return void t.log("Discard a command: " + e.command + ":" + r.category);

              if (n.isHidden = !0, r.data && r.data.hasOwnProperty("hide_previous_messages") && r.data.hide_previous_messages && V.cachedChannels) {
                var s = V.cachedChannels[n.url];
                y(s, 0, 0), V.cachedChannels[n.url] = s;
              }

              for (var o in Ie.getInstance().channelHandlers) {
                Ie.getInstance().channelHandlers[o].onChannelHidden(n);
              }
            });
        }
      };

      this.getGroupChannelCount = function (e, n) {
        if ("function" == typeof e && 1 === arguments.length && (n = e, e = V.memberState.ALL), e !== V.memberState.ALL && e !== V.memberState.JOINED && e !== V.memberState.INVITED && e !== V.memberState.INVITED_BY_FRIEND && e !== V.memberState.INVITED_BY_NON_FRIEND) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().getGroupChannelCount(e, function (e, t) {
          if (t) return void U(null, t, n);
          var r = parseInt(e.group_channel_count);
          U(r, null, n);
        });
      }, this.getTotalUnreadMessageCount = function (e, n) {
        "function" == typeof e && (n = e, e = null);
        var t = e,
            r = V.superChannelFilter.ALL;
        if (e instanceof G && (t = e.channelCustomTypesFilter, r = e.superChannelFilter), null !== t && void 0 !== t && !Array.isArray(t) || "string" != typeof r && [V.superChannelFilter.ALL, V.superChannelFilter.SUPER, V.superChannelFilter.NON_SUPER].indexOf(r) < 0) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().getTotalUnreadMessageCount(t, r, function (e, t) {
          if (t) return void U(null, t, n);
          var r = parseInt(e.unread_count);
          U(r, null, n);
        });
      }, this.getTotalUnreadChannelCount = function (e) {
        se.getInstance().getTotalUnreadChannelCount(function (n, t) {
          if (t) return void U(null, t, e);
          var r = parseInt(n.unread_count);
          U(r, null, e);
        });
      }, this.getUnreadItemCount = function (e, n) {
        if (!Array.isArray(e) || e.length < 1) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);

        for (var t = 0; t < e.length; t++) {
          if ([V.UnreadItemKey.SUPER_UNREAD_MESSAGE_COUNT, V.UnreadItemKey.NONSUPER_UNREAD_MESSAGE_COUNT, V.UnreadItemKey.GROUP_CHANNEL_UNREAD_MESSAGE_COUNT, V.UnreadItemKey.SUPER_UNREAD_MENTION_COUNT, V.UnreadItemKey.NONSUPER_UNREAD_MENTION_COUNT, V.UnreadItemKey.GROUP_CHANNEL_UNREAD_MENTION_COUNT, V.UnreadItemKey.SUPER_INVITATION_COUNT, V.UnreadItemKey.NONSUPER_INVITATION_COUNT, V.UnreadItemKey.GROUP_CHANNEL_INVITATION_COUNT].indexOf(e[t]) < 0) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        }

        var r = e.filter(function (n, t) {
          return e.indexOf(n) === t;
        });
        se.getInstance().getUnreadItemCount(r, function (e, t) {
          if (t) return void U(null, t, n);
          U(e, null, n);
        });
      };

      var I = {
        all: 0,
        custom_types: {},
        ts: 0
      },
          E = function E(e) {
        if (e.hasOwnProperty("unread_cnt") && "object" == typeof e.unread_cnt) {
          var n = e.unread_cnt.ts;

          if ("number" == typeof n && n > I.ts) {
            if (I.all = e.unread_cnt.all >= 0 ? e.unread_cnt.all : 0, e.unread_cnt.custom_types) for (var t in e.unread_cnt.custom_types) {
              I.custom_types[t] = e.unread_cnt.custom_types[t];
            }
            I.ts = n;
          }
        }
      };

      this.getSubscribedTotalUnreadMessageCount = function () {
        return I.all >= 0 ? I.all : 0;
      }, this.getSubscribedCustomTypeTotalUnreadMessageCount = function () {
        if (Object.keys(I.custom_types).length > 0) {
          var e = 0;

          for (var n in I.custom_types) {
            e += I.custom_types[n];
          }

          return e;
        }

        return 0;
      }, this.getSubscribedCustomTypeUnreadMessageCount = function (e) {
        return e && "string" == typeof e && I.custom_types.hasOwnProperty(e) ? I.custom_types[e] : 0;
      }, this.setPushTemplate = function (e, n) {
        if (!e || e !== this.PUSH_TEMPLATE_DEFAULT && e !== this.PUSH_TEMPLATE_ALTERNATIVE) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().setPushTemplate(e, function (e, t) {
          if (t) return void U(null, t, n);
          var r = e.name.toString();
          U(r, null, n);
        });
      }, this.getPushTemplate = function (e) {
        se.getInstance().getPushTemplate(function (n, t) {
          if (t) return void U(null, t, e);
          var r = n.name.toString();
          U(r, null, e);
        });
      }, this.setChannelInvitationPreference = function (e, n) {
        "boolean" != typeof e && U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n), se.getInstance().setChannelInvitationPreference(e, function (e, t) {
          if (t) return void U(null, t, n);
          U({
            autoAccept: e.auto_accept
          }, null, n);
        });
      }, this.getChannelInvitationPreference = function (e) {
        se.getInstance().getChannelInvitationPreference(function (n, t) {
          if (t) return void U(null, t, e);
          U({
            autoAccept: n.auto_accept
          }, null, e);
        });
      }, this.connect = function () {
        d && d.start();
        var e = Array.prototype.slice.call(arguments),
            n = null,
            i = null,
            a = null;

        switch ("function" == typeof e.slice(-1)[0] && (a = e.pop()), e.length) {
          case 1:
            n = e[0];
            break;

          case 2:
            n = e[0], i = e[1];
            break;

          case 3:
            n = e[0], this.customApiHost = e[1], this.customWsHost = e[2];
            break;

          case 4:
            n = e[0], i = e[1], this.customApiHost = e[2], this.customWsHost = e[3];
            break;

          default:
            r && t.log("sb.connect args length error: ", arguments);
        }

        n && 0 !== n.length ? (Ie.getInstance().connecting = !0, Ie.getInstance().reconnecting = !1, Ie.getInstance().isReconnectingOnError = !1, Ie.getInstance().reconnectTimer && (clearTimeout(Ie.getInstance().reconnectTimer), Ie.getInstance().reconnectTimer = null, Ie.getInstance().onReconnectTimerCancel = null), Ie.getInstance().getConnectionState() === this.ConnectionState.OPEN && Ie.getInstance().getCurrentUserId() === n ? (Ie.getInstance().connecting = !1, U(Ie.getInstance().currentUser, null, a)) : (Ie.getInstance().connectionCallback.push(a), 1 === Ie.getInstance().connectionCallback.length && (D(!0, null, null), W(n, i)))) : U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), a);
      };
      var A = !1,
          C = !1,
          L = !0;
      this.setBackgroundState = function () {
        if (!A && L) if (A = !0, this.getConnectionState() !== this.ConnectionState.CLOSED) {
          C = !0;
          var e = new g("Websocket connection failed.", N.WEBSOCKET_CONNECTION_FAILED);
          D(!1, null, e);
        } else C = !1;
      }, this.setForegroundState = function () {
        A && L && (A = !1, C && this.currentUser && (P = 0, z(this.getCurrentUserId(), !0)));
      }, this.disableStateChange = function () {
        L = !1;
      }, this.enableStateChange = function () {
        L = !0;
      }, this.disconnect = function (e) {
        d && d.stop();
        var n = new g("Connection has been canceled.", N.CONNECTION_CANCELED);
        D(!0, e, n);
      }, this.reconnect = function () {
        if (!se.getInstance().sessionKey || !this.currentUser) return !1;
        var e = !0;
        P > 0 && (e = !1);
        var n = new g("Connection has been canceled.", N.CONNECTION_CANCELED);
        return D(!1, null, n), P = 0, z(this.getCurrentUserId(), e), !0;
      };

      var D = function D(e, n, t) {
        var r = Ie.getInstance();
        r.loginTimer && (clearTimeout(r.loginTimer), r.onLoginTimerCancel && (r.onLoginTimerCancel(), r.onLoginTimerCancel = null), r.loginTimer = null), r.reconnectTimer && (clearTimeout(r.reconnectTimer), r.onReconnectTimerCancel && (r.onReconnectTimerCancel(), r.onReconnectTimerCancel = null), r.reconnectTimer = null), r.wsClient && (P = 0, r.wsClient.disconnect(!0), r.wsClient = null), function () {
          if (e) {
            k.clearEnteredChannels(), k.clearCache(), V.clearCache(), r.globalTimer && (clearTimeout(r.globalTimer), r.globalTimer = null);

            for (var i in r._ackStateMap) {
              clearTimeout(r._ackStateMap[i].timer);
            }

            r._ackStateMap = {}, r.currentUser = null, se.getInstance().sessionKey = null, se.getInstance().ekey = null;
          }

          t && (l(null, t), r.connecting = !1, r.reconnecting = !1, r.isReconnectingOnError = !1), U(null, null, n);
        }();
      },
          z = function z(e, n) {
        if (Ie.getInstance().reconnecting = !0, Ie.getInstance().reconnectTimer) r && t.log("still reconnecting");else {
          if ((P += 1) <= 1) {
            if (n) for (var i in Ie.getInstance().connectionHandlers) {
              var a = Ie.getInstance().connectionHandlers[i];
              a.onReconnectStarted(i);
            }
            O = 0;
          } else O = 3e3 * Math.pow(2, P - 2);

          if (!e || !se.getInstance().sessionKey || P >= 6) {
            var s = new g("Websocket connection failed.", N.WEBSOCKET_CONNECTION_FAILED);
            D(!1, null, s), P = 0;

            for (var i in Ie.getInstance().connectionHandlers) {
              var a = Ie.getInstance().connectionHandlers[i];
              a.onReconnectFailed(i);
            }

            return Ie.getInstance().connecting = !1, Ie.getInstance().reconnecting = !1, Ie.getInstance().isReconnectingOnError = !1, void Ie.getInstance().ConnectionManager.errorAllReadyHandler();
          }

          Ie.getInstance().onReconnectTimerCancel = function () {
            P = 0;
          }, Ie.getInstance().reconnectTimer = setTimeout(function () {
            Ie.getInstance().reconnectTimer = null, Ie.getInstance().onReconnectTimerCancel = null, Ie.getInstance().wsClient && Ie.getInstance().wsClient.disconnect(!0);
            var n = new ae.WSClientHandler();
            Ie.getInstance().wsClient = new ae(n), Ie.getInstance().loginHandler = function (e) {
              P = 0, Ie.getInstance().connecting = !1, Ie.getInstance().reconnecting = !1, Ie.getInstance().isReconnectingOnError = !1;

              for (var n in Ie.getInstance().connectionHandlers) {
                Ie.getInstance().connectionHandlers[n].onReconnectSucceeded(n);
              }

              if (Ie.getInstance().ConnectionManager.processAllReadyHandler(null), Ie.getInstance().isReconnectingOnError) for (var t in Ie.getInstance().ConnectionManager.networkHandlers) {
                Ie.getInstance().ConnectionManager.networkHandlers[t].onReconnected();
              }
              var r = [];

              for (var t in k.enteredChannels) {
                r.push(t);
              }

              for (var n = 0; n < r.length; n++) {
                var i = r[n],
                    a = k.enteredChannels[i];
                !function (e) {
                  e.enter(function (e, n) {
                    n && (delete k.enteredChannels[i], Ie.getInstance()._deleteFileQueue(i));
                  });
                }(a);
              }
            }, n.onOpen = function () {
              r && t.log("reconnectWS onOpen"), Ie.getInstance().loginTimer = setTimeout(function () {
                r && t.log("reconnectWS loginTimer timedout"), Ie.getInstance().loginTimer = null, z(e, !0);
              }, 1e4), Ie.getInstance().onLoginTimerCancel = null, Ie.getInstance().reconnecting = !1;
            }, n.onMessage = function (e) {
              h(e);
            }, n.onError = function () {
              r && t.log("reconnectWS onError"), Ie.getInstance().isReconnectingOnError = !0, Ie.getInstance().ConnectionManager.errorAllReadyHandler(), z(e, !0);
            }, n.onClose = function () {
              r && t.log("reconnectWS onClose"), Ie.getInstance().reconnecting = !1;
            };
            var i = Ie.getInstance().getCurrentApiHost();
            se.getInstance().checkRouting(function (n, t) {
              if (t) return void z(e, !0);
              i !== n.API_HOST && R.get(n.API_HOST, {}, function () {}), Ie.getInstance().wsClient.connect(e, null, n.WS_HOST);
            });
          }, O);
        }
      },
          W = function W(e, n) {
        var i = new ae.WSClientHandler();
        Ie.getInstance().wsClient = new ae(i), i.onMessage = function (e) {
          h(e);
        }, Ie.getInstance().loginHandler = function (e, n) {
          if (Ie.getInstance().connecting = !1, n) D(!0, null, n);else {
            clearTimeout(Ie.getInstance().globalTimer);

            var t = function t() {
              if (V.cachedChannels) for (var e in V.cachedChannels) {
                var n = V.cachedChannels[e];
                if (n.invalidateTypingStatus()) for (var r in Ie.getInstance().channelHandlers) {
                  var i = Ie.getInstance().channelHandlers[r];
                  i.onTypingStatusUpdated(n);
                }
              }
              Ie.getInstance().globalTimer = setTimeout(function () {
                t();
              }, 1e3);
            };

            t(), l(e, null), Ie.getInstance().connecting = !1, Ie.getInstance().reconnecting = !1, Ie.getInstance().ConnectionManager.processAllReadyHandler(null);
          }
        }, i.onOpen = function (e) {
          Ie.getInstance().loginTimer = setTimeout(function () {
            Ie.getInstance().loginTimer = null, Ie.getInstance().onLoginTimerCancel = null, Ie.getInstance().disconnect(null), l(null, new g("Connection timeout.", N.LOGIN_TIMEOUT));
          }, 1e4), Ie.getInstance().onLoginTimerCancel = function () {
            l(null, new g("Connection has been canceled.", N.REQUEST_FAILED));
          }, Ie.getInstance().connecting = !1;
        }, i.onError = function (n) {
          r && t.log("WSClientHandler.onError", n), se.getInstance().sessionKey ? (Ie.getInstance().isReconnectingOnError = !0, Ie.getInstance().ConnectionManager.errorAllReadyHandler(), z(e, !0)) : l(null, new g("Websocket connection failed.", N.WEBSOCKET_CONNECTION_FAILED)), Ie.getInstance().connecting = !1;
        }, i.onClose = function (e) {
          r && t.log("WSClientHandler.onClose"), Ie.getInstance().connecting = !1;
        }, se.getInstance().checkRouting(function (t, r) {
          if (r) return l(null, new g("Connection routing failed.", N.REQUEST_FAILED)), void (Ie.getInstance().connecting = !1);
          R.get(t.API_HOST, {}, function () {}), Ie.getInstance().wsClient.connect(e, n, t.WS_HOST);
        });
      };

      this.sendCommand = function (e, n) {
        Ie.getInstance().ConnectionManager.ready(function (t, r) {
          if (r) return void (n && n(null, r));
          if (null == Ie.getInstance().wsClient || Ie.getInstance().wsClient.getConnectionState() !== Ie.getInstance().ConnectionState.OPEN || Ie.getInstance().getConnectionState() !== Ie.getInstance().ConnectionState.OPEN) return void (n && n(null, new g("Connection is not valid. Please reconnect.", N.WEBSOCKET_CONNECTION_CLOSED)));

          if (e.isAckRequired()) {
            var i = e.requestId,
                a = {
              handler: n,
              timer: setTimeout(function () {
                n(null, new g("Command received no ack.", N.ACK_TIMEOUT)), delete Ie.getInstance()._ackStateMap[i];
              }, 1e4)
            };
            Ie.getInstance()._ackStateMap[i] = a, Ie.getInstance().wsClient.send(e, function (e, t) {
              if (t) return clearTimeout(a.timer), void n(null, t);
            });
          } else Ie.getInstance().wsClient.send(e, n);
        });
      }, this.markAsReadAll = function (e) {
        var n = new Date().getTime();
        if (n - V.markAsReadAllLastSentAt < 1e3) return void U(null, new g("MarkAsRead rate limit exceeded.", N.MARK_AS_READ_RATE_LIMIT_EXCEEDED), e);
        V.markAsReadAllLastSentAt = n, se.getInstance().groupChannelMarkAsReadAll(null, function (t, r) {
          if (r) return void U(null, r, e);

          for (var i in V.cachedChannels) {
            V.cachedChannels[i].updateReadReceipt(Ie.getInstance().getCurrentUserId(), n), y(V.cachedChannels[i], 0, 0);
          }

          U(null, null, e);
        });
      }, this.markAsReadWithChannelUrls = function (e, n) {
        if (!Array.isArray(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        var t = new Date().getTime();
        if (t - V.markAsReadAllLastSentAt < 1e3) return void U(null, new g("MarkAsRead rate limit exceeded.", N.MARK_AS_READ_RATE_LIMIT_EXCEEDED), n);
        V.markAsReadAllLastSentAt = t, se.getInstance().groupChannelMarkAsReadAll(e, function (r, i) {
          if (i) return void U(null, i, n);
          e.forEach(function (e) {
            var n = V.cachedChannels[e];
            n && (y(n, 0, 0), n.updateReadReceipt(Ie.getInstance().getCurrentUserId(), t), V.cachedChannels[e] = n);
          }), U(null, null, n);
        });
      }, this.updateCurrentUserInfoWithProfileImage = function (e, n, t) {
        var r = this;
        if ("string" != typeof e && null !== e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);

        if (n) {
          if ("object" != typeof n || Array.isArray(n) || Object.keys(n).length < 1) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
          se.getInstance().updateCurrentUserInfoWithFile(e, n, function (i, a) {
            if (a) return void U(null, a, t);
            r.currentUser && (e && (r.currentUser.nickname = e), n && (r.currentUser.profileUrl = i.profile_url)), U(r.currentUser, null, t);
          });
        } else r.updateCurrentUserInfo(e, null, t);
      }, this.updateCurrentUserInfo = function (e, n, t) {
        var r = this;
        if ("string" != typeof e && null !== e || "string" != typeof n && null !== n) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), t);
        se.getInstance().updateUserInfo(e, n, function (i, a) {
          if (a) return void U(null, a, t);
          r.currentUser && (e && (r.currentUser.nickname = e), n && (r.currentUser.profileUrl = n)), U(r.currentUser, null, t);
        });
      }, this.getPendingGCMToken = function () {
        return this.GCMPushToken;
      }, this.getPendingAPNSToken = function () {
        return this.APNSPushToken;
      }, this.registerGCMPushTokenForCurrentUser = function (e, n) {
        var t = this;
        return e && "string" == typeof e ? this.currentUser ? void se.getInstance().registerGCMPushToken(e, function (e, r) {
          if (r) return void U(t.pushTokenRegistrationState.ERROR, r, n);
          t.GCMPushToken = "", U(t.pushTokenRegistrationState.SUCCESS, null, n);
        }) : (t.GCMPushToken = e, void U(t.pushTokenRegistrationState.PENDING, null, n)) : void U(t.pushTokenRegistrationState.ERROR, new g("Invalid token", N.INVALID_PARAMETER), n);
      }, this.unregisterGCMPushTokenForCurrentUser = function (e, n) {
        if (!e || "string" != typeof e) return void U(null, new g("Invalid token", N.INVALID_PARAMETER), n);
        se.getInstance().unregisterGCMPushToken(e, function (e, t) {
          if (t) return void U(null, t, n);
          U(null, null, n);
        });
      }, this.unregisterGCMPushTokenAllForCurrentUser = function (e) {
        se.getInstance().unregisterGCMPushTokenAll(function (n, t) {
          if (t) return void U(null, t, e);
          U(null, null, e);
        });
      }, this.registerAPNSPushTokenForCurrentUser = function (e, n) {
        var t = this;
        return e && "string" == typeof e ? this.currentUser ? void se.getInstance().registerAPNSPushToken(e, function (e, r) {
          if (r) return void U(t.pushTokenRegistrationState.ERROR, r, n);
          t.APNSPushToken = "", U(t.pushTokenRegistrationState.SUCCESS, null, n);
        }) : (t.APNSPushToken = e, void U(t.pushTokenRegistrationState.PENDING, null, n)) : void U(t.pushTokenRegistrationState.ERROR, new g("Invalid token", N.INVALID_PARAMETER), n);
      }, this.unregisterAPNSPushTokenForCurrentUser = function (e, n) {
        if (!e || "string" != typeof e) return void U(null, new g("Invalid token", N.INVALID_PARAMETER), n);
        se.getInstance().unregisterAPNSPushToken(e, function (e, t) {
          if (t) return void U(null, t, n);
          U(null, null, n);
        });
      }, this.unregisterAPNSPushTokenAllForCurrentUser = function (e) {
        se.getInstance().unregisterAPNSPushTokenAll(function (n, t) {
          if (t) return void U(null, t, e);
          U(null, null, e);
        });
      }, this.unregisterPushTokenAllForCurrentUser = function (e) {
        se.getInstance().unregisterPushTokenAll(function (n, t) {
          if (t) return void U(null, t, e);
          U(null, null, e);
        });
      }, this.setDoNotDisturb = function (e, n, t, r, i, a, s) {
        if (n < 0 || n > 23 || t < 0 || t > 59 || r < 0 || r > 23 || i < 0 || i > 59) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), s);
        se.getInstance().setDoNotDisturb(e, n, t, r, i, a, function (e, n) {
          if (n) return void U(null, n, s);
          var t = {
            doNotDisturbOn: e.do_not_disturb,
            startHour: e.start_hour,
            startMin: e.start_min,
            endHour: e.end_hour,
            endMin: e.end_min,
            timezone: e.timezone
          };
          U(t, null, s);
        });
      }, this.getDoNotDisturb = function (e) {
        se.getInstance().getDoNotDisturb(function (n, t) {
          if (t) return void U(null, t, e);
          var r = {
            doNotDisturbOn: n.do_not_disturb,
            startHour: n.start_hour,
            startMin: n.start_min,
            endHour: n.end_hour,
            endMin: n.end_min,
            timezone: n.timezone
          };
          U(r, null, e);
        });
      }, this.blockUser = function (e, n) {
        if ("object" != typeof e) return void U(null, new g("You have to pass user object.", N.INVALID_PARAMETER), n);
        this.blockUserWithUserId(e.userId, n);
      }, this.blockUserWithUserId = function (e, n) {
        if (this.getCurrentUserId() === e) return void U(null, new g("You cannot block yourself.", N.INVALID_PARAMETER), n);
        se.getInstance().blockUser(e, function (e, t) {
          if (t) return void U(null, t, n);
          U(new q(e), null, n);
        });
      }, this.unblockUser = function (e, n) {
        if ("object" != typeof e) return void U(null, new g("You have to pass user object.", N.INVALID_PARAMETER), n);
        this.unblockUserWithUserId(e.userId, n);
      }, this.unblockUserWithUserId = function (e, n) {
        if (this.getCurrentUserId() === e) return void U(null, new g("You cannot unblock yourself.", N.INVALID_PARAMETER), n);
        se.getInstance().unblockUser(e, function (e, t) {
          if (t) return void U(null, t, n);
          U(null, null, n);
        });
      }, this.addFriends = function (e, n) {
        if (!Array.isArray(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().addFriends(e, function (e, t) {
          if (t) return void U(null, t, n);
          var r = e.users.map(function (e) {
            return new q(e);
          });
          U(r, null, n);
        });
      }, this.deleteFriends = function (e, n) {
        if (!Array.isArray(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().deleteFriends(e, function (e, t) {
          if (t) return void U(null, t, n);
          U(e, null, n);
        });
      }, this.deleteFriend = function (e, n) {
        if ("string" != typeof e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        this.deleteFriends([e], n);
      }, this.uploadFriendDiscoveries = function (e, n) {
        var t = !0;

        for (var r in e) {
          if (!e[r].hasOwnProperty("friendDiscoveryKey")) {
            t = !1, U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
            break;
          }
        }

        if (t) {
          se.getInstance().uploadFriendDiscoveries(e, function (e, t) {
            if (t) return void U(null, t, n);
            U(e, null, n);
          });
        }
      }, this.deleteFriendDiscoveries = function (e, n) {
        if (!Array.isArray(e)) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        se.getInstance().deleteFriendDiscoveries(e, function (e, t) {
          if (t) return void U(null, t, n);
          U(e, null, n);
        });
      }, this.deleteFriendDiscovery = function (e, n) {
        if ("string" != typeof e) return void U(null, new g("Invalid parameter.", N.INVALID_PARAMETER), n);
        this.deleteFriendDiscoveries([e], n);
      }, this.getFriendChangeLogsByToken = function (e, n) {
        if ("function" == typeof e && (n = e, e = null), "function" != typeof n) return null;
        se.getInstance().getFriendChangeLogsByToken(e, function (e, t) {
          if (t) return void U(null, t, n);
          var r = e.updated.map(function (e) {
            return new q(q.build(e.user_id, e.nickname, e.profile_url, e.is_online, e.last_seen_at, e.metadata, e.is_active, e.friend_discovery_key, e.friend_name));
          }),
              i = e.deleted,
              a = e.has_more,
              s = e.next;
          U({
            updatedUsers: r,
            deletedUserIds: i,
            hasMore: a,
            token: s
          }, null, n);
        });
      }, this.createFriendListQuery = function () {
        return new le();
      };
    },
        ge = null;

    return Ie.getInstance = function () {
      return null === ge ? null : ge;
    }, {
      SendBird: Ie
    };
  },
      C = null;

  return function () {
    var e = function e(_e2) {
      if (_e2.newInstance || !C) {
        var n = new N();
        C = new n.SendBird(_e2);
      } else if (C && _e2.appId !== C.getApplicationId() && C.getConnectionState() === C.ConnectionState.CLOSED) {
        var n = new N();
        C = new n.SendBird(_e2);
      }

      return C;
    };

    return e.getInstance = function () {
      return null === C ? null : C;
    }, e.version = "3.0.85", {
      SendBird: e
    };
  }().SendBird;
});